/* eslint-disable no-param-reassign */
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ChartDefaultcolors, ComboDisplayType, ComboAxisAlignment } from 'core/constants/visualizations';
import {
  IBuilderFilter,
  IBuilderMeasure,
  IDetails, IPaging, IReportConfig, ISetDimensionsBinningPayload, ISetGroupingPayload, IRawTemplate, ReportBuilderStatus,
  QuerySourceType, IHierarchy,
  IReportBuilderCustomColumns,
  IBuilder,
  ICustomHierarchy,
} from 'core/models/report-builder/report-builder';
import { UserContext } from 'core/constants/common';
import { APIRequestStatus } from 'core/constants/redux';
import {
  DynamicMeasureResponse, IColumn, IField, IFilterConfig,
  ICalendarDateApplicableFilter,
  ILinkedFilterInfo,
  ISetDimensionsEntityGroupingPayload,
  ISetEntityGroupingPayload,
  ISetMetaSelectorOptionsPayload,
} from 'core/models/report-response';
import {
  buildCustomMeasure, buildMeasureColumn, buildCustomDimension,
} from 'core/utils/report-expressions';
import {
  ColumnDataTypes,
  ColumnModes, DimensionMode, DimensionStatus, FieldEntitiesType, dynamicMeasureDefaultConfig,
  statusCodes,
} from 'core/constants/report';
import SieraResponse from 'core/models/siera-response';
import { ObjModel, ReportResponseModel } from 'core/models';
import {
  IAddCustomFilterPayload, IAddDynamicFilterPayload, ICreateNewQueryPayload, IDeleteCustomFilterPayload, IDeleteDynamicFilterPayload, IFilterFormValues,
  IFilterValueChangePayload, IFilterValueNestedQueryChangePayload, ILoadMoreFilterPayloadRequest, ISearchFilterPayloadRequest,
  ISwitchUserFieldFilterPayload, IUpdateCustomFilterPayload,
  IUpdateDataSourceJoinsPayload,
  IUpdateDataSourceNameSpacePayload,
  IUpdateQueryPayload,
} from 'core/models/report-builder/report-builder-redux';
import {
  FilterType, LinkedFilterOrigin, LinkedFilterSource, UserFilterPayloadType,
} from 'core/constants/filter';
import { v4 as uuidv4 } from 'uuid';
import FilterFetchUtility from 'core/utils/filter-fetch-utility';
import isEmpty from 'lodash/isEmpty';
import { IUpdateVisualizationPayload } from 'redux-v2/report/report-store.state';
import { IFilterResponse } from 'core/models/filter';
import { IVariables } from 'core/models/store';
import { IPanelDataResponse } from 'core/models/dashboard';
import {
  getDefaultEntity,
  getUniqIdentiferForDrilldownCols, isDimension, isDrilldownPossible, isMeasure, resolveFilterIDInCaseOfQueryIdPresent, setDrilldownEnableFlag, sortColumns,
  subQuerySortForMeasures,
  updateColumnsDisplayName,
} from 'core/utils/report.util';
import {
  applyValueToConstituent,
  buildCustomFiltersFromDefinitions,
  getFilterConfigFromTemplate, getMappedMetaFields,
  isLargeOptionSetFilter,
  isPaginatedFilter,
  reconstructCustomFilters,
  resolveSubBuilderCustomFilterDefaults,
} from 'core/utils/common.utility';
import {
  isValidArray, isValidArrayAndNotEmpty, isValidObjectAndNotEmpty, truncateUUID,
} from 'components/feature/Report/ReportSidebar/common/helpers';
import {
  cloneDeep, fromPairs, isString,
} from 'lodash';
import { defaultPageValue } from 'core/constants/pagination';
import { IDimension } from 'core/models/report-redux';
import { getEntityJoinIdForCustomMeasure } from 'components/feature/ReportBuilderV2/ReportBuilderDetail/DrilldownTabContent/drilldown.util';
import { ROOT_QUERY_KEY } from 'components/feature/Report/ReportSidebar/common/constants';
import { isListReport, SubQueryPanelType } from 'core/utils/report-builder.util';
import { getDataSourceNames } from 'components/feature/ReportBuilderV2/DataSource/data-source.util';
import { IBreadcrumbItem } from 'components/common/Breadcrumbs/breadcrumbs.component';
import { generateEntityStore } from 'core/utils/entity-grouping.util';
import initialReportBuilderState from './report-builder-store.initial-state';
import {
  getAdditionalDrilldownColumnsRequest,
  getDrilldownConfig,
  getDefaultDrilldownColumnsRequest,
  saveDrilldownColumnConfig,
  getDynamicDimensions, getReportBuilderDynamicFilters, getDynamicMeasures,
  getFieldsRequest, getReportRawConfig, getReportRenderConfig,
  saveReportConfig, getReportBuilderFiltersLoad,
  getDataSourcesList,
  getSubQueryFiltersLoad,
  getReportBuilderDynamicFiltersForNamespaces,
  getDynamicDimensionsForNamespaces,
  getDynamicMeasuresForNamespaces,
  getFieldsRequestForNamespaces,
  saveNestedJoinsConfig,
  getAdditionalListReportColumnsRequest,
  getAdditionalListReportColumnsRequestForNamespaces,
  getDataSourcesFieldList,
  getAllReportsForLinkedInsights,
  getReportConfigForLinkedInsights,
} from './report-builder-store.requests';
import {
  DrilldownConfigMapping,
  DrilldownFieldUpdationsAction,
  ExpressionContext,
  IAddMeasurePayload,
  ICustomExpression,
  IDataSourceApiResponse,
  IMoveMeasurePayload,
  IRemoveMeasurePayload,
  IReportBuilderState, IFilterBuilder, ISetMeasurePayload, ISortColumnPayload, ISortDrilldownColumnPayload, MeasureListWithJoinId,
  ReportBuilderActions, ReportBuilderSaveStatus,
  IResetReportConfigPayload,
  IQueryInfo,
  SaveSubQueryPayload,
  ReportType,
  ISetDimensionPayload,
  IRule,
  ILinkedConfig,
  ISaveLinkedInsightPayload,
  IPreviewDataError,
} from './report-builder-store.state';
import {
  getAppliedDimensions, getDrilldownMapping, getInitialDrilldownConfigInfo,
  getStateOnMoveColumns,
  getStateOnUpdateDrilldownColumn, getUpdatedDrilldownColConfig,
  sortDrilldownColumns,
  groupByJoinIdAndEntity,
  getUpdatedFetchdrilldownColumnsRes,
  handleCustExpUpdateForDrilldownMapper,
  getAppliedDimensionsOnSuccess, getAppliedFilterFromTemplate, getCombinedReportConfig, getExpressionStoreFromConfig,
  getIsFilterFormDisable, getIsReportBuilderSaveFormDisable, getMeasureColumns, getStateOnAddDynamicFilter, getStateOnAddMeasure,
  getStateOnBinningChange, getStateOnEntityGroupingChange, getStateOnMoveMeasure, getStateOnRemoveMeasure, getStateOnSetGrouping, getStateOnSwitchUserFilter, getStateOnUpdateMeasure,
  getUpdatedPayloadAfterInitialSave, getUpdatedReportFilterConfig, reorderAppliedDimensions, resetFilterOnFailure, selectedReportTemplate,
  getUpdatedDataSourceResponse,
  convertDrilldownMappingIntoIdMapping,
  getStateOnSetGroupingForSubQuery,
  getStateOnBinningChangeForSubQuery,
  getStateOnAddMeasureForSubQuery,
  getStateOnRemoveMeasureForSubQuery,
  getStateOnMoveMeasureForSubQuery,
  getStateOnUpdateMeasureForSubQuery,
  getStateOnUpdateDimensionForSubQuery,
  getStateOnSaveSubQuery,
  prepareUICompatibleConfig,
  resetSelectedQueryToParent,
  resetDataSourceOfLinkedQueries,
  populateSubQueryDetailsFromConfig,
  getStateOnAddQueryDynamicFilter,
  createNewQuery,
  getStateOnQueryDeleteDynamicFilter,
  deleteSubQueryFn,
  updateSelectedFn,
  findAndUpdateAssociatedUserFilters,
  getStateOnApplyEntityGrouping,
  getStateOnSetEntityGroupingOptions,
  getMeasureColumnsFromSubqueryBuilder,
  getUpdatedDataSourceFieldsResponse,
  getStateOnSwitchUserFilterInSubQueryBuilder,
  getStateOnUpdateDimension,
  getStateOnUpdateCustomHierarchies,
  getAllDependentFilterIds,
  resetFilterBuilderInStoreDueToUserContextChange,
  updateSalesGroupAndUserFiltersInPayloadDueToUserContextChange,
  updateQueryFilterDefaultValueInSubBuilderPayload,
  resolveAndLinkFilter,
  filterBuilderToFilterConfig,
} from './report-builder-store.utils';
import { fieldSelectors } from './report-builder-store.selectors';
import { IGlobalState } from '../../core/models/redux';
import { IReportData, SourceTypes } from '../report-listing/report-listing.state';

// Removes a set of source filter IDs from LinkingConfig.Filters on every linked-insight
// entry and mirrors the result into reportBuilderSavePayload. Called when filters are
// absorbed into a custom filter (source-side mapping becomes stale) or fully removed
// from the report due to custom-filter lifecycle events. Safe to call with an empty set
// or with IDs that don't appear in any mapping — preserves state identity in those cases
// so downstream selectors don't see a spurious change.
const removeFilterIdsFromLinkedReportsConfig = (
  state: IReportBuilderState,
  filterIds: string[],
): void => {
  if (!filterIds?.length) return;
  const idSet = new Set(filterIds);

  let anyChanged = false;
  const updated = state.updatedReportBuilderInfo.linkedReportsConfig.map((cfg) => {
    const current = cfg.LinkingConfig?.Filters || {};
    const keys = Object.keys(current);
    if (!keys.some((k) => idSet.has(k))) return cfg;
    anyChanged = true;
    const nextFilters: Record<string, string> = {};
    keys.forEach((k) => {
      if (!idSet.has(k)) nextFilters[k] = current[k];
    });
    return { ...cfg, LinkingConfig: { ...cfg.LinkingConfig, Filters: nextFilters } };
  });
  if (!anyChanged) return;

  state.updatedReportBuilderInfo.linkedReportsConfig = updated;
  state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.LinkedReportsConfig = updated;
};

const withDescription = <T extends { Props?: any }>(col: T, description?: string): T => ({
  ...col,
  Props: { ...col.Props, Description: description },
});

// Persist the calendar-date (RangeFill) toggle for each applicable constituent onto its linked
// applied dimension. Shared by ADD_CUSTOM_FILTER and UPDATE_CUSTOM_FILTER. Handled for
// AppliedFilter-origin constituents from both the main report (Source = MainReport) and queries
// (Source = SubBuilder).
const applyCalendarDateRangeFillOnConstituents = (
  state: IReportBuilderState,
  resolvedFilters: ILinkedFilterInfo[],
  calendarDateApplicableFilters?: ICalendarDateApplicableFilter[],
): void => {
  const mainReportAppliedDimensions = state.updatedReportBuilderInfo.appliedDimensions || [];
  (calendarDateApplicableFilters || []).forEach((calendarFilter) => {
    const linkedFilter = resolvedFilters.find(
      (lf) => resolveFilterIDInCaseOfQueryIdPresent(lf.FilterId, lf.QueryId) === calendarFilter.FilterId
        && lf.QueryId === calendarFilter.QueryId,
    );
    // Only AppliedFilter-origin constituents carry a linked dimension whose RangeFill we own.
    if (linkedFilter?.Origin !== LinkedFilterOrigin.AppliedFilter) return;
    const rangeFillValue = calendarFilter.calendarDateEnabled ? 1 : 0;
    const linkedDimensionId = linkedFilter.LinkedDimensionId
      || state.filterBuilder.filterConfig.find((f) => f.ID === linkedFilter.FilterId)?.LinkedDimensionId;
    if (!linkedDimensionId) return;

    if (linkedFilter.Source === LinkedFilterSource.MainReport) {
      // Main-report dimension: report-redux IDimension shape (RangeFill under Props.Dimension).
      const linkedDimensionIndex = mainReportAppliedDimensions.findIndex((item) => item.Id === linkedDimensionId);
      if (linkedDimensionIndex === -1) return;
      mainReportAppliedDimensions[linkedDimensionIndex] = {
        ...mainReportAppliedDimensions[linkedDimensionIndex],
        RangeFill: rangeFillValue,
        Props: {
          ...mainReportAppliedDimensions[linkedDimensionIndex]?.Props,
          Dimension: {
            ...mainReportAppliedDimensions[linkedDimensionIndex]?.Props?.Dimension,
            RangeFill: rangeFillValue,
          },
        },
      };
    } else if (linkedFilter.Source === LinkedFilterSource.SubBuilder && linkedFilter.QueryId) {
      // Query dimension: IBuilderDimension shape (top-level RangeFill), sourced from the query's
      // QueryPayload.Select.Dimensions. Strip the LinkedDimensionId's query suffix before matching
      // the base dimension Id (mirrors hasQueryLinkedAppliedDimension).
      const baseDimensionId = truncateUUID(linkedDimensionId);
      // Report-redux IDimension update (RangeFill under Props.Dimension, plus top-level). The query
      // report's own calendar toggle reads these (SelectedQueryData / QueryDataInfo.AppliedDimensions),
      // NOT the IBuilderDimension copies. The applied-dimension Id may be the base id or the
      // query-suffixed LinkedDimensionId — match either.
      const updateRangeFillInAppliedDimensions = (appliedDimensions: IDimension[]) => {
        const idx = (appliedDimensions || []).findIndex(
          (dim) => dim.Id === linkedDimensionId || dim.Id === baseDimensionId,
        );
        if (idx === -1) return;
        appliedDimensions[idx] = {
          ...appliedDimensions[idx],
          RangeFill: rangeFillValue,
          Props: {
            ...appliedDimensions[idx]?.Props,
            Dimension: {
              ...appliedDimensions[idx]?.Props?.Dimension,
              RangeFill: rangeFillValue,
            },
          },
        };
      };
      // Update a query list's copies for the owning query — both shapes:
      //  - QueryPayload.Select.Dimensions[i]              → IBuilderDimension (top-level RangeFill)
      //  - QueryDataInfo.updatedInfo.AppliedDimensions[i] → report-redux IDimension (Props.Dimension)
      // Applied to BOTH DynamicQueryList AND StaticQueryList: DELETE_SELECTED_QUERY (query cancel →
      // back to root) restores DynamicQueryList = StaticQueryList directly, bypassing the
      // selectedTemplate rebuild, so a stale StaticQueryList reverts both toggles.
      const updateRangeFillInQueryList = (queryList: IQueryInfo[]) => {
        const q = (queryList || []).find((item) => item.Id === linkedFilter.QueryId);
        if (!q) return;
        const payloadDimensions = q.QueryPayload?.Select?.Dimensions || [];
        const payloadDimIndex = payloadDimensions.findIndex((dim) => dim.Id === baseDimensionId);
        if (payloadDimIndex !== -1) {
          payloadDimensions[payloadDimIndex] = {
            ...payloadDimensions[payloadDimIndex],
            RangeFill: rangeFillValue,
          };
        }
        updateRangeFillInAppliedDimensions(q.QueryDataInfo?.updatedInfo?.AppliedDimensions);
      };
      updateRangeFillInQueryList(state.reportQueryBuilder.DynamicQueryList);
      updateRangeFillInQueryList(state.reportQueryBuilder.StaticQueryList);
      // Keep the currently-open query panel in sync so a live edit reflects immediately.
      if (state.reportQueryBuilder.SelectedQuery === linkedFilter.QueryId) {
        updateRangeFillInAppliedDimensions(state.reportQueryBuilder.SelectedQueryData?.updatedInfo?.AppliedDimensions);
      }
      // The preview payload builder (getSaveReportConfigPayload) sources SubBuilder
      // Select.Dimensions from reportBuilderSavePayload.SubBuilders (and the edit flow from
      // rawReportConfig.SubBuilders), and RESET_QUERY_BUILDER_STATE rebuilds the query lists from
      // selectedTemplate.ReportConfig — mirror the RangeFill onto all three so no rebuild/preview
      // path re-introduces the stale value.
      const updateRangeFillInSubBuilderList = (subBuilderList: IBuilder[]) => {
        (subBuilderList || []).forEach((builder) => {
          if (builder.QueryId !== linkedFilter.QueryId) return;
          const dimIndex = (builder.Select?.Dimensions || []).findIndex((dim) => dim.Id === baseDimensionId);
          if (dimIndex === -1) return;
          builder.Select.Dimensions[dimIndex] = {
            ...builder.Select.Dimensions[dimIndex],
            RangeFill: rangeFillValue,
          };
        });
      };
      updateRangeFillInSubBuilderList(state.updatedReportBuilderInfo.reportBuilderSavePayload?.SubBuilders);
      updateRangeFillInSubBuilderList(state.reportEditInfo.rawReportConfig?.SubBuilders);
      updateRangeFillInSubBuilderList(state.updatedReportBuilderInfo.selectedTemplate?.ReportConfig?.SubBuilders);
    }
  });
};

// Propagates a custom filter wrapper's newly-applied value onto its SubBuilder (query)
// constituents. The wrapper is the only input surface on the main report — a query constituent
// has no applied entry of its own there (see ADD_CUSTOM_FILTER) — so every query-side copy of the
// constituent's value has to be written here or the query report keeps rendering the old value.
//
// Why this hangs off the main-report value-change handler and not
// HANDLE_MAIN_REPORT_QUERY_FILTER_VALUE_CHANGE: that action is dispatched only when
// selectedFilterConfig.QueryId is set (report-builder-store.requests.ts), and a wrapper created
// in-session by ADD_CUSTOM_FILTER / UPDATE_CUSTOM_FILTER is an explicit object literal with no
// QueryId — only wrappers rebuilt from a saved config by buildCustomFiltersFromDefinitions inherit
// one through the schema-constituent spread. That handler is also keyed entirely on the wrapper id,
// which never matches a constituent id (the query's own filterConfig holds expanded constituents,
// and FilterGroup ids are bare or `_<queryId>`-suffixed). The main-report handler runs for every
// value change unconditionally, so the fan-out is reachable for in-session and reloaded wrappers
// alike, and for wrappers whose constituents span more than one query.
//
// Write targets mirror the removal path in UPDATE_CUSTOM_FILTER (clearDefaultValueInSubBuilders):
//   QueryDataInfo.updatedInfo.filterBuilder.appliedFilters — what the query report renders
//     (updateSelectedFn hands this object to SelectedQueryData verbatim, without re-deriving)
//   SelectedQueryData.updatedInfo.filterBuilder.appliedFilters — the currently-open query panel
//   DynamicQueryList[q].QueryPayload.Filter — read by getSubBuilders on a root save
//   reportBuilderSavePayload.SubBuilders    — read by getSaveReportConfigPayload (preview / save)
//   reportEditInfo.rawReportConfig.SubBuilders — read by getQueryConfigFromRawConfig (edit flow)
//
// UserMultiSelect wrappers are deliberately skipped: a user constituent's value travels with
// UserDropdownSelectType / Status metadata that belongs to the query's FiltersMetadata and is not
// maintained here, so a value-only write would leave the query in an inconsistent state.
const applyCustomFilterValueToQueryConstituents = (
  state: IReportBuilderState,
  wrapper: IFilterConfig | undefined,
  filterValue: any,
): void => {
  if (!wrapper?.IsCustomFilter || !isValidArrayAndNotEmpty(wrapper?.LinkedFilters)) return;
  if (wrapper.Type === FilterType.UserMultiSelect) return;
  const { DynamicQueryList, SelectedQuery, SelectedQueryData } = state.reportQueryBuilder;
  const isWrapperLOS = isLargeOptionSetFilter(wrapper);
  const savePayloadSubBuilders = state.updatedReportBuilderInfo.reportBuilderSavePayload?.SubBuilders;

  wrapper.LinkedFilters.forEach((lf) => {
    if (lf.Source !== LinkedFilterSource.SubBuilder || !lf.QueryId) return;
    // Reuse the fetch-payload envelope rules so the constituent receives the value in its own
    // shape — notably an LOS wrapper feeding a non-LOS constituent, where the { Type, Values }
    // envelope has to collapse to a flat array.
    const { key, value } = applyValueToConstituent(
      lf,
      filterValue,
      wrapper,
      isWrapperLOS,
      state.filterBuilder.filterConfig,
      savePayloadSubBuilders,
    );
    // Sub-query appliedFilters and FilterGroup entries are keyed by the base id or the
    // query-suffixed id depending on which path created them — write whichever forms exist.
    const idsToWrite = key === lf.FilterId ? [lf.FilterId] : [lf.FilterId, key];

    const setInFilterBuilder = (filterBuilder: IFilterBuilder | undefined) => {
      if (!filterBuilder?.appliedFilters) return;
      idsToWrite.forEach((id) => {
        if (!filterBuilder.appliedFilters[id]) return;
        filterBuilder.appliedFilters[id] = {
          ...filterBuilder.appliedFilters[id],
          FilterResponse: value,
        };
      });
    };
    // updateQueryFilterDefaultValueInSubBuilderPayload re-serialises via getSerializedDefaultValue
    // using the matched FilterGroup's own IsLargeOptionSetField / Operator, so the already
    // constituent-adapted `value` is the correct input here.
    const setInBuilderFilter = (builderFilter: IBuilderFilter | undefined) => {
      if (!builderFilter) return;
      idsToWrite.forEach((id) => updateQueryFilterDefaultValueInSubBuilderPayload(
        builderFilter,
        id,
        value,
        wrapper.Type,
      ));
    };
    const setInSubBuilders = (subBuilderList: IBuilder[] | undefined) => {
      (subBuilderList || []).forEach((builder) => {
        if (builder.QueryId !== lf.QueryId) return;
        setInBuilderFilter(builder.Filter);
      });
    };

    (DynamicQueryList || []).forEach((query) => {
      if (query.Id !== lf.QueryId) return;
      setInFilterBuilder(query.QueryDataInfo?.updatedInfo?.filterBuilder);
      setInBuilderFilter(query.QueryPayload?.Filter);
    });
    if (SelectedQuery === lf.QueryId) {
      setInFilterBuilder(SelectedQueryData?.updatedInfo?.filterBuilder);
    }
    setInSubBuilders(savePayloadSubBuilders);
    setInSubBuilders(state.reportEditInfo.rawReportConfig?.SubBuilders);
  });
};

const reportBuilderSlice = createSlice({
  name: 'ReportBuilderState',
  initialState: initialReportBuilderState,
  reducers: {
    [ReportBuilderActions.SEARCH_FILTER_DATA_LOAD_REQUEST]: (state: IReportBuilderState, action:PayloadAction<ISearchFilterPayloadRequest>) => {
      const { filterId, searchKey } = action.payload;
      const filter = state.filterBuilder.filterConfig.find(
        (config) => config.ID === filterId,
      );
      const newAppliedFilters = state.filterBuilder.appliedFilters;
      if (filter) {
        newAppliedFilters[filterId].OptionsMeta.SearchKey = searchKey;
        newAppliedFilters[filterId].OptionsMeta.Page.PageIndex = 0;
        newAppliedFilters[filterId].FilterOptions = [];
      }
      state.filterBuilder.appliedFilters = newAppliedFilters;
    },
    [ReportBuilderActions.LOAD_MORE_FILTER_DATA_LOAD_REQUEST]: (state: IReportBuilderState, action:PayloadAction<ILoadMoreFilterPayloadRequest>) => {
      const { filterId } = action.payload;
      const filter = state.filterBuilder.filterConfig.find(
        (config) => config.ID === filterId,
      );
      const newAppliedFilters = state.filterBuilder.appliedFilters;

      if (filter) {
        newAppliedFilters[filterId].OptionsMeta.Page.PageIndex += 1;
      }
      state.filterBuilder.appliedFilters = newAppliedFilters;
      const { Title, Description } = state.updatedReportBuilderInfo.reportBuilderSavePayload.Details;
      state.assortedInfo.isFormDisabled = getIsReportBuilderSaveFormDisable(Title, Description, state)
        || getIsFilterFormDisable(state.filterBuilder);
    },
    [ReportBuilderActions.ADD_DYNAMIC_FILTER]: (state: IReportBuilderState, action: PayloadAction<IAddDynamicFilterPayload>) => getStateOnAddDynamicFilter(state, action.payload.index),
    [ReportBuilderActions.ADD_CUSTOM_FILTER]: (state: IReportBuilderState, action: PayloadAction<IAddCustomFilterPayload>) => {
      const {
        filterName, customFilterType, hideFromReportPage, linkedFilters, userStatus, filterKey, useVar, calendarDateApplicableFilters,
      } = action.payload;
      const filterId = `custom_filter_${uuidv4()}`;
      const { additionalFilters } = state.reportBuilderInfo;

      // For each linked filter: resolve source, stamp AssociatedCustomFilterId, push to filterConfig.
      // Constituents keep their original Labels.
      if (!linkedFilters?.length) return;
      const resolvedLinkedFilters = linkedFilters.map(
        (lf) => resolveAndLinkFilter(state, lf, filterId, additionalFilters),
      );

      // Prune any linked-insight source mappings that reference the newly-absorbed
      // constituent IDs. Those mappings would otherwise translate against stale
      // activeFilters entries at drilldown time (the constituent no longer receives
      // user input directly).
      removeFilterIdsFromLinkedReportsConfig(
        state,
        resolvedLinkedFilters.map((lf) => lf.FilterId),
      );

      // Store the custom filter definition (source of truth for metadata)
      state.filterBuilder.customFilterDefinitions.push({
        ID: filterId,
        Label: filterName,
        CustomFilterType: customFilterType,
        HideFromReportPage: hideFromReportPage,
        LinkedFilters: resolvedLinkedFilters,
        UserStatus: userStatus,
        FilterKey: filterKey,
        UseVar: useVar,
      });

      // Add UI rendering entry in filterConfig.
      // For dropdown types, resolve the Filter Key constituent's Metadata.FilterKey
      // so the dropdown API (lsqMultiSelectProcessor) knows which schema to query.
      const filterKeyConstituent = filterKey
        ? state.filterBuilder.filterConfig.find((f) => f.ID === filterKey)
          || additionalFilters?.find((f) => f.ID === filterKey)
        : undefined;
      const metadata: Record<string, any> = {};
      // Only set Status for non-primary user filters.
      const hasPrimaryUserConstituent = resolvedLinkedFilters.some((lf) => {
        const constituent = state.filterBuilder.filterConfig.find((f) => f.ID === lf.FilterId)
          || additionalFilters?.find((f) => f.ID === lf.FilterId);
        return constituent?.IsPrimaryUserFilter;
      });
      if (userStatus && !hasPrimaryUserConstituent) metadata.Status = userStatus;
      if (filterKeyConstituent?.Metadata?.FilterKey) metadata.FilterKey = filterKeyConstituent.Metadata.FilterKey;
      const newFilter: IFilterConfig = {
        ID: filterId,
        Label: filterName,
        Type: customFilterType,
        IsDynamic: true,
        IsCustomFilter: true,
        CustomFilterType: customFilterType,
        LinkedFilters: resolvedLinkedFilters,
        HideFromReportPage: hideFromReportPage,
        Alias: filterId,
        Metadata: metadata,
        // Copy LinkedTo from FilterKey constituent so the custom filter participates
        // in the dependency chain (parent value changes → custom filter dropdown reloads)
        LinkedTo: filterKeyConstituent?.LinkedTo,
        // Propagate IsLargeOptionSetField from FilterKey constituent so the custom filter
        // renders with pagination/lazy-loading and uses the LOS dropdown API
        IsLargeOptionSetField: filterKeyConstituent?.IsLargeOptionSetField,
      };
      state.filterBuilder.filterConfig.push(newFilter);
      const defaultFilter = new FilterFetchUtility(null).GetDefaultSingleFilter(newFilter, null);
      // For dropdown types with a FilterKey, mark shouldLoad so the auto-loader triggers the dropdown API
      if (filterKey) defaultFilter.shouldLoad = true;
      state.filterBuilder.appliedFilters[filterId] = defaultFilter;
      // Linking a user-entity (Entity === User) constituent must re-scope the existing
      // user-picker filter's options — mirrors getStateOnAddDynamicFilter's user branch
      // that the standalone add-filter path runs. The reload target excludes constituents
      // (they have no appliedFilters entry — see bug #2); the wrapper itself self-loads above.
      const hasUserEntityConstituent = resolvedLinkedFilters.some((lf) => (
        state.filterBuilder.filterConfig.find((f) => f.ID === lf.FilterId)
          || additionalFilters?.find((f) => f.ID === lf.FilterId)
      )?.Entity === FieldEntitiesType.User);
      if (hasUserEntityConstituent) {
        const userPicker = state.filterBuilder.filterConfig.find(
          (f) => f.Type === FilterType.UserMultiSelect,
        );
        if (userPicker) {
          state.filterBuilder.isUsersModified = true;
          state.filterBuilder.appliedFilters[userPicker.ID] = new FilterFetchUtility(null).GetDefaultSingleFilter(userPicker, null);
        }
      }
      // Stamp the variable metadata onto the new definition while the selected constituents and
      // the freshly-initialised applied value are in scope (custom-filter-expressions feature;
      // independent of UseVar). DataType is read directly off a representative constituent's config;
      // DefaultValue captures the applied value. Operator is resolved at report-save time from the
      // constituent via getOperatorValue (see getSaveReportConfigPayload) — at add-time a dropdown's
      // value/operator may not be resolved yet, so it is not inferred here.
      const addedDefinition = state.filterBuilder.customFilterDefinitions.find((d) => d.ID === filterId);
      if (addedDefinition) {
        const representativeConstituent = resolvedLinkedFilters
          .map((lf) => state.filterBuilder.filterConfig.find((f) => f.ID === lf.FilterId)
            || additionalFilters?.find((f) => f.ID === lf.FilterId))
          .find((c) => !!c?.DataType);
        addedDefinition.DataType = representativeConstituent?.DataType;
        addedDefinition.DefaultValue = state.filterBuilder.appliedFilters[filterId]?.FilterResponse ?? null;
        // Copy the FilterKey constituent's LOS flag and the composed render metadata onto the
        // definition so it stays self-contained (mirrors the filterConfig render entry above).
        addedDefinition.IsLargeOptionSetField = filterKeyConstituent?.IsLargeOptionSetField;
        addedDefinition.Metadata = metadata;
      }
      applyCalendarDateRangeFillOnConstituents(state, resolvedLinkedFilters, calendarDateApplicableFilters);
      // From now on the wrapper — not the constituent — is the input surface, and it starts at its
      // own default rather than inheriting the constituent's current value (no constituent → wrapper
      // seeding exists at add time; resolveSubBuilderCustomFilterDefaults only runs on config load).
      // Push that value down so a query constituent does not keep a value the user can no longer see
      // or edit from the main report, which is also what the fetch-payload fan-out would send.
      // applyCustomFilterValueToQueryConstituents(state, newFilter, defaultFilter?.FilterResponse ?? null);

      const { Title, Description } = state.updatedReportBuilderInfo?.reportBuilderSavePayload?.Details || {};
      state.assortedInfo.isFormDisabled = getIsReportBuilderSaveFormDisable(Title, Description, state)
        || getIsFilterFormDisable(state.filterBuilder);
    },
    [ReportBuilderActions.UPDATE_CUSTOM_FILTER]: (state: IReportBuilderState, action: PayloadAction<IUpdateCustomFilterPayload>) => {
      const {
        filterId, filterName, customFilterType, hideFromReportPage, linkedFilters, userStatus, filterKey, useVar, dataType, calendarDateApplicableFilters,
      } = action.payload;
      const { additionalFilters } = state.reportBuilderInfo;

      // Update definition in customFilterDefinitions
      const defIndex = state.filterBuilder.customFilterDefinitions.findIndex((d) => d.ID === filterId);
      if (defIndex === -1) return;

      const oldLinkedFilters = state.filterBuilder.customFilterDefinitions[defIndex]?.LinkedFilters || [];
      const oldLinkedIds = oldLinkedFilters.map((lf) => resolveFilterIDInCaseOfQueryIdPresent(lf.FilterId, lf?.QueryId));
      const newLinkedIds = (linkedFilters || []).map((lf) => resolveFilterIDInCaseOfQueryIdPresent(lf.FilterId, lf?.QueryId));

      // Unlink removed filters: use Origin to decide cleanup
      const removedLinkedFilters = oldLinkedFilters.filter((lf) => !newLinkedIds.includes(resolveFilterIDInCaseOfQueryIdPresent(lf.FilterId, lf?.QueryId)));
      // Track IDs fully removed from filterConfig — their linked-insight mappings go stale.
      // Main-report AppliedFilter constituents revert to standalone (filter still exists), so
      // they are intentionally not collected here; their existing mappings remain valid.
      const fullyRemovedIds: string[] = [];
      removedLinkedFilters.forEach((removedLf) => {
        const removedResolvedId = resolveFilterIDInCaseOfQueryIdPresent(removedLf.FilterId, removedLf?.QueryId);
        // Capture the constituent's Type before it is spliced out of filterConfig below —
        // updateQueryFilterDefaultValueInSubBuilderPayload needs it to serialise the reset value.
        const removedFilter = state.filterBuilder.filterConfig.find(
          (f) => resolveFilterIDInCaseOfQueryIdPresent(f.ID, f?.QueryId) === removedResolvedId,
        );
        const idx = state.filterBuilder.filterConfig.findIndex((f) => resolveFilterIDInCaseOfQueryIdPresent(f.ID, f?.QueryId) === resolveFilterIDInCaseOfQueryIdPresent(removedLf.FilterId, removedLf?.QueryId));
        if (idx !== -1) {
          if (removedLf.Source === LinkedFilterSource.SubBuilder) {
            // SubBuilder constituent: remove from main filterConfig entirely.
            // It was added here only because of custom filter linking — it doesn't belong in main filterConfig.
            state.filterBuilder.filterConfig.splice(idx, 1);
            fullyRemovedIds.push(resolveFilterIDInCaseOfQueryIdPresent(removedLf.FilterId, removedLf?.QueryId));
          } else if (removedLf.Origin === LinkedFilterOrigin.AppliedDimension) {
            // Main report filter added only by linking — remove it entirely
            state.filterBuilder.filterConfig.splice(idx, 1);
            fullyRemovedIds.push(resolveFilterIDInCaseOfQueryIdPresent(removedLf.FilterId, removedLf?.QueryId));
          } else {
            // Main report filter that existed independently — remove completely
            state.filterBuilder.filterConfig.splice(idx, 1);
            fullyRemovedIds.push(resolveFilterIDInCaseOfQueryIdPresent(removedLf.FilterId, removedLf?.QueryId));
          }
        }
        // When an already-applied calendar-date constituent is removed from this custom filter,
        // reset its linked dimension's RangeFill to 0 (calendar-date off). Main report only —
        // query constituents are out of scope. Only date-type constituents carry calendar date.
        if (removedLf.Source === LinkedFilterSource.MainReport && removedFilter?.Type === FilterType.DateRange) {
          const removedLinkedDimensionId = removedLf.LinkedDimensionId || removedFilter?.LinkedDimensionId;
          const appliedDimensions = state.updatedReportBuilderInfo.appliedDimensions || [];
          const dimIndex = removedLinkedDimensionId
            ? appliedDimensions.findIndex((dim) => dim.Id === removedLinkedDimensionId)
            : -1;
          if (dimIndex !== -1) {
            appliedDimensions[dimIndex] = {
              ...appliedDimensions[dimIndex],
              RangeFill: 0,
              Props: {
                ...appliedDimensions[dimIndex]?.Props,
                Dimension: {
                  ...appliedDimensions[dimIndex]?.Props?.Dimension,
                  RangeFill: 0,
                },
              },
            };
          }
        }
      });

      // Link newly added filters
      const addedLinkedFilters = (linkedFilters || []).filter((lf) => !oldLinkedIds.includes(resolveFilterIDInCaseOfQueryIdPresent(lf.FilterId, lf?.QueryId)));
      const resolvedAddedFilters = addedLinkedFilters.map(
        (lf) => resolveAndLinkFilter(state, lf, filterId, additionalFilters),
      );

      // Single prune pass covering both the newly-absorbed constituents and the
      // fully-removed ones. Either class leaves stale source keys in linked-insight mappings.
      removeFilterIdsFromLinkedReportsConfig(
        state,
        [...fullyRemovedIds, ...resolvedAddedFilters.map((lf) => lf.FilterId)],
      );

      // Merge: keep unchanged filters + newly resolved ones. Backfill Label on the kept entries
      // for backward compatibility — custom filters created before this feature have label-less
      // LinkedFilters, so re-saving the form stamps each unchanged constituent's display Label
      // (from filterConfig / additionalFilters) the same way resolveAndLinkFilter does for newly
      // added ones. Idempotent: entries that already carry a Label are left untouched.
      const unchangedFilters = oldLinkedFilters
        .filter((lf) => newLinkedIds.includes(resolveFilterIDInCaseOfQueryIdPresent(lf.FilterId, lf?.QueryId)))
        .map((lf) => (lf.Label ? lf : {
          ...lf,
          Label: (state.filterBuilder.filterConfig.find((f) => f.ID === lf.FilterId)
            || additionalFilters?.find((f) => f.ID === lf.FilterId))?.Label || lf.Label,
        }));
      const allResolvedFilters = [...unchangedFilters, ...(resolvedAddedFilters || [])];

      // If FilterKey changed, remove the old FilterKey constituent from filterConfig
      // if it is no longer in the linked list
      const oldFilterKey = state.filterBuilder.customFilterDefinitions[defIndex]?.FilterKey;
      // Capture the previous user status before the definition is overwritten below, so a
      // status-only edit can reset the wrapper's applied value back to "All" (see re-init gate).
      const oldUserStatus = state.filterBuilder.customFilterDefinitions[defIndex]?.UserStatus;
      if (oldFilterKey && oldFilterKey !== filterKey && !newLinkedIds.includes(oldFilterKey)) {
        const oldKeyIdx = state.filterBuilder.filterConfig.findIndex((f) => f.ID === oldFilterKey);
        if (oldKeyIdx !== -1) {
          state.filterBuilder.filterConfig.splice(oldKeyIdx, 1);
        }
      }

      // Update the definition
      state.filterBuilder.customFilterDefinitions[defIndex] = {
        ...(state.filterBuilder.customFilterDefinitions[defIndex] ?? {}),
        ID: filterId,
        Label: filterName,
        CustomFilterType: customFilterType,
        HideFromReportPage: hideFromReportPage,
        LinkedFilters: allResolvedFilters,
        UserStatus: userStatus,
        FilterKey: filterKey,
        UseVar: useVar,
        DataType: dataType ?? state.filterBuilder.customFilterDefinitions[defIndex]?.DataType,
      };

      // Update the UI rendering entry in filterConfig
      const filterIndex = state.filterBuilder.filterConfig.findIndex((c) => c.ID === filterId);
      if (filterIndex !== -1) {
        const oldType = state.filterBuilder.filterConfig[filterIndex].Type;
        // For dropdown types, resolve the Filter Key constituent's Metadata.FilterKey.
        // Search main filterConfig and additionalFilters first; fall back to the per-
        // query FilterGroups so a FilterKey set to a query-applied filter (which
        // doesn't live in main filterConfig until promoted) still resolves. SubBuilder
        // FilterGroup IDs may be bare or `_<queryId>`-suffixed — match either form.
        const findFilterKeyConstituent = (): IFilterConfig | undefined => {
          if (!filterKey) return undefined;
          const fromMain = state.filterBuilder.filterConfig.find((f) => f.ID === filterKey);
          if (fromMain) return fromMain;
          const fromAdditional = additionalFilters?.find((f) => f.ID === filterKey);
          if (fromAdditional) return fromAdditional;
          const queryList = state.reportQueryBuilder?.DynamicQueryList || [];
          for (let i = 0; i < queryList.length; i += 1) {
            const queryId = queryList[i].Id;
            const fg = (queryList[i].QueryPayload?.Filter?.FilterGroup || []).find((g) => (
              g.ID === filterKey
              || (!!queryId && (g.ID === `${filterKey}_${queryId}` || `${g.ID}_${queryId}` === filterKey))
            ));
            if (fg) {
              // Hoist Render.Metadata so the downstream `.Metadata?.FilterKey` read works;
              // LinkedTo / IsLargeOptionSetField are already on the FilterGroup top-level.
              return {
                ...fg,
                Type: fg.Render?.Type,
                Metadata: fg.Render?.Metadata || (fg as any).Metadata,
              } as IFilterConfig;
            }
          }
          return undefined;
        };
        const updatedFilterKeyConstituent = findFilterKeyConstituent();
        const updatedMetadata: Record<string, any> = {
          ...state.filterBuilder.filterConfig[filterIndex].Metadata,
        };
        // Only set Status for non-primary user filters.
        const hasUpdatedPrimaryUserConstituent = allResolvedFilters.some((lf) => {
          const constituent = state.filterBuilder.filterConfig.find((f) => f.ID === lf.FilterId)
            || additionalFilters?.find((f) => f.ID === lf.FilterId);
          return constituent?.IsPrimaryUserFilter;
        });
        if (userStatus && !hasUpdatedPrimaryUserConstituent) updatedMetadata.Status = userStatus;
        if (updatedFilterKeyConstituent?.Metadata?.FilterKey) {
          updatedMetadata.FilterKey = updatedFilterKeyConstituent.Metadata.FilterKey;
        }
        state.filterBuilder.filterConfig[filterIndex] = {
          ...state.filterBuilder.filterConfig[filterIndex],
          Label: filterName,
          Type: customFilterType,
          CustomFilterType: customFilterType,
          LinkedFilters: allResolvedFilters,
          HideFromReportPage: hideFromReportPage,
          Metadata: updatedMetadata,
          LinkedTo: updatedFilterKeyConstituent?.LinkedTo,
          // Propagate IsLargeOptionSetField from FilterKey constituent so the custom filter
          // renders with pagination/lazy-loading and uses the LOS dropdown API
          IsLargeOptionSetField: updatedFilterKeyConstituent?.IsLargeOptionSetField,
        };
        // Keep the definition's copies in sync with the render entry (e.g. a FilterKey swap) so
        // the persisted definition stays self-contained.
        state.filterBuilder.customFilterDefinitions[defIndex].IsLargeOptionSetField = updatedFilterKeyConstituent?.IsLargeOptionSetField;
        state.filterBuilder.customFilterDefinitions[defIndex].Metadata = updatedMetadata;
        // Reset applied filter value when the type changes (old value structure is incompatible
        // with the new renderer) OR when the FilterKey changes (old selected values are invalid
        // for the new constituent's dropdown — e.g., swapping between different LOS fields).
        const hasFilterKeyChanged = oldFilterKey !== filterKey;
        // A user-status change invalidates the previously-selected UserIds (they may not exist
        // under the new status), so reset the wrapper to its default ("All") — mirrors the
        // standalone path in UPDATE_FILTER_FORM. Re-initialising via GetDefaultSingleFilter both
        // resets FilterResponse to { Type: All, UserIds: [] } and primes shouldLoad, so it
        // subsumes the reload trigger below for this case.
        const hasUserStatusChanged = customFilterType === FilterType.UserMultiSelect
          && oldUserStatus !== userStatus;
        if (oldType !== customFilterType || hasFilterKeyChanged || hasUserStatusChanged) {
          state.filterBuilder.appliedFilters[filterId] = new FilterFetchUtility(null).GetDefaultSingleFilter(
            state.filterBuilder.filterConfig[filterIndex], null,
          );
        }
        // Trigger an options reload when the FilterKey is set (dropdown types) or for
        // User-type wrappers — which never carry a FilterKey (it is a dropdown-only
        // concept; the editor sends `filterKey: undefined` for User filters). Without
        // the User-type arm, a same-type edit hits neither this gate nor the re-init
        // above (gated on type/FilterKey change), so `shouldLoad` stays false and the
        // auto-loader never re-fetches `get-users`. Flipping it on the existing applied
        // entry preserves the current selection while re-fetching options against any
        // changed user status / constituents — mirroring ADD_CUSTOM_FILTER, where
        // GetDefaultSingleFilter primes shouldLoad on the freshly-built entry.
        const shouldReloadWrapperOptions = !!filterKey || customFilterType === FilterType.UserMultiSelect;
        if (shouldReloadWrapperOptions && state.filterBuilder.appliedFilters[filterId]) {
          state.filterBuilder.appliedFilters[filterId].shouldLoad = true;
        }
        // A user-entity (Entity === User) constituent in the final constituent set must re-scope
        // the existing user-picker filter's options — same branch as ADD_CUSTOM_FILTER. Computed
        // over the full post-update list (allResolvedFilters), not just the newly-added delta.
        const hasUserEntityConstituent = allResolvedFilters.some((lf) => (
          state.filterBuilder.filterConfig.find((f) => f.ID === lf.FilterId)
            || additionalFilters?.find((f) => f.ID === lf.FilterId)
        )?.Entity === FieldEntitiesType.User);
        if (hasUserEntityConstituent) {
          const userPicker = state.filterBuilder.filterConfig.find(
            (f) => f.Type === FilterType.UserMultiSelect,
          );
          if (userPicker) {
            state.filterBuilder.isUsersModified = true;
            state.filterBuilder.appliedFilters[userPicker.ID] = new FilterFetchUtility(null).GetDefaultSingleFilter(userPicker, null);
          }
        }
      }
      // Re-stamp the variable metadata after the update: constituents may have changed (→ DataType)
      // and the applied value may have been reset above (→ DefaultValue). DataType is read off a
      // representative constituent from the full post-update list; DefaultValue captures the applied
      // value. Operator is resolved at report-save time from the constituent via getOperatorValue
      // (see getSaveReportConfigPayload) (custom-filter-expressions feature; independent of UseVar).
      // Backward compatibility: re-saving a custom filter created before this feature stamps the
      // now-missing DataType onto its definition. Guard against clobbering — only overwrite when a
      // representative constituent actually exposes a DataType, so a transient lookup miss never
      // wipes an existing value.
      const updatedDefinition = state.filterBuilder.customFilterDefinitions[defIndex];
      const updatedRepresentativeConstituent = allResolvedFilters
        .map((lf) => state.filterBuilder.filterConfig.find((f) => f.ID === lf.FilterId)
          || additionalFilters?.find((f) => f.ID === lf.FilterId))
        .find((c) => !!c?.DataType);
      if (updatedRepresentativeConstituent?.DataType) {
        updatedDefinition.DataType = updatedRepresentativeConstituent.DataType;
      }
      updatedDefinition.DefaultValue = state.filterBuilder.appliedFilters[filterId]?.FilterResponse ?? null;

      applyCalendarDateRangeFillOnConstituents(state, allResolvedFilters, calendarDateApplicableFilters);
      // Re-seed the query constituents from the wrapper's current value. Covers newly-linked
      // constituents (they still hold whatever value the query had before linking) and the resets
      // above — a type / FilterKey / user-status change drops the wrapper back to its default, and
      // without this the owning query would keep the pre-reset value. Read the render entry rather
      // than the definition: it is the copy that carries IsCustomFilter / Type / the post-update
      // LinkedFilters. Removed constituents are not touched — they are absent from LinkedFilters and
      // were already cleared by the removal branch above.
      applyCustomFilterValueToQueryConstituents(
        state,
        state.filterBuilder.filterConfig.find((f) => f.ID === filterId),
        state.filterBuilder.appliedFilters[filterId]?.FilterResponse ?? null,
      );
    },
    [ReportBuilderActions.DELETE_CUSTOM_FILTER]: (state: IReportBuilderState, action: PayloadAction<IDeleteCustomFilterPayload>) => {
      const { filterId } = action.payload;

      // SubBuilder constituents are copies that resolveAndLinkFilter pushed into main
      // filterConfig only because of linking. Their natural home is the query's own
      // QueryPayload.Filter.FilterGroup, so they must be removed from main filterConfig
      // when the custom filter goes away — even if their AlwaysEnabled flag was carried
      // over from the query (otherwise they linger as phantom standalones and Rule 3 in
      // the linking picker excludes the original SubBuilder filter from being re-linked).
      const deletingDefinition = state.filterBuilder.customFilterDefinitions.find(
        (d) => d.ID === filterId,
      );
      const subBuilderConstituentIds = new Set<string>(
        (deletingDefinition?.LinkedFilters || [])
          .filter((lf) => lf.Source === LinkedFilterSource.SubBuilder)
          .map((lf) => lf.FilterId),
      );

      // Deleting a custom filter that bundled a main-report user-entity constituent must re-scope
      // the remaining user-picker filter's options — mirrors DELETE_DYNAMIC_FILTER's user branch.
      // Detected here, before the constituents are removed below; sub-builder constituents are
      // skipped (their user scoping is out of scope for this flow).
      const hadUserEntityConstituent = (deletingDefinition?.LinkedFilters || []).some((lf) => (
        lf.Source !== LinkedFilterSource.SubBuilder
        && state.filterBuilder.filterConfig.find((f) => f.ID === lf.FilterId)?.Entity === FieldEntitiesType.User
      ));

      // Reset the linked dimension's RangeFill to 0 (calendar-date off) for each already-applied
      // calendar-date constituent bundled in the deleted custom filter. Main report only; date-type
      // constituents only. Runs before the constituents are stripped from filterConfig below so the
      // Type / LinkedDimensionId can still be resolved.
      const mainReportAppliedDimensions = state.updatedReportBuilderInfo.appliedDimensions || [];
      (deletingDefinition?.LinkedFilters || []).forEach((lf) => {
        if (lf.Source !== LinkedFilterSource.MainReport) return;
        const constituent = state.filterBuilder.filterConfig.find((f) => f.ID === lf.FilterId);
        if (constituent?.Type !== FilterType.DateRange) return;
        const linkedDimensionId = lf.LinkedDimensionId || constituent?.LinkedDimensionId;
        const dimIndex = linkedDimensionId
          ? mainReportAppliedDimensions.findIndex((dim) => dim.Id === linkedDimensionId)
          : -1;
        if (dimIndex === -1) return;
        mainReportAppliedDimensions[dimIndex] = {
          ...mainReportAppliedDimensions[dimIndex],
          RangeFill: 0,
          Props: {
            ...mainReportAppliedDimensions[dimIndex]?.Props,
            Dimension: {
              ...mainReportAppliedDimensions[dimIndex]?.Props?.Dimension,
              RangeFill: 0,
            },
          },
        };
      });

      // Release constituent filters of the deleted custom filter:
      //   - SubBuilder constituents are always removed (see comment above).
      //   - AlwaysEnabled main-report constituents revert to the report as standalone
      //     filters (AssociatedCustomFilterId cleared; entry retained). These are
      //     filters the report requires at all times, so silently removing them with
      //     the custom filter would drop a required input.
      //   - All other constituents are removed entirely, since relying on Origin
      //     is unsound: resolveAndLinkFilter historically stamped every
      //     LinkedFilterInfo with Origin = AppliedFilter, so any custom filter
      //     saved before that was corrected carries stale metadata.
      const removedConstituentIds: string[] = [];
      state.filterBuilder.filterConfig = state.filterBuilder.filterConfig.filter((f) => {
        if (f.AssociatedCustomFilterId !== filterId) return true;
        if (subBuilderConstituentIds.has(f.ID)) {
          removedConstituentIds.push(f.ID);
          return false;
        }
        if (f.AlwaysEnabled) {
          // Keep the filter as a standalone — clear the association only.
          delete f.AssociatedCustomFilterId;
          return true;
        }
        removedConstituentIds.push(f.ID);
        return false;
      });

      // Drop appliedFilters entries for the constituents we actually removed. Leaving
      // stale FilterResponse values behind bleeds into subsequent save payloads and
      // the next fetch-report call. AlwaysEnabled constituents kept their entries.
      removedConstituentIds.forEach((id) => {
        delete state.filterBuilder.appliedFilters[id];
      });

      // Release constituent filters from SubBuilder query FilterGroups.
      // SubBuilder filters carry AssociatedCustomFilterId in their own QueryPayload — clear it
      // so the filter is no longer marked as linked to this custom filter.
      (state.reportQueryBuilder.DynamicQueryList || []).forEach((query) => {
        const filterGroup = query?.QueryPayload?.Filter?.FilterGroup;
        if (!filterGroup) return;
        filterGroup.forEach((fg) => {
          if (fg.AssociatedCustomFilterId === filterId) {
            delete fg.AssociatedCustomFilterId;
          }
        });
      });

      // Clear stale AssociatedCustomFilterId from filter structures in both the
      // save payload AND the selected template. Without this,
      // updateReportTemplateFilterBuilder (called during preview/save) skips
      // these filters because their AssociatedCustomFilterId points to a
      // deleted custom filter that no longer exists in filterConfig.
      // hydrateWithCustomFilters also cleans orphaned associations, but it runs
      // after getSavePayloadBuilderFilters has already dropped these filters.
      // NOTE: getSaveReportConfigPayload reads from the *template* filter
      // (selectedTemplate.ReportConfig.Builder[].Filter), not the save payload,
      // so both must be cleaned.
      const clearAssociatedCustomFilterId = (filter: IBuilderFilter) => {
        filter?.FilterGroup?.forEach((fg) => {
          if (fg.AssociatedCustomFilterId === filterId) {
            delete fg.AssociatedCustomFilterId;
          }
        });
        filter?.SubFilters?.forEach((sf) => clearAssociatedCustomFilterId(sf));
      };

      state.updatedReportBuilderInfo?.reportBuilderSavePayload
        ?.Builder?.forEach((b) => clearAssociatedCustomFilterId(b.Filter));
      state.updatedReportBuilderInfo?.selectedTemplate?.ReportConfig
        ?.Builder?.forEach((b) => clearAssociatedCustomFilterId(b.Filter));

      // Remove the IsCustomFilter UI entry
      state.filterBuilder.filterConfig = state.filterBuilder.filterConfig.filter(
        (config) => config.ID !== filterId,
      );

      // Remove definition
      state.filterBuilder.customFilterDefinitions = state.filterBuilder.customFilterDefinitions.filter(
        (def) => def.ID !== filterId,
      );

      // Remove applied filter entry for the custom filter itself
      delete state.filterBuilder.appliedFilters[filterId];

      // Prune linked-insight source mappings that reference any constituent we just
      // removed from the report. Their IDs no longer resolve to live filters, so any
      // LinkingConfig.Filters entry keyed on them would translate against nothing.
      removeFilterIdsFromLinkedReportsConfig(state, removedConstituentIds);

      // Re-scope the remaining user picker now that a user-entity constituent has been released
      // (find runs after the wrapper + constituents are removed, so it targets a live picker).
      if (hadUserEntityConstituent) {
        const userPicker = state.filterBuilder.filterConfig.find((f) => f.Type === FilterType.UserMultiSelect);
        if (userPicker) {
          state.filterBuilder.isUsersModified = true;
          state.filterBuilder.appliedFilters[userPicker.ID] = new FilterFetchUtility(null).GetDefaultSingleFilter(userPicker, null);
        }
      }

      const { Title, Description } = state.updatedReportBuilderInfo?.reportBuilderSavePayload?.Details || {};
      state.assortedInfo.isFormDisabled = getIsReportBuilderSaveFormDisable(Title, Description, state)
        || getIsFilterFormDisable(state.filterBuilder);
    },
    [ReportBuilderActions.DELETE_DYNAMIC_FILTER]: (state: IReportBuilderState, action: PayloadAction<IDeleteDynamicFilterPayload>) => {
      const { filterId } = action.payload;
      const newFilterConfig = state.filterBuilder.filterConfig;
      const newAppliedFilters = state.filterBuilder.appliedFilters;
      const index = newFilterConfig.findIndex(
        (config) => config.ID === filterId,
      );
      const appliedDimensions = state.updatedReportBuilderInfo.appliedDimensions;
      const deletedFilter = index !== -1 ? newFilterConfig[index] : null;
      if (deletedFilter?.Type === FilterType.DateRange && deletedFilter?.LinkedDimensionId && isValidArrayAndNotEmpty(appliedDimensions)) {
        const isLinkedDimAppliedIndex = appliedDimensions.findIndex((dim: IDimension) => dim.Applied === DimensionStatus.Applied && truncateUUID(deletedFilter?.LinkedDimensionId) === dim.Id);
        if (isLinkedDimAppliedIndex !== -1) {
          appliedDimensions[isLinkedDimAppliedIndex] = {
            ...appliedDimensions[isLinkedDimAppliedIndex],
            RangeFill: 0,
            Props: {
              ...appliedDimensions[isLinkedDimAppliedIndex]?.Props,
              Dimension: {
                ...appliedDimensions[isLinkedDimAppliedIndex]?.Props?.Dimension,
                RangeFill: 0,
              },
            },
          };
        }
        state.updatedReportBuilderInfo.appliedDimensions = appliedDimensions;
      }

      const userMultiSelectFilterData = newFilterConfig.find(
        (config) => config.Type === FilterType.UserMultiSelect,
      );
      if (index !== -1) {
        newFilterConfig[index].IsRemoved = true;
        if (
          newFilterConfig[index]?.Entity === FieldEntitiesType.User
          && userMultiSelectFilterData
        ) {
          state.filterBuilder.isUsersModified = true;
          newAppliedFilters[userMultiSelectFilterData.ID] = new FilterFetchUtility(null).GetDefaultSingleFilter(userMultiSelectFilterData, null);
        }
      }
      delete newAppliedFilters[filterId];
      state.filterBuilder.appliedFilters = newAppliedFilters;
      state.filterBuilder.filterConfig = newFilterConfig;

      removeFilterIdsFromLinkedReportsConfig(state, [filterId]);

      const { Title, Description } = state.updatedReportBuilderInfo.reportBuilderSavePayload.Details;
      state.assortedInfo.isFormDisabled = getIsReportBuilderSaveFormDisable(Title, Description, state)
        || getIsFilterFormDisable(state.filterBuilder);
    },
    [ReportBuilderActions.HANDLE_MAIN_REPORT_FILTER_VALUE_CHANGE]: (state: IReportBuilderState, action: PayloadAction<IFilterValueChangePayload>) => {
      const {
        filterId, filterValue, variables,
      } = action.payload;
      const fetchFilter = new FilterFetchUtility(variables);
      const newAppliedFilters = state.filterBuilder.appliedFilters;
      const { filterConfig } = state.filterBuilder;

      const selectedFilterConfig = filterConfig.find(
        (item: IFilterConfig) => item.ID === filterId,
      );
      // Augment the lookup pool with sub-query (SubBuilder) filters so the dependency chain can
      // reach dependents whose parent (or whose own definition) lives in a sub-query. The main
      // filterConfig only carries sub-query filters flagged ShowInMainReport; the rest live in the
      // save payload's SubBuilders (updatedReportBuilderInfo.reportBuilderSavePayload.SubBuilders).
      // Passing isSubBuilder=false to filterBuilderToFilterConfig includes ALL sub-query filters
      // (skips the ShowInMainReport gating) and recurses SubFilters. Scoped to the dependency-id
      // calculation only; the reset loop below still iterates the main filterConfig.
      const subQueryFilters = (state.updatedReportBuilderInfo.reportBuilderSavePayload?.SubBuilders || []).flatMap(
        (builder) => filterBuilderToFilterConfig(builder.Filter, [], [], false),
      );
      const dependencyLookupFilterConfig = isValidArrayAndNotEmpty(subQueryFilters)
        ? [...filterConfig, ...subQueryFilters]
        : filterConfig;
      // Get all dependent filter IDs (entire dependency chain: parent -> child -> grandchild -> ...)
      const allDependentFilterIds = getAllDependentFilterIds(filterId, dependencyLookupFilterConfig, state.filterBuilder.customFilterDefinitions);

      if (!isEmpty(filterConfig)) {
        filterConfig.forEach((item) => {
          if (item.ID === filterId && newAppliedFilters[item.ID]) {
            newAppliedFilters[filterId].FilterResponse = filterValue;
          } else if (
            allDependentFilterIds.includes(item.ID)
            || (selectedFilterConfig?.Entity === FieldEntitiesType.User
              && (item.Type === FilterType.UserMultiSelect && item.ID === selectedFilterConfig.ID))
          ) {
            // Skip resetting constituents — their parent custom filter (which now has LinkedTo set)
            // will be found as a dependent and reset directly by this same loop.
            // Gate on `!IsCustomFilter`: a wrapper built by buildCustomFiltersFromDefinitions spreads
            // its FilterKey constituent and inherits that constituent's AssociatedCustomFilterId, so a
            // loaded (report-edit) wrapper carries AssociatedCustomFilterId === self.ID. Without the
            // carve-out the wrapper — the legitimate dependent that must reload when its parent (or a
            // parent custom filter) changes — gets skipped here and its options never re-scope. Same
            // guard shape as report.util.ts and getStateOnFilterChange (report page, bug #18).
            if (item.AssociatedCustomFilterId && !item.IsCustomFilter) return;

            newAppliedFilters[item.ID] = fetchFilter.GetDefaultSingleFilter(
              item,
              null,
            );
            state.filterBuilder.isUsersModified = true;
          }
          if (item.Type === FilterType.UserMultiSelect && item?.Metadata?.Status) {
            newAppliedFilters[item.ID] = {
              ...newAppliedFilters[item.ID],
              userStatus: item?.Metadata?.Status,
            };
          }
        });
      }
      state.filterBuilder.appliedFilters = newAppliedFilters;
      // If the changed filter is a custom filter definition, refresh its DefaultValue from the new
      // applied value. Operator is resolved at report-save time from the constituent via
      // getOperatorValue (see getSaveReportConfigPayload); DataType never changes with the value.
      // No-ops for non-custom filters (custom-filter-expressions feature).
      const changedDefinition = state.filterBuilder.customFilterDefinitions.find((d) => d.ID === filterId);
      if (changedDefinition) {
        changedDefinition.DefaultValue = newAppliedFilters[filterId]?.FilterResponse ?? null;
      }
      // Push the wrapper's new value down onto any SubBuilder (query) constituents. The reset loop
      // above deliberately skips constituents (they are not the input surface), and nothing else in
      // this reducer writes them, so without this the owning query keeps its stale applied value.
      applyCustomFilterValueToQueryConstituents(state, selectedFilterConfig, filterValue);
      const { Title, Description } = state.updatedReportBuilderInfo.reportBuilderSavePayload.Details;
      state.assortedInfo.isFormDisabled = getIsReportBuilderSaveFormDisable(Title, Description, state)
        || getIsFilterFormDisable(state.filterBuilder);
    },
    [ReportBuilderActions.HANDLE_MAIN_REPORT_QUERY_FILTER_VALUE_CHANGE]: (state: IReportBuilderState, action: PayloadAction<IFilterValueNestedQueryChangePayload>) => {
      const {
        filterId, filterValue, variables, queryRes,
      } = action.payload;

      const selectedFilterConfig = state.filterBuilder.filterConfig.find(
        (item: IFilterConfig) => item.ID === filterId,
      );
      const selectedQueryData = state.reportQueryBuilder.DynamicQueryList?.find((query) => query?.Id === selectedFilterConfig.QueryId);
      if (!isValidObjectAndNotEmpty(selectedQueryData.QueryDataInfo) && queryRes) {
        const {
          SelectedQueryData, BreadcrumbData, DataSourceMapping, DataSourceMappingPayload, DynamicQueryList,
        } = state.reportQueryBuilder;
        const selectedQueryId = selectedFilterConfig.QueryId;

        const breadcrumbs = [...BreadcrumbData];
        const updatedBreadcrumbs = breadcrumbs.filter((item) => !(item.queryId === selectedQueryId && item.type === SubQueryPanelType.dataSource));
        if (updatedBreadcrumbs.length > 0) {
          updatedBreadcrumbs[updatedBreadcrumbs.length - 1].isActive = false;
        }
        state.reportQueryBuilder.BreadcrumbData = updatedBreadcrumbs;
        state.reportQueryBuilder.DynamicQueryList.forEach((query: IQueryInfo) => {
          if (query.Id === selectedQueryId) query.QueryConfig = queryRes;
        });
        DataSourceMapping[selectedQueryId].isDataSourceSaved = true;

        // Save the initial data source config to both DataSourceMapping and DataSourceMappingPayload,
        // so that data source can be reset to the original configuration when needed.
        if (!isValidObjectAndNotEmpty(DataSourceMappingPayload)) {
          state.reportQueryBuilder.DataSourceMappingPayload = {
            [selectedQueryId]: DataSourceMapping[selectedQueryId],
          };
        } else if (!DataSourceMappingPayload[selectedQueryId]) {
          state.reportQueryBuilder.DataSourceMappingPayload = {
            ...state.reportQueryBuilder.DataSourceMappingPayload,
            [selectedQueryId]: DataSourceMapping[selectedQueryId],
          };
        }
        prepareUICompatibleConfig(state, queryRes, SelectedQueryData, variables, DataSourceMapping[selectedQueryId]?.PrimaryNamespace, DynamicQueryList);
        state.reportQueryBuilder.SelectedQueryData = SelectedQueryData;

        state.requestProcessing[ReportBuilderActions.SAVE_NESTED_JOINS_CONFIG] = APIRequestStatus.Success;
      }
      const fetchFilter = new FilterFetchUtility(variables);

      if (selectedFilterConfig.QueryId && selectedQueryData) {
        const subQueryFilterId = selectedQueryData.QueryDataInfo?.updatedInfo?.filterBuilder?.filterConfig.find(
          (item: IFilterConfig) => item.ID === filterId,
        ) ? filterId : filterId.replace(`_${selectedFilterConfig.QueryId}`, '');

        const newAppliedFiltersForSubQuery = selectedQueryData.QueryDataInfo?.updatedInfo?.filterBuilder?.appliedFilters;
        let userFilterType = selectedQueryData.QueryDataInfo?.updatedInfo?.filterBuilder?.UserDropdownSelectType ?? UserFilterPayloadType.All;
        const selectedFilterConfigForSubQuery = selectedQueryData.QueryDataInfo?.updatedInfo?.filterBuilder?.filterConfig.find(
          (item: IFilterConfig) => item.ID === subQueryFilterId,
        );

        const subQueryFilterConfig = selectedQueryData.QueryDataInfo?.updatedInfo?.filterBuilder?.filterConfig || [];
        // Get all dependent filter IDs (entire dependency chain: parent -> child -> grandchild -> ...)
        const allDependentSubQueryFilterIds = getAllDependentFilterIds(subQueryFilterId, subQueryFilterConfig);

        if (!isEmpty(subQueryFilterConfig)) {
          subQueryFilterConfig.forEach((item) => {
            if (item.ID === subQueryFilterId && item.Type === FilterType.UserMultiSelect) {
              userFilterType = filterValue?.Type;
            }
            if (item.ID === subQueryFilterId && newAppliedFiltersForSubQuery[item.ID]) {
              newAppliedFiltersForSubQuery[subQueryFilterId].FilterResponse = filterValue;
            } else if (
              allDependentSubQueryFilterIds.includes(item.ID)
              || (selectedFilterConfigForSubQuery?.Entity === FieldEntitiesType.User
                && item.Type === FilterType.UserMultiSelect)
            ) {
              newAppliedFiltersForSubQuery[item.ID] = fetchFilter.GetDefaultSingleFilter(
                item,
                null,
              );
              selectedQueryData.QueryDataInfo.updatedInfo.filterBuilder.isUsersModified = true;
            }
            if (item.Type === FilterType.UserMultiSelect && item?.Metadata?.Status) {
              newAppliedFiltersForSubQuery[item.ID] = {
                ...newAppliedFiltersForSubQuery[item.ID],
                userStatus: item?.Metadata?.Status,
              };
            }
          });
          selectedQueryData.QueryDataInfo.updatedInfo.filterBuilder.UserDropdownSelectType = userFilterType;
          selectedQueryData.QueryDataInfo.updatedInfo.filterBuilder.appliedFilters = newAppliedFiltersForSubQuery;
          state.reportQueryBuilder.SelectedQuery = ROOT_QUERY_KEY;
          state.reportQueryBuilder.SelectedQueryData = initialReportBuilderState.reportQueryBuilder.SelectedQueryData;
        }
      }

      // Update filter DefaultValue in all three SubBuilder payload locations so that
      // every serialisation path picks up the latest value:
      // 1. reportBuilderSavePayload.SubBuilders — used by getSaveReportConfigPayload (preview/save fallback)
      // 2. DynamicQueryList[].QueryPayload — used by getSubBuilders via getRootQuerySaveReportConfigPayload
      // 3. reportEditInfo.rawReportConfig.SubBuilders — used by getQueryConfigFromRawConfig (saveNestedJoinsConfig payload)
      if (selectedFilterConfig?.QueryId) {
        const updateFilterInSubBuilders = (subBuilderList: IBuilder[]) => {
          if (!isValidArrayAndNotEmpty(subBuilderList)) return;
          subBuilderList.forEach((builder) => {
            if (builder.QueryId === selectedFilterConfig.QueryId) {
              updateQueryFilterDefaultValueInSubBuilderPayload(
                builder.Filter,
                filterId,
                filterValue,
                selectedFilterConfig.Type,
              );
            }
          });
        };

        updateFilterInSubBuilders(state.updatedReportBuilderInfo.reportBuilderSavePayload?.SubBuilders);
        updateFilterInSubBuilders(state.reportEditInfo.rawReportConfig?.SubBuilders);

        state.reportQueryBuilder.DynamicQueryList?.forEach((query) => {
          if (query.Id === selectedFilterConfig.QueryId && query.QueryPayload) {
            updateQueryFilterDefaultValueInSubBuilderPayload(
              query.QueryPayload.Filter,
              filterId,
              filterValue,
              selectedFilterConfig.Type,
            );
          }
        });
      }
    },
    [ReportBuilderActions.UPDATE_FILTER_FORM]: (state:IReportBuilderState, action: PayloadAction<IFilterFormValues>) => {
      const {
        name, filterId, userStatus, rangeFillValue, hideFromReportPage, linkedFilters, calendarDateApplicableFilters,
      } = action.payload;
      const newFilterConfig = state.filterBuilder.filterConfig;
      const newAppliedFilter = state.filterBuilder.appliedFilters;
      const appliedDimensions = state.updatedReportBuilderInfo.appliedDimensions || [];

      const index = newFilterConfig.findIndex(
        (config) => config.ID === filterId,
      );
      const linkedDimensionIndex = appliedDimensions.findIndex((item) => item.Id === newFilterConfig[index]?.LinkedDimensionId);

      if (linkedDimensionIndex !== -1 && (rangeFillValue || rangeFillValue === 0)) {
        appliedDimensions[linkedDimensionIndex] = {
          ...appliedDimensions[linkedDimensionIndex],
          Props: {
            ...appliedDimensions[linkedDimensionIndex]?.Props,
            Dimension: {
              ...appliedDimensions[linkedDimensionIndex]?.Props?.Dimension,
              RangeFill: rangeFillValue,
            },
          },
        };
      }

      // Calendar-date toggle from the custom filter editor. A seed-mode rename saves through
      // UPDATE_FILTER_FORM (not ADD/UPDATE_CUSTOM_FILTER), so persist the toggle onto the linked
      // dimension's RangeFill here — reusing the same writer as ADD/UPDATE_CUSTOM_FILTER, fed the
      // editor's own linkedFilters so each applicable constituent resolves to its dimension.
      if (isValidArrayAndNotEmpty(calendarDateApplicableFilters)) {
        applyCalendarDateRangeFillOnConstituents(state, linkedFilters || [], calendarDateApplicableFilters);
      }

      const statusChanged = newAppliedFilter?.[filterId]?.userStatus !== userStatus;
      if (isPaginatedFilter(newFilterConfig[index])) {
        newAppliedFilter[filterId] = {
          ...newAppliedFilter[filterId],
          label: name,
          ...(userStatus ? { userStatus } : {}),
          ...(statusChanged ? {
            FilterResponse: {
              ...newAppliedFilter[filterId]?.FilterResponse,
              Type: 'ALL',
              ...(isLargeOptionSetFilter(newFilterConfig[index]) ? { Values: [] } : { UserIds: [] }),
            },
          } : {}),
        };
      }
      newAppliedFilter[filterId] = {
        ...newAppliedFilter[filterId],
        label: name,
      };

      newFilterConfig[index].Label = name;
      if (userStatus && newFilterConfig[index].Type === FilterType.UserMultiSelect) {
        newFilterConfig[index].Metadata.Status = userStatus;
      }
      // Sales Group hide-from-report-page: persist into Render.Metadata so it
      // round-trips through the BE's existing Metadata interface{} channel.
      // Scoped strictly to standalone main-report GroupMultiSelect — other
      // filter types and any sub-query filter (QueryId set) are untouched.
      if (
        hideFromReportPage !== undefined
        && newFilterConfig[index].Type === FilterType.GroupMultiSelect
        && !newFilterConfig[index].QueryId
      ) {
        newFilterConfig[index].Metadata = {
          ...(newFilterConfig[index].Metadata || {}),
          HideFromReportPage: hideFromReportPage,
        };
      }
      state.filterBuilder.filterConfig = newFilterConfig;
      state.filterBuilder.appliedFilters = newAppliedFilter;
    },
    [ReportBuilderActions.UPDATED_SELECTED_TEMPLATE]: (state: IReportBuilderState, action: PayloadAction<IRawTemplate>) => {
      if (!action.payload?.ReportConfig) return;
      const measureColumns = getMeasureColumns(action.payload.ReportConfig, true);
      const reportConfig = selectedReportTemplate(action.payload, action.payload.FilterMetaInfo);
      state.updatedReportBuilderInfo.selectedTemplate = action.payload;
      state.updatedReportBuilderInfo.selectedTemplate.ReportConfig = reportConfig;
      state.updatedReportBuilderInfo.reportBuilderSavePayload = reportConfig;
      state.updatedReportBuilderInfo.appliedDimensions = getAppliedDimensions(state, reportConfig, action.payload.FilterMetaInfo);
      state.updatedReportBuilderInfo.appliedMeasures = measureColumns?.map((measure: IColumn) => setDrilldownEnableFlag(measure)) || [];
      state.updatedReportBuilderInfo.linkedReportsConfig = reportConfig?.Visualization?.LinkedReportsConfig || [];

      state.updatedReportBuilderInfo.sortState = [...(action.payload.ReportConfig.Sorting ?? [])];
      state.updatedReportBuilderInfo.calculatedColumns = new Set<string>((reportConfig.CalculatedColumns ?? []).map((c) => c.Alias));
      state.filterBuilder.filterMetaInfo = action.payload.FilterMetaInfo;
      if (!isValidObjectAndNotEmpty(reportConfig?.Builder[0]?.Filter)) {
        if (reportConfig.Details?.Title && reportConfig?.Details?.Description) {
          state.assortedInfo.isFormDisabled = false;
        }
      } else {
        state.assortedInfo.isFormDisabled = true;
      }
      state.assortedInfo.settings = action.payload.Settings;
      state.reportQueryBuilder.DataSourceMapping = {
        ...state.reportQueryBuilder.DataSourceMapping,
        [ROOT_QUERY_KEY]: {
          Joins: reportConfig?.Builder[0]?.Joins,
          PrimaryNamespace: reportConfig?.Builder[0]?.Namespace,
          JoinBlockIndexBeingEdited: 0,
          isEditMode: false,
          isDataSourceSaved: false,
        },
      };
      state.reportQueryBuilder.DataSourceMappingPayload = cloneDeep(state.reportQueryBuilder.DataSourceMapping);
    },
    [ReportBuilderActions.UPDATE_SELECTED_TAB]: (state: IReportBuilderState, action: PayloadAction<string>) => {
      state.assortedInfo.selectedTabInfo = action.payload;
    },
    [ReportBuilderActions.UPDATE_REPORT_TEMPLATE_DETAIL]: (state: IReportBuilderState, action: PayloadAction<IDetails>) => {
      const { Title, Description } = action.payload;
      state.assortedInfo.isFormDisabled = getIsReportBuilderSaveFormDisable(Title, Description, state)
            || getIsFilterFormDisable(state.filterBuilder);
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Details = action.payload;
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.DisplayName = Title;
    },
    [ReportBuilderActions.UPDATE_VISUALIZATION]: (state: IReportBuilderState, action: PayloadAction<IUpdateVisualizationPayload>) => {
      const { type, attributes } = action.payload;
      const { Title, Description } = state.updatedReportBuilderInfo.reportBuilderSavePayload.Details;
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.Type = type;
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.Builder = {
        ...state.updatedReportBuilderInfo.reportBuilderSavePayload
          .Visualization.Builder,
        Properties: { ...attributes },
      };
      state.assortedInfo.isFormDisabled = getIsReportBuilderSaveFormDisable(Title, Description, state)
            || getIsFilterFormDisable(state.filterBuilder);
    },
    [ReportBuilderActions.INITIALIZE_COMBO_CONFIG]: (state: IReportBuilderState, action: PayloadAction<{ measures: ReportResponseModel.IColumn[]; dimensions: Array<{ Id: string }>; styleConfig: any }>) => {
      const { measures, dimensions, styleConfig } = action.payload;
      const comboConfig = measures.map((m, i) => ({
        columnId: m.Id,
        displayType: ComboDisplayType.Line,
        columnAlignment: ComboAxisAlignment.Auto,
        color: (styleConfig?.Colors?.[i]) || ChartDefaultcolors[i % ChartDefaultcolors.length],
      }));
      const builder = state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.Builder as ReportResponseModel.IChartVisualizationBuilder;
      builder.ComboConfig = comboConfig;
      if (!builder.YAxis) {
        builder.YAxis = { Columns: measures.map((m) => m.Id) };
      } else {
        builder.YAxis = { ...builder.YAxis, Columns: measures.map((m) => m.Id) };
      }
      builder.XAxis = { Columns: dimensions.map((d) => d.Id) };
    },
    [ReportBuilderActions.UPDATE_COMBO_MEASURE_CONFIG]: (state: IReportBuilderState, action: PayloadAction<{ columnId: string; changes: Partial<ReportResponseModel.IComboMeasureConfig> }>) => {
      const { columnId, changes } = action.payload;
      const builder = state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.Builder as ReportResponseModel.IChartVisualizationBuilder;
      if (!builder.ComboConfig) return;
      const idx = builder.ComboConfig.findIndex((c) => c.columnId === columnId);
      if (idx !== -1) {
        builder.ComboConfig[idx] = { ...builder.ComboConfig[idx], ...changes };
      }
    },
    [ReportBuilderActions.ADD_COMBO_YAXIS_COLUMN]: (state: IReportBuilderState, action: PayloadAction<ReportResponseModel.IColumn>) => {
      const measure = action.payload;
      const builder = state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.Builder as ReportResponseModel.IChartVisualizationBuilder;
      if (!builder.ComboConfig) builder.ComboConfig = [];
      if (!builder.YAxis) builder.YAxis = { Columns: [] };
      if (!builder.YAxis.Columns.includes(measure.Id)) {
        builder.YAxis.Columns.push(measure.Id);
        builder.ComboConfig.push({
          columnId: measure.Id,
          displayType: ComboDisplayType.Line,
          columnAlignment: ComboAxisAlignment.Auto,
          color: ChartDefaultcolors[(builder.ComboConfig.length - 1) % ChartDefaultcolors.length],
        });
      }
    },
    [ReportBuilderActions.REMOVE_COMBO_YAXIS_COLUMN]: (state: IReportBuilderState, action: PayloadAction<string>) => {
      const columnId = action.payload;
      const builder = state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.Builder as ReportResponseModel.IChartVisualizationBuilder;
      if (builder.YAxis) {
        builder.YAxis.Columns = builder.YAxis.Columns.filter((id) => id !== columnId);
      }
      if (builder.ComboConfig) {
        builder.ComboConfig = builder.ComboConfig.filter((c) => c.columnId !== columnId);
      }
    },
    [ReportBuilderActions.ADD_COMBO_XAXIS_COLUMN]: (state: IReportBuilderState, action: PayloadAction<{ Id: string }>) => {
      const dimension = action.payload;
      const builder = state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.Builder as ReportResponseModel.IChartVisualizationBuilder;
      if (!builder.XAxis) builder.XAxis = { Columns: [] };
      if (!builder.XAxis.Columns.includes(dimension.Id)) {
        builder.XAxis.Columns.push(dimension.Id);
      }
    },
    [ReportBuilderActions.REMOVE_COMBO_XAXIS_COLUMN]: (state: IReportBuilderState, action: PayloadAction<string>) => {
      const columnId = action.payload;
      const builder = state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.Builder as ReportResponseModel.IChartVisualizationBuilder;
      if (builder.XAxis) {
        builder.XAxis.Columns = builder.XAxis.Columns.filter((id) => id !== columnId);
      }
    },
    [ReportBuilderActions.CLEAR_COMBO_CONFIG]: (state: IReportBuilderState) => {
      const builder = state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.Builder as ReportResponseModel.IChartVisualizationBuilder;
      builder.ComboConfig = undefined;
      builder.XAxis = undefined;
      builder.YAxis = undefined;
    },
    [ReportBuilderActions.UPDATE_PAGINATION]: (state: IReportBuilderState, action: PayloadAction<IPaging>) => {
      const { PageIndex, PageSize } = action.payload;
      const { Title, Description } = state.updatedReportBuilderInfo.reportBuilderSavePayload.Details;
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Paging.PageIndex = PageIndex;
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Paging.PageSize = PageSize;
      state.assortedInfo.isFormDisabled = getIsReportBuilderSaveFormDisable(Title, Description, state)
            || getIsFilterFormDisable(state.filterBuilder);
    },
    [ReportBuilderActions.RESET_REPORT_TEMPLATE]: (state:IReportBuilderState) => {
      const updatedInitialState = {
        ...initialReportBuilderState,
        assortedInfo: {
          ...initialReportBuilderState.assortedInfo,
          reportBuilderSaveStatus: state.assortedInfo.reportBuilderSaveStatus, // we want to keep the updated status for enabling toast notification on redirection
        },
      };
      return { ...updatedInitialState };
    },
    [ReportBuilderActions.SET_DIMENSIONS_GROUPING]: (state:IReportBuilderState, action: PayloadAction<ISetGroupingPayload>) => getStateOnSetGrouping(state, action.payload),
    [ReportBuilderActions.SET_DIMENSIONS_BINNING]: (state:IReportBuilderState, action: PayloadAction<ISetDimensionsBinningPayload>) => getStateOnBinningChange(state, action.payload),
    [ReportBuilderActions.ADD_MEASURE]: (state:IReportBuilderState, action: PayloadAction<IAddMeasurePayload>) => getStateOnAddMeasure(state, action.payload),
    [ReportBuilderActions.REM_MEASURE]: (state:IReportBuilderState, action: PayloadAction<IRemoveMeasurePayload>) => getStateOnRemoveMeasure(state, action.payload),
    [ReportBuilderActions.MOV_MEASURE]: (state:IReportBuilderState, action: PayloadAction<IMoveMeasurePayload>) => getStateOnMoveMeasure(state, action.payload),
    [ReportBuilderActions.SET_MEASURE]: (state:IReportBuilderState, action: PayloadAction<ISetMeasurePayload>) => getStateOnUpdateMeasure(state, action.payload),
    [ReportBuilderActions.UPDATE_SAVE_REPORT_BUILDER_STATUS]: (state: IReportBuilderState, action: PayloadAction<ReportBuilderSaveStatus>) => {
      state.assortedInfo.reportBuilderSaveStatus = action.payload;
    },
    [ReportBuilderActions.SORT_COLUMN]: (state: IReportBuilderState, action: PayloadAction<ISortColumnPayload>) => {
      const { updatedReportBuilderInfo: reportBuilder } = state;
      const [sortState, hasChanged] = sortColumns(
        reportBuilder.sortState,
        reportBuilder.appliedDimensions,
        reportBuilder.appliedMeasures,
        action.payload.columnType,
        action.payload.columnName,
        action.payload.order,
        action.payload.multiSort,
        action.payload.Id,
        [],
        false,
        isListReport(reportBuilder?.reportBuilderSavePayload?.Builder[0]?.Type),
      );
      if (!hasChanged) return;
      state.updatedReportBuilderInfo.sortState = sortState;
    },
    [ReportBuilderActions.ADD_OR_UPDATE_CUSTOM_EXPRESSION]: (state: IReportBuilderState, action: PayloadAction<{customExpression:ICustomExpression, isDrilldownBlocked?: boolean}>) => {
      const customExp = action.payload.customExpression;
      const uniqueId = customExp.uniqueId;
      const newMeasure = buildCustomMeasure(customExp.displayName, customExp.Mode, customExp.jsonExpression, uniqueId, customExp?.Formatter, customExp.DataType, undefined, undefined, customExp?.description);
      const expressionType = customExp.ExpressionType;
      const updatedAppliedMeasures = state.updatedReportBuilderInfo.appliedMeasures;
      let updatedAppliedDimensions = state.updatedReportBuilderInfo.appliedDimensions;
      const rowGroupingDimensions = state.updatedReportBuilderInfo.appliedDimensions.filter(
        (dim) => dim?.DimensionMode !== DimensionMode.ColumnGroup
      && dim?.Applied !== DimensionStatus.NotApplied,
      );
      const isReportListType = isListReport(state?.updatedReportBuilderInfo?.reportBuilderSavePayload?.Builder[0]?.Type);
      const destIndex = rowGroupingDimensions.length;

      let newExpression: IColumn| IDimension;
      let editMode = false;
      if (state?.updatedReportBuilderInfo?.expressionStore && state.updatedReportBuilderInfo.expressionStore[uniqueId]) {
        editMode = true;
      }

      switch (expressionType) {
        case ExpressionContext.Measure: {
          const defaultEntity = getDefaultEntity(state?.updatedReportBuilderInfo?.selectedTemplate?.ReportConfig);
          const fieldsData = fieldSelectors({ reportBuilder: state } as IGlobalState);
          const editedCustIndex = updatedAppliedMeasures.findIndex((mes) => mes.BuilderConfig?.uniqueKey === uniqueId);
          const originalCustomMeasure = updatedAppliedMeasures[editedCustIndex];
          newExpression = withDescription(
            buildCustomMeasure(customExp.displayName, customExp.Mode, customExp.jsonExpression, uniqueId, customExp?.Formatter, customExp.DataType, undefined, undefined, customExp?.description),
            customExp.description,
          );
          if (editMode) {
            if (customExp.Mode === ColumnModes.Sortable || customExp.Mode === ColumnModes.Hidden) {
              updatedAppliedMeasures[editedCustIndex] = newExpression as IColumn;
            }

            if (originalCustomMeasure.Props.DrilldownEnabled) {
              const { newConfigMapping, newConfigColumns } = handleCustExpUpdateForDrilldownMapper(originalCustomMeasure, newExpression, state.updatedReportBuilderInfo.drilldownConfigInfo, defaultEntity, fieldsData);
              state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping = newConfigMapping;
              state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig = newConfigColumns;
            }
          } else {
            updatedAppliedMeasures.push(newExpression as IColumn);
            if (newExpression.Props?.DrilldownEnabled) {
              state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping = groupByJoinIdAndEntity(
                state?.reportBuilderInfo.fields,
                newMeasure,
                state?.updatedReportBuilderInfo?.drilldownConfigInfo?.drilldownConfigMapping,
                state?.updatedReportBuilderInfo?.appliedMeasures,
                defaultEntity,
              );
            }
          }

          break;
        }
        case ExpressionContext.Dimension:
          newExpression = withDescription(
            buildCustomDimension(customExp.displayName, customExp.Mode, customExp.jsonExpression, uniqueId, customExp.DataType, customExp?.dimensionType, customExp?.description),
            customExp.description,
          );
          if (editMode) {
            const editedCustIndex = updatedAppliedDimensions.findIndex((dim) => dim.BuilderConfig?.uniqueKey === uniqueId);
            if (editedCustIndex !== -1) {
              updatedAppliedDimensions[editedCustIndex] = withDescription({
                ...updatedAppliedDimensions[editedCustIndex],
                Expression: newExpression?.Expression,
                BuilderConfig: { ...newExpression?.BuilderConfig },
                Name: newExpression.Name,
              }, customExp.description);
              updatedAppliedDimensions = reorderAppliedDimensions(updatedAppliedDimensions);
            }
          } else {
            state.updatedReportBuilderInfo.expressionStore[uniqueId] = customExp;
            updatedAppliedDimensions.splice(destIndex, 0, newExpression);
          }

          break;

        case ExpressionContext.Custom:
          /**
       * The below code is to handle the case where the custom column is added to the list report.
       * Since custom columns are editable in list reports and the have `ExpressionType` set to `Custom`, we explicitly need to handle the case where the custom column
       * is added to grouping in the list report mainly for name updates.
       */
          if (isReportListType) {
            if (editMode) {
              customExp.Formatter = null;
              newExpression = buildCustomDimension(customExp.displayName, customExp.Mode, customExp.jsonExpression, uniqueId, customExp.DataType, customExp?.dimensionType, customExp?.description);
              const editedCustIndex = updatedAppliedDimensions.findIndex((dim) => dim.BuilderConfig?.uniqueKey === uniqueId);
              if (editedCustIndex !== -1) {
                updatedAppliedDimensions[editedCustIndex] = {
                  ...updatedAppliedDimensions[editedCustIndex],
                  Expression: newExpression?.Expression,
                  BuilderConfig: { ...updatedAppliedDimensions[editedCustIndex]?.BuilderConfig, DisplayName: newExpression.Name },
                  Name: newExpression.Name,
                };
                updatedAppliedDimensions = reorderAppliedDimensions(updatedAppliedDimensions);
              }
            }
          }
          break;
        default:
      }

      state.updatedReportBuilderInfo.appliedMeasures = updatedAppliedMeasures;
      state.updatedReportBuilderInfo.appliedDimensions = updatedAppliedDimensions;
      state.updatedReportBuilderInfo.expressionStore[uniqueId] = customExp;

      const editedCustomColumn = updatedAppliedDimensions.find((col) => col.BuilderConfig?.uniqueKey === uniqueId)
        || updatedAppliedMeasures.find((col) => col.BuilderConfig?.uniqueKey === uniqueId);
      if (editMode && editedCustomColumn?.Props) {
        editedCustomColumn.Props.Description = customExp.description;
      }
    },
    [ReportBuilderActions.DELETE_CUSTOM_EXPRESSION]: (state: IReportBuilderState, action: PayloadAction<string | number>) => {
      const uniqueId = action.payload;

      let updatedAdditionalMeasures = state.reportBuilderInfo.additionalMeasures;
      updatedAdditionalMeasures = isValidArrayAndNotEmpty(updatedAdditionalMeasures) && updatedAdditionalMeasures.filter((measure:IColumn) => measure.BuilderConfig?.uniqueKey !== uniqueId);
      const newExpressionStore = { ...state?.updatedReportBuilderInfo?.expressionStore };
      delete newExpressionStore[uniqueId];
      state.reportBuilderInfo.additionalMeasures = updatedAdditionalMeasures;
      state.updatedReportBuilderInfo.expressionStore = newExpressionStore;
    },
    [ReportBuilderActions.SUBQUERY_DELETE_CUSTOM_EXPRESSION]: (state: IReportBuilderState, action: PayloadAction<string | number>) => {
      const uniqueId = action.payload;
      const selectedQuery = state.reportQueryBuilder.SelectedQuery;
      if (selectedQuery) {
        // Remove from expression store in SelectedQueryData
        const queryData = state.reportQueryBuilder.SelectedQueryData;
        const newExpressionStore = { ...queryData.updatedInfo.ExpressionStore };
        delete newExpressionStore[uniqueId];
        state.reportQueryBuilder.SelectedQueryData.updatedInfo.ExpressionStore = newExpressionStore;

        // Remove from expression store in DynamicQueryList
        const dynamicQueryIndex = state.reportQueryBuilder.DynamicQueryList.findIndex((query) => query.Id === selectedQuery);
        if (dynamicQueryIndex !== -1) {
          const queryDataInfo = state.reportQueryBuilder.DynamicQueryList[dynamicQueryIndex]?.QueryDataInfo;
          if (queryDataInfo) {
            const dynamicQueryExpressionStore = { ...queryDataInfo.updatedInfo.ExpressionStore };
            delete dynamicQueryExpressionStore[uniqueId];
            state.reportQueryBuilder.DynamicQueryList[dynamicQueryIndex].QueryDataInfo.updatedInfo.ExpressionStore = dynamicQueryExpressionStore;
          }
        }
      }
    },
    [ReportBuilderActions.COMBINE_RAW_AND_RENDER_CONFIG]: (state: IReportBuilderState) => {
      const updatedConfig = getCombinedReportConfig(state.reportEditInfo.rawReportConfig, state.reportEditInfo.renderReportConfig);
      state.updatedReportBuilderInfo.selectedTemplate.ReportConfig = updatedConfig;
      state.updatedReportBuilderInfo.sortState = state.reportEditInfo.rawReportConfig.Sorting ?? [];
      state.updatedReportBuilderInfo.customHierarchies = state.reportEditInfo.rawReportConfig.Builder?.[0]?.CustomHierarchies ?? [];
      const appliedDimensions = getAppliedDimensions(state, updatedConfig, state?.reportEditInfo?.renderReportConfig?.Filters);
      state.updatedReportBuilderInfo.appliedDimensions = appliedDimensions;
      const appliedMeasures = getMeasureColumns(updatedConfig, true);
      state.updatedReportBuilderInfo.appliedMeasures = appliedMeasures?.map((measure: IColumn) => setDrilldownEnableFlag(measure)) || [];
      state.updatedReportBuilderInfo.reportBuilderSavePayload = { ...state.reportEditInfo.rawReportConfig, FiltersMetadata: state?.reportEditInfo?.renderReportConfig?.FiltersMetadata };
      state.filterBuilder.customFilterDefinitions = state.reportEditInfo.rawReportConfig.CustomFilterDefinitions ?? [];

      // Resolve custom filter defaults from SubBuilder constituent filters.
      // The render config does not include SubBuilder filters, so custom filters
      // with only SubBuilder constituents are initialized with a fallback default.
      const resolvedDefaults = resolveSubBuilderCustomFilterDefaults(
        state.filterBuilder.customFilterDefinitions,
        state.reportEditInfo.rawReportConfig.SubBuilders,
      );
      Object.entries(resolvedDefaults).forEach(([cfId, defaultValue]) => {
        if (state.filterBuilder.appliedFilters?.[cfId]) {
          state.filterBuilder.appliedFilters[cfId].FilterResponse = defaultValue;
        }
        const cfEntry = state.filterBuilder.filterConfig?.find((f) => f.ID === cfId);
        if (cfEntry) {
          cfEntry.DefaultValue = defaultValue;
        }
      });

      // Rebuild custom-filter wrappers with SubBuilders available so dropdown wrappers
      // whose FilterKey constituent lives in a subquery (not main Filters) pick up the
      // correct schema (LOS-ness, Metadata.FilterKey, LinkedTo). getReportRenderConfig
      // couldn't resolve these because the render config doesn't include SubBuilders.
      // Then re-init appliedFilters[wrapperId] so shouldLoad flips back to true and the
      // auto-loader re-fires getReportBuilderFiltersLoad with the now-correct wrapper.
      const rawSubBuilders = state.reportEditInfo.rawReportConfig?.SubBuilders;
      const customFilterDefs = state.filterBuilder.customFilterDefinitions;
      if (isValidArrayAndNotEmpty(customFilterDefs) && isValidArrayAndNotEmpty(rawSubBuilders) && isValidArrayAndNotEmpty(state.filterBuilder.filterConfig)) {
        const rebuilt = buildCustomFiltersFromDefinitions(
          customFilterDefs,
          state.filterBuilder.filterConfig,
          rawSubBuilders,
        );
        const cfIds = new Set(customFilterDefs.map((d) => d.ID));
        const rebuiltById = new Map(rebuilt.filter((f) => cfIds.has(f.ID)).map((w) => [w.ID, w] as const));
        state.filterBuilder.filterConfig = state.filterBuilder.filterConfig.map((f) => {
          if (!cfIds.has(f.ID)) return f;
          const r = rebuiltById.get(f.ID);
          return r ? { ...r, DefaultValue: f.DefaultValue } : f;
        });

        const fetchFilter = new FilterFetchUtility(null);
        state.filterBuilder.filterConfig.forEach((f) => {
          if (!cfIds.has(f.ID)) return;
          let value: any = f.DefaultValue;
          if (f.Type === FilterType.UserMultiSelect) {
            value = {
              Type: f?.DropdownMetaData?.DropdownSelectType || UserFilterPayloadType.All,
              UserIds: f.DefaultValue,
            };
          }
          const refreshed = fetchFilter.GetDefaultSingleFilter(f, value);
          state.filterBuilder.appliedFilters[f.ID] = { ...refreshed, label: f.Label };
        });
      }

      state.updatedReportBuilderInfo.calculatedColumns = new Set<string>((updatedConfig?.CalculatedColumns ?? []).map((column) => column.Alias));
      state.updatedReportBuilderInfo.expressionStore = getExpressionStoreFromConfig(updatedConfig, state?.updatedReportBuilderInfo?.expressionStore);
      state.updatedReportBuilderInfo.entityGroupStore = generateEntityStore(appliedDimensions, state?.updatedReportBuilderInfo?.entityGroupStore);
      state.updatedReportBuilderInfo.conditionalFormatting = updatedConfig.Visualization?.ConditionalFormatting ?? { Enabled: true, Rules: [] };
      state.updatedReportBuilderInfo.linkedReportsConfig = updatedConfig.Visualization?.LinkedReportsConfig ?? [];
      state.reportEditInfo.combineConfigLoaded = true;
      state.assortedInfo.isFormDisabled = false;
      state.assortedInfo.isReportDataSourceSaved = true;
      const subBuilders = updatedConfig.SubBuilders;
      const joinsList = updatedConfig.Builder[0].Joins;
      state.reportQueryBuilder.DataSourceMapping = {
        ...state.reportQueryBuilder.DataSourceMapping,
        [ROOT_QUERY_KEY]: {
          Joins: updatedConfig.Builder[0]?.Joins,
          PrimaryNamespace: updatedConfig.Builder[0]?.Namespace,
          JoinBlockIndexBeingEdited: 0,
          isEditMode: false,
          isDataSourceSaved: false,
        },
      };
      const shouldPopulateSubBuilderDetails = joinsList?.some((joinsConfig) => joinsConfig.IsCTE) || updatedConfig.Builder[0].Source === QuerySourceType.Query;
      if (subBuilders?.length > 0 && shouldPopulateSubBuilderDetails) {
        populateSubQueryDetailsFromConfig(state, updatedConfig);
      }
    },
    [ReportBuilderActions.SET_REPORT_EDIT_ID]: (state:IReportBuilderState, action:PayloadAction<string>) => {
      state.assortedInfo.reportId = action.payload;
      state.reportEditInfo.isEditing = true;
    },
    [ReportBuilderActions.SET_TEMPORARY_REPORT_ID]: (state:IReportBuilderState, action:PayloadAction<string>) => {
      state.reportEditInfo.temporaryReportId = action.payload;
    },
    [ReportBuilderActions.INITIAL_SAVE_TEMPLATE]: (state:IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.INITIAL_SAVE_TEMPLATE] = APIRequestStatus.Processing;
    },
    [ReportBuilderActions.SET_INITIAL_SUCCESS_STATE]: (state:IReportBuilderState, action: PayloadAction<{reportId:string, variables: IVariables}>) => {
      state.requestProcessing[ReportBuilderActions.INITIAL_SAVE_TEMPLATE] = APIRequestStatus.Success;
      state.updatedReportBuilderInfo.selectedTemplate.ReportConfig = getUpdatedPayloadAfterInitialSave(
        state,
        action.payload.reportId,
      );
      state.updatedReportBuilderInfo.reportBuilderSavePayload = getUpdatedPayloadAfterInitialSave(
        state,
        action.payload.reportId,
      );
      state.previewBackUpInfo.filterBuilder = state.filterBuilder;
      state.previewBackUpInfo.updatedReportBuilderInfo = state.updatedReportBuilderInfo;
      state.assortedInfo.reportId = action.payload.reportId;

      state.filterBuilder.filterConfig = getFilterConfigFromTemplate(state.updatedReportBuilderInfo.reportBuilderSavePayload, state.filterBuilder.filterMetaInfo);
      state.filterBuilder.filterConfig = getUpdatedReportFilterConfig(state.filterBuilder.filterConfig);
      state.filterBuilder.appliedFilters = getAppliedFilterFromTemplate(state, action.payload.variables);
    },
    [ReportBuilderActions.SET_INITIAL_FAILURE_STATE]: (state:IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.INITIAL_SAVE_TEMPLATE] = APIRequestStatus.Failure;
    },
    [ReportBuilderActions.GET_PREVIEW_DATA]: (state:IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_PREVIEW_DATA] = APIRequestStatus.Processing;
    },
    [ReportBuilderActions.SET_PREVIEW_DATA_SUCCESS_STATE]: (state: IReportBuilderState, action: PayloadAction<{ res: IPanelDataResponse, isInitialLoad?: boolean }>) => {
      const response = cloneDeep(action.payload.res);
      updateColumnsDisplayName(response?.Visualization?.Columns);
      state.previewData.data = response;
      state.previewData.error = null;
      state.previewData.mappedMetaFields = getMappedMetaFields(
        response.Visualization.Columns,
        response?.Raw?.Data,
      );
      if (action.payload?.isInitialLoad) {
        state.updatedReportBuilderInfo.appliedMeasures = isValidArrayAndNotEmpty(state?.updatedReportBuilderInfo?.appliedMeasures) ? state.updatedReportBuilderInfo.appliedMeasures.map((measure: IColumn) => {
          if (measure?.Props?.Measure?.IsPreDefined) {
            const selectedMeasure = response.Visualization.Columns.find((col: IColumn) => col.Id === measure.Id);
            measure.Props.DrilldownEnabled = measure.Props?.AllowDrillDown;
            measure.Props.Measure.Entity = selectedMeasure?.Props?.Measure?.Entity;
            measure.Props.Measure.JoinID = selectedMeasure?.Props?.Measure?.JoinID;
            return measure;
          }
          return measure;
        }) : [];
        state.reportBuilderInfo.additionalMeasures = isValidArrayAndNotEmpty(state?.reportBuilderInfo.additionalMeasures) ? state.reportBuilderInfo.additionalMeasures.map((measure: IColumn) => {
          if (measure?.Props?.Measure?.IsPreDefined) {
            const selectedMeasure = response?.Visualization?.Columns?.find((col: IColumn) => col.Id === measure.Id);
            measure.Props.DrilldownEnabled = measure.Props?.AllowDrillDown;
            measure.Props.Measure.Entity = selectedMeasure?.Props?.Measure?.Entity;
            measure.Props.Measure.JoinID = selectedMeasure?.Props?.Measure?.JoinID;
            return measure;
          }
          return measure;
        }) : [];
      }
      state.previewBackUpInfo.filterBuilder = state.filterBuilder;
      // The below line is to re-instate the conditional formatting from the report builder save payload to the conditional formatting state.
      state.updatedReportBuilderInfo.conditionalFormatting = state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization?.ConditionalFormatting;
      state.previewBackUpInfo.updatedReportBuilderInfo = state.updatedReportBuilderInfo;
      state.requestProcessing[ReportBuilderActions.GET_PREVIEW_DATA] = APIRequestStatus.Success;
    },
    [ReportBuilderActions.SET_PREVIEW_DATA_FAILURE_STATE]: (state:IReportBuilderState, action: PayloadAction<ObjModel.Obj>) => {
      state.requestProcessing[ReportBuilderActions.GET_PREVIEW_DATA] = APIRequestStatus.Failure;
      state.previewData.error = action.payload?.error || null;
    },
    [ReportBuilderActions.ADD_DRILLDOWN_CONFIGURATION]: (state: IReportBuilderState, action:PayloadAction<{id: string}>) => {
      const emptyDrilldownConfigExists = Object.keys(state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping).find((item: any) => state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping[item].length < 1);

      if (!emptyDrilldownConfigExists) {
        state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping = {
          ...state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping,
          [action.payload.id]: [],
        };
      }
    },
    [ReportBuilderActions.ADD_DRILLDOWN_MEASURE]: (state:IReportBuilderState, action: PayloadAction<{data: IColumn, key: string}>) => {
      const drilldownMeasures = cloneDeep(state?.updatedReportBuilderInfo?.drilldownConfigInfo?.drilldownConfigMapping[action.payload.key]) || [];
      const data = action.payload.data;
      if (!drilldownMeasures?.some((measure: MeasureListWithJoinId) => measure?.Id === data?.Id)) {
        drilldownMeasures.push({
          Id: data.Id, Name: data?.Props?.Measure?.Name, JoinId: data?.Props?.Measure?.JoinID || drilldownMeasures[0]?.JoinId || '', Entity: drilldownMeasures[0]?.Entity,
        });
        state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping[action.payload.key] = drilldownMeasures;
        state.updatedReportBuilderInfo.appliedMeasures = state?.updatedReportBuilderInfo?.appliedMeasures?.map((measure: IColumn) => {
          if (drilldownMeasures?.some((col: MeasureListWithJoinId) => col?.Id === measure?.Id)) {
            measure.Props.DrilldownEnabled = true;
          }
          return measure;
        });
      }
    },
    [ReportBuilderActions.REMOVE_DRILLDOWN_ACCORD]: (state:IReportBuilderState, action: PayloadAction<string>) => {
      const { drilldownConfigMapping, drilldownColumnConfig } = state.updatedReportBuilderInfo.drilldownConfigInfo || {};
      state.updatedReportBuilderInfo.appliedMeasures = state?.updatedReportBuilderInfo?.appliedMeasures?.map((measure: IColumn) => {
        if (drilldownConfigMapping[action.payload]?.some((col: MeasureListWithJoinId) => col?.Id === measure?.Id)) {
          measure.Props.DrilldownEnabled = false;
        }
        return measure;
      });
      delete drilldownConfigMapping[action.payload];
      delete drilldownColumnConfig[action.payload];
      state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping = drilldownConfigMapping;
      state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig = drilldownColumnConfig;
    },
    [ReportBuilderActions.REMOVE_DRILLDOWN_MEASURE]: (state:IReportBuilderState, action: PayloadAction<{id: string, key: string}>) => {
      const drilldownConfigItem = state.updatedReportBuilderInfo?.drilldownConfigInfo?.drilldownConfigMapping?.[action.payload.key] || [];
      const removedMeasure = [...drilldownConfigItem]?.find((measure) => measure?.Id === action.payload.id);
      const drilldownMeasures = [...drilldownConfigItem].filter((measure) => measure?.Id !== action.payload.id);
      state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping[action.payload.key] = drilldownMeasures;
      state.updatedReportBuilderInfo.appliedMeasures = state?.updatedReportBuilderInfo?.appliedMeasures?.map((measure: IColumn) => {
        if (removedMeasure?.Id === measure?.Id) {
          measure.Props.DrilldownEnabled = false;
        }
        return measure;
      });
    },

    [ReportBuilderActions.INIT_DRILLDOWN_MAPPING]: (state: IReportBuilderState) => {
      if (isEmpty(state?.updatedReportBuilderInfo?.drilldownConfigInfo?.drilldownConfigMapping)) {
        state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping = getDrilldownMapping(state?.updatedReportBuilderInfo?.appliedMeasures || [], state);
      } else {
        const firstDrilldownKey = Object.keys(state?.updatedReportBuilderInfo?.drilldownConfigInfo?.drilldownConfigMapping)[0];
        const firstDrilldownValue = state?.updatedReportBuilderInfo?.drilldownConfigInfo?.drilldownConfigMapping[firstDrilldownKey];
        if (isString(firstDrilldownValue[0])) { // check if structure of value is ["measureName1","measureName2"] and convert to {Name:"measureName",Id:"measureId",JoinId:"measureJoinId",Entity:"measureEntity"}
          state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping = convertDrilldownMappingIntoIdMapping(state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping, state?.updatedReportBuilderInfo?.appliedMeasures);
        }
      }

      state.updatedReportBuilderInfo.drilldownConfigInfo.enableDrilldown = state?.updatedReportBuilderInfo?.appliedMeasures?.some((measure: IColumn) => (Object.prototype.hasOwnProperty.call(measure?.Props, 'DrilldownEnabled') ? measure?.Props?.DrilldownEnabled : false));

      const newMapper: DrilldownConfigMapping = {};
      Object.keys(state?.updatedReportBuilderInfo?.drilldownConfigInfo?.drilldownConfigMapping || {})?.forEach((key) => {
        const measureInfo = state?.updatedReportBuilderInfo?.appliedMeasures?.find((measure:IColumn) => measure?.Id === state?.updatedReportBuilderInfo?.drilldownConfigInfo?.drilldownConfigMapping[key]?.[0]?.Id);
        newMapper[key] = state?.updatedReportBuilderInfo?.drilldownConfigInfo?.drilldownConfigMapping[key]?.map((measure: MeasureListWithJoinId) => {
          let entity = measureInfo?.Props?.Measure?.Entity;
          let joinId = measureInfo?.Props?.Measure?.JoinID;
          if (measureInfo?.Props?.Measure?.IsCustomExpression || measureInfo?.Props?.IsSourceCustomColumn) {
            const defaultEntity = getDefaultEntity(state?.updatedReportBuilderInfo?.selectedTemplate?.ReportConfig);
            const fieldsData = fieldSelectors({ reportBuilder: state } as IGlobalState);
            const { Entity, JoinId } = getEntityJoinIdForCustomMeasure(fieldsData || [], measureInfo, defaultEntity);
            entity = Entity;
            joinId = JoinId;
          }
          return {
            ...measure,
            JoinId: joinId || '',
            Entity: entity || '',
          };
        });
      });
      state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping = newMapper;
    },
    [ReportBuilderActions.SORT_DRILLDOWN_COLUMN]: (state: IReportBuilderState, action: PayloadAction<ISortDrilldownColumnPayload>) => {
      const { key } = action.payload;
      state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig[key].sortState = sortDrilldownColumns(state, action.payload);
    },
    [ReportBuilderActions.ADD_REMOVE_DRILLDOWN_FIELD]: (state: IReportBuilderState, action: PayloadAction<DrilldownFieldUpdationsAction>) => {
      state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig[action.payload.groupingId] = getUpdatedDrilldownColConfig(state, action.payload);
    },
    [ReportBuilderActions.UPDATE_DRILLDOWN_COLUMN]: (state:IReportBuilderState, action: PayloadAction<{
      index: number;
      newMeasure: IColumn;
      key: string;
    }>) => {
      state.updatedReportBuilderInfo.drilldownConfigInfo = getStateOnUpdateDrilldownColumn(state?.updatedReportBuilderInfo?.drilldownConfigInfo, action.payload);
    },
    [ReportBuilderActions.MOVE_DRILLDOWN_COLUMN]: (state:IReportBuilderState, action: PayloadAction<{startElement:IColumn;
      endElement:IColumn;
      key: string;}>) => {
      state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig = {
        ...state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig,
        [action.payload.key]: {
          ...state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig[action.payload.key],
          defaultColumns: getStateOnMoveColumns(state?.updatedReportBuilderInfo?.drilldownConfigInfo?.drilldownColumnConfig, action.payload),
        },
      };
    },
    [ReportBuilderActions.TOGGLE_DRILLDOWN]: (state:IReportBuilderState) => {
      const isEnabled = !state.updatedReportBuilderInfo.drilldownConfigInfo.enableDrilldown;
      const calculatedMeasuresList = state.updatedReportBuilderInfo.selectedTemplate.ReportConfig.CalculatedColumns;
      const isCalculated = fromPairs((calculatedMeasuresList || []).map((column) => [column?.Alias, true]));
      const builderMeasuresList = state.updatedReportBuilderInfo.reportBuilderSavePayload?.Builder[0]?.Select?.Measures || [];
      const updatedAppliedColumns = state?.updatedReportBuilderInfo?.appliedMeasures?.map((measure: IColumn) => {
        let expr = measure?.Props?.Measure?.Expression;
        if (!expr) {
          const currentMeasure = builderMeasuresList.find((builderMeasure: IBuilderMeasure) => builderMeasure.Alias === measure.Name);
          expr = currentMeasure?.MeasureExpression;
        }
        measure.Props.DrilldownEnabled = isCalculated[measure.Name] || !isDrilldownPossible(expr) ? false : !!isEnabled;
        return measure;
      });

      const filteredAppliedMeasures = updatedAppliedColumns.filter((col: IColumn) => !isCalculated[col.Name]);
      state.updatedReportBuilderInfo.appliedMeasures = updatedAppliedColumns;
      state.updatedReportBuilderInfo.drilldownConfigInfo.enableDrilldown = isEnabled;
      if (isEnabled) {
        state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping = getDrilldownMapping(filteredAppliedMeasures, state);
      } else {
        state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping = {};
        state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig = {};
      }
    },
    [ReportBuilderActions.UPDATE_DRILLDOWN_PAGINATION]: (state: IReportBuilderState, action: PayloadAction<number>) => {
      state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownPagination.PageSize = action.payload;
    },
    [ReportBuilderActions.GET_RAW_TEMPLATE_DETAILS]: (state:IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_RAW_TEMPLATE_DETAILS] = APIRequestStatus.Processing;
    },
    [ReportBuilderActions.GET_RAW_TEMPLATE_DETAILS_SUCCESS]: (state:IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_RAW_TEMPLATE_DETAILS] = APIRequestStatus.Success;
    },
    [ReportBuilderActions.GET_RAW_TEMPLATE_DETAILS_FAILURE]: (state:IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_RAW_TEMPLATE_DETAILS] = APIRequestStatus.Failure;
    },
    [ReportBuilderActions.RESET_GET_RAW_TEMPLATE_DETAILS]: (state:IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_RAW_TEMPLATE_DETAILS] = APIRequestStatus.AboutToLoad;
    },
    [ReportBuilderActions.SWITCH_USER_FIELD_AND_FILTER]: (state: IReportBuilderState, action: PayloadAction<ISwitchUserFieldFilterPayload>) => getStateOnSwitchUserFilter(state, action.payload),

    [ReportBuilderActions.SUB_QUERY_SWITCH_USER_FIELD_AND_FILTER]: (state: IReportBuilderState, action: PayloadAction<ISwitchUserFieldFilterPayload>) => getStateOnSwitchUserFilterInSubQueryBuilder(state, action.payload),

    [ReportBuilderActions.UPDATE_DATA_SOURCE_CHANGES]: (state: IReportBuilderState, action: PayloadAction<IResetReportConfigPayload>) => {
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Builder[0].Namespace = action.payload.primaryNamespace;
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Builder[0].Joins = action.payload.joinsData;
      state.updatedReportBuilderInfo.selectedTemplate.ReportConfig.Builder[0].Namespace = action.payload.primaryNamespace;
      state.updatedReportBuilderInfo.selectedTemplate.ReportConfig.Builder[0].Joins = action.payload.joinsData;
    },
    [ReportBuilderActions.TOGGLE_DATA_SOURCE_EDIT_MODE]: (state: IReportBuilderState, action: PayloadAction<boolean>) => {
      state.assortedInfo.isDataSourceEditMode = action.payload || false;
    },
    [ReportBuilderActions.SAVE_DATA_SOURCE_CHANGES_REQUEST_RESET]: (state:IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.SAVE_DATA_SOURCE_CHANGES_REQUEST] = APIRequestStatus.AboutToLoad;
    },
    [ReportBuilderActions.SAVE_DATA_SOURCE_CHANGES_REQUEST]: (state:IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.SAVE_DATA_SOURCE_CHANGES_REQUEST] = APIRequestStatus.Processing;
    },
    [ReportBuilderActions.SAVE_DATA_SOURCE_CHANGES_FAILURE]: (state:IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.SAVE_DATA_SOURCE_CHANGES_REQUEST] = APIRequestStatus.Failure;
    },
    [ReportBuilderActions.SAVE_DATA_SOURCE_CHANGES_SUCCESS]: (state:IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.SAVE_DATA_SOURCE_CHANGES_REQUEST] = APIRequestStatus.Success;
    },
    [ReportBuilderActions.UPDATE_REPORT_METADATA_POST_JOINS_SAVE]: (state:IReportBuilderState, action: PayloadAction<ObjModel.Obj>) => {
      const title = action.payload.Title;
      const description = action.payload.Description;
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Details.Title = title;
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Details.Description = description;
      state.updatedReportBuilderInfo.drilldownConfigInfo = {
        drilldownConfigMapping: {},
        drilldownColumnConfig: {},
        enableDrilldown: true,
        drilldownPagination: defaultPageValue,
      };
      state.requestProcessing = { ...state.requestProcessing, [ReportBuilderActions.FILTER_DATA_LOAD_REQUEST]: {} };
      state.updatedReportBuilderInfo.expressionStore = {};
      state.assortedInfo.reportId = action.payload.originalReportId;
    },
    [ReportBuilderActions.UPDATE_DATA_SOURCE_SIDETRAY_STATE]: (state:IReportBuilderState, action: PayloadAction<boolean>) => {
      state.assortedInfo.isDataSourceSidetrayExpanded = action.payload;
    },
    [ReportBuilderActions.CREATE_NEW_QUERY]: (state: IReportBuilderState, action: PayloadAction<ICreateNewQueryPayload>) => createNewQuery(state, action?.payload),
    [ReportBuilderActions.TOGGLE_NESTED_QUERY_BUILDER_MODE]: (state: IReportBuilderState, action: PayloadAction<boolean>) => {
      state.assortedInfo.isNestedQueryFormOpen = action.payload;
    },
    [ReportBuilderActions.ADD_GROUPING_FOR_SUB_QUERY]: (state: IReportBuilderState, action: PayloadAction<ISetGroupingPayload>) => getStateOnSetGroupingForSubQuery(state, action.payload),
    [ReportBuilderActions.SET_DIMENSIONS_BINNING_FOR_QUERY]: (state:IReportBuilderState, action: PayloadAction<ISetDimensionsBinningPayload>) => getStateOnBinningChangeForSubQuery(state, action.payload),
    [ReportBuilderActions.ADD_MEASURE_FOR_SUB_QUERY]: (state:IReportBuilderState, action: PayloadAction<IAddMeasurePayload>) => getStateOnAddMeasureForSubQuery(state, action.payload),
    [ReportBuilderActions.REMOVE_MEASURE_FOR_SUB_QUERY]: (state:IReportBuilderState, action: PayloadAction<IRemoveMeasurePayload>) => getStateOnRemoveMeasureForSubQuery(state, action.payload),
    [ReportBuilderActions.MOVE_MEASURE_FOR_SUB_QUERY]: (state:IReportBuilderState, action: PayloadAction<IMoveMeasurePayload>) => getStateOnMoveMeasureForSubQuery(state, action.payload),
    [ReportBuilderActions.SET_MEASURE_FOR_SUB_QUERY]: (state:IReportBuilderState, action: PayloadAction<ISetMeasurePayload>) => getStateOnUpdateMeasureForSubQuery(state, action.payload),
    [ReportBuilderActions.UPDATE_DIMENSION_FOR_SUB_QUERY]: (state: IReportBuilderState, action: PayloadAction<ISetDimensionPayload>) => getStateOnUpdateDimensionForSubQuery(state, action.payload),
    [ReportBuilderActions.ADD_DYNAMIC_FILTER_IN_SUB_QUERY]: (state: IReportBuilderState, action: PayloadAction<IAddDynamicFilterPayload>) => getStateOnAddQueryDynamicFilter(state, action.payload.index),
    [ReportBuilderActions.DELETE_DYNAMIC_FILTER_IN_SUB_QUERY]: (state: IReportBuilderState, action: PayloadAction<IDeleteDynamicFilterPayload>) => getStateOnQueryDeleteDynamicFilter(state, action.payload),
    [ReportBuilderActions.SUB_QUERY_FILTER_VALUE_CHANGE]: (state: IReportBuilderState, action: PayloadAction<IFilterValueChangePayload>) => {
      const { filterId, filterValue, variables } = action.payload;
      const fetchFilter = new FilterFetchUtility(variables);
      const newAppliedFilters = state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.appliedFilters;
      let userFilterType = state.reportQueryBuilder?.SelectedQueryData?.updatedInfo?.filterBuilder?.UserDropdownSelectType ?? UserFilterPayloadType.All;

      const selectedFilterConfig = state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.filterConfig.find(
        (item: IFilterConfig) => item.ID === filterId,
      );
      if (!isEmpty(state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.filterConfig)) {
        state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.filterConfig.forEach((item) => {
          if (item.ID === filterId && item.Type === FilterType.UserMultiSelect && item.IsPrimaryUserFilter) {
            userFilterType = filterValue?.Type;
          }
          if (item.ID === filterId && newAppliedFilters[item.ID]) {
            newAppliedFilters[filterId].FilterResponse = filterValue;
          } else if (
            (item.LinkedTo && item.LinkedTo === filterId)
            || (selectedFilterConfig?.Entity === FieldEntitiesType.User
              && item.Type === FilterType.UserMultiSelect && item.ID === selectedFilterConfig.ID)
          ) {
            newAppliedFilters[item.ID] = fetchFilter.GetDefaultSingleFilter(
              item,
              null,
            );
            state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.isUsersModified = true;
          }
          if (item.Type === FilterType.UserMultiSelect && item?.Metadata?.Status) {
            newAppliedFilters[item.ID] = {
              ...newAppliedFilters[item.ID],
              userStatus: item?.Metadata?.Status,
            };
          }
        });
      }
      state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.UserDropdownSelectType = userFilterType;

      state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.appliedFilters = newAppliedFilters;

      state.reportQueryBuilder.DynamicQueryList?.forEach((query) => {
        if (query.Id === state.reportQueryBuilder.SelectedQuery) {
          query.QueryDataInfo.updatedInfo.filterBuilder.appliedFilters = newAppliedFilters;
          query.QueryDataInfo.updatedInfo.filterBuilder.UserDropdownSelectType = userFilterType;
        }
      });
    },
    [ReportBuilderActions.SUB_QUERY_SEARCH_FILTER_DATA_LOAD_REQUEST]: (state: IReportBuilderState, action:PayloadAction<ISearchFilterPayloadRequest>) => {
      const { filterId, searchKey } = action.payload;
      const filter = state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.filterConfig.find(
        (config) => config.ID === filterId,
      );
      const newAppliedFilters = state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.appliedFilters;
      if (filter) {
        newAppliedFilters[filterId].OptionsMeta.SearchKey = searchKey;
        newAppliedFilters[filterId].OptionsMeta.Page.PageIndex = 0;
        newAppliedFilters[filterId].FilterOptions = [];
      }
      state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.appliedFilters = newAppliedFilters;
    },
    [ReportBuilderActions.SUB_QUERY_LOAD_MORE_FILTER_DATA_LOAD_REQUEST]: (state: IReportBuilderState, action:PayloadAction<ILoadMoreFilterPayloadRequest>) => {
      const { filterId } = action.payload;
      const filter = state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.filterConfig.find(
        (config) => config.ID === filterId,
      );
      const newAppliedFilters = state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.appliedFilters;

      if (filter) {
        newAppliedFilters[filterId].OptionsMeta.Page.PageIndex += 1;
      }
      state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.appliedFilters = newAppliedFilters;
    },
    [ReportBuilderActions.UPDATE_SUB_QUERY_FILTER_FORM]: (state:IReportBuilderState, action: PayloadAction<IFilterFormValues>) => {
      const {
        name, filterId, userStatus, ShowInMainReport, rangeFillValue,
      } = action.payload;
      const selectedQueryId = state.reportQueryBuilder.SelectedQuery;
      const newFilterConfig = state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.filterConfig;
      const newAppliedFilter = state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.appliedFilters;
      const statusChanged = newAppliedFilter?.[filterId]?.userStatus !== userStatus;
      const index = newFilterConfig.findIndex(
        (config) => config.ID === filterId,
      );
      newAppliedFilter[filterId] = {
        ...newAppliedFilter[filterId],
        label: name,
        ...(userStatus && newFilterConfig[index].Type === FilterType.UserMultiSelect ? { userStatus } : {}),
        ...(statusChanged && newFilterConfig[index].Type === FilterType.UserMultiSelect ? {
          FilterResponse: {
            ...newAppliedFilter[filterId]?.FilterResponse,
            Type: 'ALL',
            UserIds: [],
          },
        } : {}),
      };
      const updatedAppliedDimensions = cloneDeep(state.reportQueryBuilder.SelectedQueryData.updatedInfo?.AppliedDimensions) || [];

      const linkedDimensionIndex = updatedAppliedDimensions.findIndex((item) => item.Id === newFilterConfig[index]?.LinkedDimensionId);

      if (linkedDimensionIndex !== -1 && (rangeFillValue || rangeFillValue === 0)) {
        updatedAppliedDimensions[linkedDimensionIndex] = {
          ...updatedAppliedDimensions[linkedDimensionIndex],
          Props: {
            ...updatedAppliedDimensions[linkedDimensionIndex]?.Props,
            Dimension: {
              ...updatedAppliedDimensions[linkedDimensionIndex]?.Props?.Dimension,
              RangeFill: rangeFillValue,
            },
          },
        };
      }
      newFilterConfig[index].Label = name;
      newFilterConfig[index].Render = { ...newFilterConfig[index]?.Render, ShowInMainReport, LinkedQueryId: selectedQueryId };
      if (userStatus && newFilterConfig[index].Type === FilterType.UserMultiSelect) {
        newFilterConfig[index].Metadata.Status = userStatus;
      }
      state.reportQueryBuilder.SelectedQueryData.updatedInfo.AppliedDimensions = updatedAppliedDimensions;
      findAndUpdateAssociatedUserFilters(newFilterConfig, filterId, selectedQueryId, action?.payload?.ShowInMainReport);
      state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.filterConfig = newFilterConfig;
      state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.appliedFilters = newAppliedFilter;
    },
    [ReportBuilderActions.SUB_QUERY_SORT_COLUMN]: (state: IReportBuilderState, action: PayloadAction<ISortColumnPayload>) => {
      const { reportQueryBuilder } = state;
      const [sortState, hasChanged] = subQuerySortForMeasures(
        reportQueryBuilder.SelectedQueryData.updatedInfo.sortState,
        reportQueryBuilder.SelectedQueryData.updatedInfo.AppliedDimensions,
        reportQueryBuilder.SelectedQueryData.updatedInfo.AppliedMeasures,
        action.payload.columnType,
        action.payload.columnName,
        action.payload.order,
        action.payload.multiSort,
        action.payload.Id,
        isListReport(reportQueryBuilder.SelectedQueryData.Type),
      );
      if (!hasChanged) return;
      reportQueryBuilder.SelectedQueryData.updatedInfo.sortState = sortState;
    },
    [ReportBuilderActions.DELETE_SUB_QUERY]: (state: IReportBuilderState, action: PayloadAction<string>) => {
      deleteSubQueryFn(state, action.payload, true);
    },
    [ReportBuilderActions.UPDATE_SUB_QUERY_DATA_SOURCE_JOINS_ARRAY]: (state: IReportBuilderState, action: PayloadAction<IUpdateDataSourceJoinsPayload>) => {
      const {
        key, joins, joinBlockIndexBeingEdited, joinBlockConditionIndexBeingEdited,
      } = action.payload;
      state.reportQueryBuilder.DataSourceMapping = {
        ...state.reportQueryBuilder.DataSourceMapping,
        [key]: {
          ...state.reportQueryBuilder.DataSourceMapping[key], Joins: joins, JoinBlockIndexBeingEdited: joinBlockIndexBeingEdited, JoinBlockConditionIndexBeingEdited: joinBlockConditionIndexBeingEdited, isDataSourceSaved: false,
        },
      };
      const breadcrumbList = [...state.reportQueryBuilder.BreadcrumbData];
      const breadcrumbItemIndex = breadcrumbList.findIndex((breadcrumb) => breadcrumb.queryId === key && breadcrumb.type === SubQueryPanelType.dataSource);
      const label = getDataSourceNames(state.reportQueryBuilder.DataSourceMapping, key, state.dataSourceInfo.dataSources);
      if (label) {
        if (breadcrumbItemIndex !== -1) {
          const breadcrumbItem = breadcrumbList[breadcrumbItemIndex];
          breadcrumbItem.label = label;
          breadcrumbList[breadcrumbItemIndex] = breadcrumbItem;
        } else {
          const length = breadcrumbList.length;
          if (length > 1) {
            breadcrumbList[length - 1].isActive = state.reportQueryBuilder.DataSourceMapping[key]?.isEditMode;
          }
          breadcrumbList.push({
            label,
            isActive: false,
            queryId: key,
            type: SubQueryPanelType.dataSource,
          });
        }
      }
      state.reportQueryBuilder.BreadcrumbData = breadcrumbList;
    },
    [ReportBuilderActions.UPDATE_SUB_QUERY_DATA_SOURCE_NAMESPACE]: (state: IReportBuilderState, action: PayloadAction<IUpdateDataSourceNameSpacePayload>) => {
      const { key, namespace } = action.payload;
      state.reportQueryBuilder.DataSourceMapping = {
        ...state.reportQueryBuilder.DataSourceMapping,
        [key]: {
          ...state.reportQueryBuilder.DataSourceMapping[key],
          Joins: null,
          PrimaryNamespace: namespace,
          isDataSourceSaved: false,
        },
      };
      state.reportQueryBuilder.SelectedQueryData.NameSpace = namespace;
    },
    [ReportBuilderActions.SUBQUERY_ADD_OR_UPDATE_CUSTOM_EXPRESSION]: (state: IReportBuilderState, action: PayloadAction<ICustomExpression>) => {
      const customExp = action.payload;
      const uniqueId = customExp.uniqueId;
      const expressionType = action.payload.ExpressionType;
      const updatedAppliedMeasures = state.reportQueryBuilder.SelectedQueryData.updatedInfo.AppliedMeasures;
      let updatedAppliedDimensions = state.reportQueryBuilder.SelectedQueryData.updatedInfo.AppliedDimensions;
      const rowGroupingDimensions = state.reportQueryBuilder.SelectedQueryData.updatedInfo.AppliedDimensions.filter(
        (dim) => dim?.DimensionMode !== DimensionMode.ColumnGroup
      && dim?.Applied !== DimensionStatus.NotApplied,
      );
      const isReportListType = isListReport(state?.reportQueryBuilder?.SelectedQueryData?.Type);
      const destIndex = rowGroupingDimensions.length;

      let newExpression: IColumn| IDimension;
      let editMode = false;
      if (state?.reportQueryBuilder?.SelectedQueryData?.updatedInfo?.ExpressionStore && state?.reportQueryBuilder.SelectedQueryData.updatedInfo?.ExpressionStore[uniqueId]) {
        editMode = true;
      }
      switch (expressionType) {
        case ExpressionContext.Measure: {
          const editedCustIndex = updatedAppliedMeasures.findIndex((mes) => mes.BuilderConfig?.uniqueKey === uniqueId);
          newExpression = withDescription(
            buildCustomMeasure(customExp.displayName, customExp.Mode, customExp.jsonExpression, uniqueId, customExp?.Formatter, customExp.DataType, undefined, undefined, customExp?.description),
            customExp.description,
          );
          if (editMode) {
            if (customExp.Mode === ColumnModes.Sortable) {
              updatedAppliedMeasures[editedCustIndex] = newExpression as IColumn;
            }
          } else {
            updatedAppliedMeasures.push(newExpression as IColumn);
          }

          break;
        }
        case ExpressionContext.Dimension: {
          newExpression = withDescription(
            buildCustomDimension(customExp.displayName, customExp.Mode, customExp.jsonExpression, uniqueId, customExp.DataType, customExp?.dimensionType, customExp?.description),
            customExp.description,
          );
          if (editMode) {
            const editedCustIndex = updatedAppliedDimensions.findIndex((dim) => dim.BuilderConfig?.uniqueKey === uniqueId || dim.BuilderConfig?.SchemaName === uniqueId);
            if (editedCustIndex !== -1) {
              updatedAppliedDimensions[editedCustIndex] = withDescription({
                ...updatedAppliedDimensions[editedCustIndex],
                Expression: newExpression?.Expression,
                BuilderConfig: { ...newExpression?.BuilderConfig },
                Name: newExpression.Name,
              }, customExp.description);
              updatedAppliedDimensions = reorderAppliedDimensions(updatedAppliedDimensions);
            }
          } else {
            state.reportQueryBuilder.SelectedQueryData.updatedInfo.ExpressionStore[uniqueId] = customExp;
            updatedAppliedDimensions.splice(destIndex, 0, newExpression);
          }

          break;
        }
        case ExpressionContext.Custom: {
          const {
            Name, Id, BuilderConfig, Props,
          } = buildCustomDimension(customExp.displayName, customExp.Mode, customExp.jsonExpression, customExp.uniqueId, customExp.DataType, customExp?.dimensionType, customExp?.description);
          const updatedCustomColumn = {
            Name, Id, BuilderConfig, Props,
          } as IReportBuilderCustomColumns;

          updatedCustomColumn.Props = {
            ...updatedCustomColumn.Props,
            Dimension: {
              ...updatedCustomColumn.Props.Dimension,
              Applied: customExp.Mode === ColumnModes.NotApplied ? DimensionStatus.NotApplied : DimensionStatus.Applied,
            },
          };

          const dynamicQueryList = state.reportQueryBuilder.DynamicQueryList;
          const selectedQuery = dynamicQueryList.find((query) => query.Id === state.reportQueryBuilder.SelectedQuery);
          if (selectedQuery) {
            if (!selectedQuery.QueryPayload) {
              selectedQuery.QueryPayload = {} as IBuilder;
            }
            selectedQuery.QueryPayload.CustomColumns = [...(selectedQuery.QueryPayload?.CustomColumns ?? []), updatedCustomColumn];
          }

          /**
       * The below code is to handle the case where the custom column is added to the list report.
       * Since custom columns are editable in list reports and the have `ExpressionType` set to `Custom`, we explicitly need to handle the case where the custom column
       * is added to grouping in the list report mainly for name updates.
       */
          if (isReportListType) {
            if (editMode) {
              customExp.Formatter = null;
              newExpression = buildCustomDimension(customExp.displayName, customExp.Mode, customExp.jsonExpression, uniqueId, customExp.DataType, customExp?.dimensionType, customExp?.description);
              const editedCustIndex = updatedAppliedDimensions.findIndex((dim) => dim.BuilderConfig?.uniqueKey === uniqueId);
              if (editedCustIndex !== -1) {
                updatedAppliedDimensions[editedCustIndex] = {
                  ...updatedAppliedDimensions[editedCustIndex],
                  Expression: newExpression?.Expression,
                  BuilderConfig: { ...updatedAppliedDimensions[editedCustIndex]?.BuilderConfig, DisplayName: newExpression.Name },
                  Name: newExpression.Name,
                };
                updatedAppliedDimensions = reorderAppliedDimensions(updatedAppliedDimensions);
              }
            }
          }
          break;
        }
        default:
      }

      state.reportQueryBuilder.SelectedQueryData.updatedInfo.AppliedMeasures = updatedAppliedMeasures;
      state.reportQueryBuilder.SelectedQueryData.updatedInfo.AppliedDimensions = updatedAppliedDimensions;
      state.reportQueryBuilder.SelectedQueryData.updatedInfo.ExpressionStore[uniqueId] = customExp;
    },
    [ReportBuilderActions.SAVE_SUBQUERY]: (state: IReportBuilderState, action: PayloadAction<SaveSubQueryPayload>) => getStateOnSaveSubQuery(state, action.payload),
    [ReportBuilderActions.UPDATE_SELECTED_QUERY]: (state: IReportBuilderState, action: PayloadAction<IUpdateQueryPayload>) => {
      updateSelectedFn(state, action.payload);
    },
    [ReportBuilderActions.DELETE_SELECTED_QUERY]: (state: IReportBuilderState, action: PayloadAction<IVariables>) => {
      const { reportQueryBuilder, dataSourceInfo: { dataSources } } = state;
      const { BreadcrumbData } = reportQueryBuilder;
      const selectedQueryId = reportQueryBuilder.SelectedQuery;
      const selectedQueryData = reportQueryBuilder.SelectedQueryData;
      const queryToBeDelete = cloneDeep(selectedQueryId);
      const queryList = reportQueryBuilder.DynamicQueryList;
      const queryExtraData = queryList.find((query) => query.Id === selectedQueryId);
      const dataSourceMapping = reportQueryBuilder.DataSourceMapping;
      const parentQueryId = queryList.find((query) => query.Id === selectedQueryId)?.ParentQueryId;
      if (dataSourceMapping[selectedQueryId]?.isEditMode && dataSourceMapping[selectedQueryId]?.isDataSourceSaved) {
        resetDataSourceOfLinkedQueries(state, selectedQueryId);
      }
      if (parentQueryId !== ROOT_QUERY_KEY && dataSourceMapping[selectedQueryId]?.isEditMode) {
        const parentQueryExtraData = queryList.find((query) => query.Id === parentQueryId);
        if (!parentQueryExtraData.IsDraft) {
          reportQueryBuilder.SelectedQueryData = parentQueryExtraData.QueryDataInfo;
        } else {
          reportQueryBuilder.SelectedQueryData = initialReportBuilderState.reportQueryBuilder.SelectedQueryData;
        }
        dataSourceMapping[selectedQueryId].isEditMode = false;
      } else {
        reportQueryBuilder.SelectedQueryData = selectedQueryData;
      }
      reportQueryBuilder.SelectedQuery = parentQueryId;
      const breadcrumbs = [...BreadcrumbData];
      const updatedbreadcrumbs = breadcrumbs.filter((item) => !(item.queryId === queryToBeDelete && item.type === SubQueryPanelType.query));
      if (updatedbreadcrumbs?.length > 0) {
        updatedbreadcrumbs[updatedbreadcrumbs.length - 1].isActive = false;
      }
      reportQueryBuilder.BreadcrumbData = updatedbreadcrumbs;

      if (!queryExtraData?.IsDraft) {
        if (parentQueryId === ROOT_QUERY_KEY) {
          reportQueryBuilder.DynamicQueryList = reportQueryBuilder.StaticQueryList;
          reportQueryBuilder.DataSourceMapping = reportQueryBuilder.DataSourceMappingPayload;
        }
        return;
      }
      reportQueryBuilder.DataSourceMapping = dataSourceMapping;
      if (dataSourceMapping[queryToBeDelete]) {
        delete dataSourceMapping[queryToBeDelete];
      }
      const linkedQueryIds = queryExtraData.LinkedQueryIds;
      reportQueryBuilder.DynamicQueryList = queryList.filter(
        (query) => query.Id !== queryToBeDelete && !linkedQueryIds.includes(query.Id),
      );
      if (dataSources[queryToBeDelete]) {
        delete dataSources[queryToBeDelete];
      }
    },
    [ReportBuilderActions.RESET_SELECTED_QUERY]: (state: IReportBuilderState, action: PayloadAction<IVariables>) => {
      const variables = action.payload;
      const { reportQueryBuilder } = state;
      const selectedQueryId = reportQueryBuilder.SelectedQuery;
      const selectedQueryData = reportQueryBuilder.SelectedQueryData;
      const dataSourceMapping = reportQueryBuilder.DataSourceMapping;
      const queryList = reportQueryBuilder.DynamicQueryList;
      const queryData = queryList.find((query) => query.Id === selectedQueryId);
      const parentQueryId = queryData?.ParentQueryId;
      const parentQueryData = queryList.find((query) => query.Id === parentQueryId);
      if (parentQueryId !== ROOT_QUERY_KEY && dataSourceMapping[selectedQueryId]?.isEditMode) {
        reportQueryBuilder.SelectedQuery = parentQueryId;
        reportQueryBuilder.SelectedQueryData = cloneDeep(initialReportBuilderState.reportQueryBuilder.SelectedQueryData);
        reportQueryBuilder.SelectedQueryData.QueryJoinRelation = parentQueryData?.QueryJoinRelation;
      } else if (parentQueryId !== ROOT_QUERY_KEY
        && !dataSourceMapping[selectedQueryId]?.isEditMode
        && dataSourceMapping[parentQueryId]?.isEditMode) {
        resetSelectedQueryToParent(state, parentQueryId, parentQueryData?.QueryConfig, selectedQueryData, variables);
      } else {
        reportQueryBuilder.SelectedQuery = parentQueryId;
        reportQueryBuilder.SelectedQueryData = cloneDeep(initialReportBuilderState.reportQueryBuilder.SelectedQueryData);
        reportQueryBuilder.SelectedQueryData.NameSpace = '';
        reportQueryBuilder.SelectedQueryData.Type = parentQueryData?.Type;
        reportQueryBuilder.SelectedQueryData.QueryJoinRelation = parentQueryData?.QueryJoinRelation;
      }
      if (reportQueryBuilder.DataSourceMapping[selectedQueryId]) {
        reportQueryBuilder.DataSourceMapping[selectedQueryId].isEditMode = false;
      }
    },
    [ReportBuilderActions.DELETE_UNSAVED_DATA_SOURCE]: (state: IReportBuilderState) => {
      const { reportQueryBuilder } = state;
      const {
        SelectedQuery, DynamicQueryList, DataSourceMapping, BreadcrumbData, DataSourceMappingPayload,
      } = reportQueryBuilder;
      const currentQuery = DynamicQueryList.find((query) => query.Id === SelectedQuery);

      // When query is not saved (in creation flow) and user is currently in the query's data source page
      // User makes some changes to data source but does not save it
      // User navigates back to query config page
      if (currentQuery?.IsDraft && !DataSourceMapping[SelectedQuery]?.isDataSourceSaved) {
        if (!DataSourceMappingPayload || !DataSourceMappingPayload[SelectedQuery]) {
          delete DataSourceMapping[SelectedQuery];
          reportQueryBuilder.SelectedQueryData.NameSpace = '';
        } else {
          resetDataSourceOfLinkedQueries(state, SelectedQuery);
        }
      }

      // When query is in edit mode and user is currently in the query's data source page
      // User makes some changes to data source but does not save it
      // User navigates back to query config page
      if (DataSourceMapping[SelectedQuery]?.isEditMode && !DataSourceMapping[SelectedQuery]?.isDataSourceSaved) {
        resetDataSourceOfLinkedQueries(state, SelectedQuery);
      }
      const breadcrumbs = [...BreadcrumbData];
      const updatedBreadcrumbs = breadcrumbs.filter((item) => !(item.queryId === SelectedQuery && item.type === SubQueryPanelType.dataSource));
      if (updatedBreadcrumbs.length > 0) {
        updatedBreadcrumbs[updatedBreadcrumbs.length - 1].isActive = false;
      }
      reportQueryBuilder.BreadcrumbData = updatedBreadcrumbs;
    },
    [ReportBuilderActions.SET_QUERY_EDIT_MODE]: (state: IReportBuilderState, action: PayloadAction<{queryId: string, editMode: boolean}>) => {
      const { reportQueryBuilder } = state;
      const { DataSourceMapping } = reportQueryBuilder;
      if (DataSourceMapping[action.payload.queryId]) {
        DataSourceMapping[action.payload.queryId].isEditMode = action.payload.editMode;
      }
    },
    [ReportBuilderActions.GET_SUB_QUERY_PREVIEW_DATA]: (state: IReportBuilderState, action: PayloadAction<{ queryId?: string }>) => {
      state.requestProcessing[ReportBuilderActions.GET_SUB_QUERY_PREVIEW_DATA] = APIRequestStatus.Processing;
      state.reportQueryBuilder.PreviewData.previewQueryId = action.payload.queryId;
    },
    [ReportBuilderActions.SET_SUB_QUERY_PREVIEW_DATA_SUCCESS]: (state: IReportBuilderState, action: PayloadAction<{ res: IPanelDataResponse, queryId?: string }>) => {
      state.requestProcessing[ReportBuilderActions.GET_SUB_QUERY_PREVIEW_DATA] = APIRequestStatus.Success;
      state.reportQueryBuilder.PreviewData.data = action.payload.res;
      state.reportQueryBuilder.PreviewData.error = undefined;
      state.reportQueryBuilder.PreviewData.previewBackupInfo.previewInfo = state.reportQueryBuilder.SelectedQueryData.updatedInfo;
    },
    [ReportBuilderActions.SET_SUB_QUERY_PREVIEW_DATA_FAILURE]: (state: IReportBuilderState, action: PayloadAction<{ error: IPreviewDataError } | undefined>) => {
      state.requestProcessing[ReportBuilderActions.GET_SUB_QUERY_PREVIEW_DATA] = APIRequestStatus.Failure;
      state.reportQueryBuilder.PreviewData.error = action.payload?.error;
    },
    [ReportBuilderActions.SET_ACTIVE_SUBQUERY_PANEL]: (state: IReportBuilderState, action: PayloadAction<SubQueryPanelType>) => {
      state.assortedInfo.activeSubQueryPanel = action.payload;
      state.assortedInfo.isDataSourceSidetrayExpanded = false;
    },
    [ReportBuilderActions.UPDATE_DATA_SOURCE_BREADCRUMB]: (state: IReportBuilderState) => {
      const { reportQueryBuilder } = state;
      const { DataSourceMapping, SelectedQuery } = reportQueryBuilder;
      const breadcrumbList = [...state.reportQueryBuilder.BreadcrumbData];
      const label = getDataSourceNames(DataSourceMapping, SelectedQuery, state.dataSourceInfo.dataSources);
      if (label) {
        const length = breadcrumbList.length;
        if (length > 1) {
          breadcrumbList[length - 1].isActive = state.reportQueryBuilder.DataSourceMapping[SelectedQuery]?.isEditMode;
        }
        breadcrumbList.push({
          label,
          isActive: false,
          queryId: SelectedQuery,
          type: SubQueryPanelType.dataSource,
        });
      }
      state.reportQueryBuilder.BreadcrumbData = breadcrumbList;
    },
    [ReportBuilderActions.UPDATE_DRILLDOWN_MEASURES_SIDETRAY_STATE]: (state:IReportBuilderState, action: PayloadAction<boolean>) => {
      state.assortedInfo.isDrilldownMeasuresPanelExpanded = action.payload;
    },
    [ReportBuilderActions.UPDATE_DRILLDOWN_FIELDS_SIDETRAY_STATE]: (state:IReportBuilderState, action: PayloadAction<boolean>) => {
      state.assortedInfo.isDrilldownFieldsPanelExpanded = action.payload;
    },
    [ReportBuilderActions.SAVE_NESTED_JOINS_CONFIG]: (state:IReportBuilderState, action: PayloadAction<APIRequestStatus>) => {
      state.requestProcessing[ReportBuilderActions.SAVE_NESTED_JOINS_CONFIG] = action.payload;
    },
    [ReportBuilderActions.UPDATE_SUB_QUERY_PAGINATION_STATE]: (state: IReportBuilderState, action: PayloadAction<IPaging>) => {
      const { reportQueryBuilder } = state;
      const { SelectedQueryData } = reportQueryBuilder;
      const paging = action.payload;
      if (paging.PageSize === -1) {
        SelectedQueryData.updatedInfo.Paging = null;
      } else {
        SelectedQueryData.updatedInfo.Paging = action.payload;
      }
    },
    [ReportBuilderActions.RESET_QUERY_BUILDER_STATE]: (state: IReportBuilderState) => {
      const reportConfig = state.updatedReportBuilderInfo.selectedTemplate.ReportConfig;
      const subBuilders = reportConfig.SubBuilders;
      const joinsList = reportConfig.Builder[0].Joins;
      const shouldPopulateSubBuilderDetails = joinsList?.find((joinsConfig) => joinsConfig.IsCTE || reportConfig.Builder[0].Source === QuerySourceType.Query);
      if (subBuilders?.length > 0 && shouldPopulateSubBuilderDetails && state.reportEditInfo.isEditing) {
        populateSubQueryDetailsFromConfig(state, reportConfig);
      } else if (!state.assortedInfo.isReportDataSourceSaved) {
        state.reportQueryBuilder = cloneDeep(initialReportBuilderState.reportQueryBuilder);
      }
      state.reportQueryBuilder.DataSourceMapping = {
        ...state.reportQueryBuilder.DataSourceMapping,
        [ROOT_QUERY_KEY]: {
          Joins: reportConfig?.Builder[0]?.Joins,
          PrimaryNamespace: reportConfig?.Builder[0]?.Namespace,
          JoinBlockIndexBeingEdited: 0,
          isEditMode: false,
          isDataSourceSaved: false,
        },
      };
      state.reportQueryBuilder.DataSourceMappingPayload = cloneDeep(state.reportQueryBuilder.DataSourceMapping);
    },
    [ReportBuilderActions.UPDATE_PARENT_REPORT_DATA_SOURCE_SAVE_STATUS]: (state: IReportBuilderState, action: PayloadAction<boolean>) => {
      state.assortedInfo.isReportDataSourceSaved = action.payload;
    },
    [ReportBuilderActions.UPDATE_INDEX_OF_JOIN_BLOCK_BEING_EDITED_INDEX]: (state: IReportBuilderState, action: PayloadAction<number>) => {
      const { SelectedQuery, DataSourceMapping, BreadcrumbData } = state.reportQueryBuilder;
      if (state.reportQueryBuilder.DataSourceMapping[SelectedQuery || ROOT_QUERY_KEY]) {
        state.reportQueryBuilder.DataSourceMapping[SelectedQuery || ROOT_QUERY_KEY].JoinBlockIndexBeingEdited = action.payload;

        const label = getDataSourceNames(DataSourceMapping, SelectedQuery, state.dataSourceInfo.dataSources);
        const length = BreadcrumbData.length;
        const index = BreadcrumbData.findIndex((breadcrumbItem) => breadcrumbItem.queryId === SelectedQuery && breadcrumbItem.type === SubQueryPanelType.dataSource);
        const breadcrumbItem: IBreadcrumbItem = {
          label,
          isActive: false,
          queryId: SelectedQuery,
          type: SubQueryPanelType.dataSource,
        };
        if (length > 0 && index > -1) {
          BreadcrumbData[index] = breadcrumbItem;
        } else {
          BreadcrumbData.push(breadcrumbItem);
        }
      }
    },
    [ReportBuilderActions.UPDATE_HIERARCHY_CONFIG]: (state: IReportBuilderState, action: PayloadAction<IHierarchy>) => {
      if (state.updatedReportBuilderInfo?.reportBuilderSavePayload?.Builder?.length > 0) {
        state.updatedReportBuilderInfo.reportBuilderSavePayload.Builder = state.updatedReportBuilderInfo.reportBuilderSavePayload.Builder.map((builder) => ({
          ...builder,
          Hierarchy: {
            ...builder.Hierarchy,
            ...action.payload,
          },
        }));
      }
    },
    [ReportBuilderActions.UPDATE_USER_CONTEXT]: (state: IReportBuilderState, action: PayloadAction<UserContext | undefined>) => {
      const prevUserContext = state.updatedReportBuilderInfo.reportBuilderSavePayload.UserContext;
      state.updatedReportBuilderInfo.selectedTemplate.ReportConfig.UserContext = action.payload;
      state.updatedReportBuilderInfo.reportBuilderSavePayload.UserContext = action.payload;

      // When UserContext changes, reset UserMultiSelect and GroupMultiSelect filters and trigger re-fetch
      if (prevUserContext !== action.payload) {
        // Reset main report filters
        resetFilterBuilderInStoreDueToUserContextChange(state.filterBuilder);

        // Reset sub-query filters (SelectedQueryData)
        const selectedQueryFilterBuilder = state.reportQueryBuilder?.SelectedQueryData?.updatedInfo?.filterBuilder;
        if (selectedQueryFilterBuilder) {
          resetFilterBuilderInStoreDueToUserContextChange(selectedQueryFilterBuilder);
        }

        // Reset filters across all dynamic query list items
        if (isValidArrayAndNotEmpty(state.reportQueryBuilder?.DynamicQueryList)) {
          state.reportQueryBuilder.DynamicQueryList.forEach((query) => {
            const queryFilterBuilder = query.QueryDataInfo?.updatedInfo?.filterBuilder;
            if (queryFilterBuilder) {
              resetFilterBuilderInStoreDueToUserContextChange(queryFilterBuilder);
            }
            const queryPayloadFilter = query.QueryPayload?.Filter;
            if (queryPayloadFilter) {
              updateSalesGroupAndUserFiltersInPayloadDueToUserContextChange(queryPayloadFilter);
            }
          });
        }

        // Reset filters in reportBuilderSavePayload (Builder and SubBuilders)
        const savePayload = state.updatedReportBuilderInfo.reportBuilderSavePayload;
        if (isValidArrayAndNotEmpty(savePayload?.Builder)) {
          savePayload.Builder.forEach((builder) => {
            if (builder.Filter) {
              updateSalesGroupAndUserFiltersInPayloadDueToUserContextChange(builder.Filter);
            }
          });
        }
        if (isValidArrayAndNotEmpty(savePayload?.SubBuilders)) {
          savePayload.SubBuilders.forEach((subBuilder) => {
            if (subBuilder.Filter) {
              updateSalesGroupAndUserFiltersInPayloadDueToUserContextChange(subBuilder.Filter);
            }
          });
        }

        // Reset SubBuilderFiltersMetadata so stale per-query user filter metadata
        // doesn't carry over after a user context switch
        const savePayloadMeta = state.updatedReportBuilderInfo.reportBuilderSavePayload?.FiltersMetadata;
        if (savePayloadMeta) {
          savePayloadMeta.SubBuilderFiltersMetadata = [];
        }
        const selectedTemplateMeta = state.updatedReportBuilderInfo.selectedTemplate?.ReportConfig?.FiltersMetadata;
        if (selectedTemplateMeta) {
          selectedTemplateMeta.SubBuilderFiltersMetadata = [];
        }
        const renderConfigMeta = state.reportEditInfo?.renderReportConfig?.FiltersMetadata;
        if (renderConfigMeta) {
          renderConfigMeta.SubBuilderFiltersMetadata = [];
        }
      }
    },
    [ReportBuilderActions.SET_META_SELECTOR_OPTIONS]: (state:IReportBuilderState, action: PayloadAction<ISetMetaSelectorOptionsPayload>) => getStateOnSetEntityGroupingOptions(state, action.payload),
    [ReportBuilderActions.APPLY_ENTITY_GROUPING]: (state:IReportBuilderState, action: PayloadAction<ISetDimensionsEntityGroupingPayload>) => getStateOnApplyEntityGrouping(state, action.payload),
    [ReportBuilderActions.SET_ENTITY_GROUPING]: (state:IReportBuilderState, action: PayloadAction<ISetEntityGroupingPayload>) => getStateOnEntityGroupingChange(state, action.payload),
    [ReportBuilderActions.UPDATE_REPORT_TYPE_FOR_BUILDER]: (state: IReportBuilderState, action: PayloadAction<ReportType>) => {
      const reportType = action.payload;
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Builder[0].Type = reportType;
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Paging = {
        PageIndex: 1,
        PageSize: 10,
      };
    },
    [ReportBuilderActions.UPDATE_REPORT_TYPE_FOR_SUB_BUILDER]: (state: IReportBuilderState, action: PayloadAction<{ reportType: ReportType, queryId: string }>) => {
      const { reportType, queryId } = action.payload;
      const selectedQueryData = state.reportQueryBuilder.SelectedQueryData;
      selectedQueryData.Type = reportType;
      state.reportQueryBuilder.DynamicQueryList.forEach((query) => {
        if (query.Id === queryId) {
          query.Type = reportType;
        }
      });
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Paging = {
        PageIndex: 1,
        PageSize: 10,
      };
    },
    [ReportBuilderActions.UPDATE_LIST_REPORT_COLUMN_CONFIG_FOR_BUILDER]: (state: IReportBuilderState, action: PayloadAction<{
      index: number;
      newColumn: IColumn;
    }>) => {
      const { index, newColumn } = action.payload;
      const appliedDimensions = state.updatedReportBuilderInfo.appliedDimensions;
      const existingDimension = appliedDimensions[index];

      const newDimension = {
        ...existingDimension,
        Name: newColumn.Name,
        BuilderConfig: newColumn.BuilderConfig,
        Mode: newColumn.Props?.Mode ?? existingDimension.Mode,
        Props: newColumn.Props,
      };

      appliedDimensions[index] = { ...newDimension };

      let newReferredDimension: IDimension;

      if (existingDimension.ReferTo) {
        const referredDimensionIndex = appliedDimensions.findIndex(
          (dim) => dim.Id === existingDimension.ReferTo,
        );

        if (referredDimensionIndex !== -1) {
          const existingReferredDimension = appliedDimensions[referredDimensionIndex];
          const renamedReferredName = newColumn.Props?.ReferTo ? newColumn.Name : newColumn.BuilderConfig?.DisplayName || newColumn.Name;
          // only re-propagate the name when the field was actually renamed; a hide-only edit keeps the rendered
          // column's display name, so the selector's raw alias doesn't overwrite the friendly meta column name
          const referredName = newColumn.Name !== existingDimension.Name ? renamedReferredName : existingReferredDimension.Name;

          newReferredDimension = {
            ...existingReferredDimension,
            Name: referredName,
            // meta field hide: the referred column is the one actually rendered (the selector is always hidden via its
            // ReferTo), so mirror the edited selector's Mode onto it - both top-level (save reads dim.Mode) and Props.
            Mode: newColumn.Props?.Mode ?? existingReferredDimension.Mode,
            Props: { ...existingReferredDimension.Props, Mode: newColumn.Props?.Mode ?? existingReferredDimension.Props?.Mode },
          };

          appliedDimensions[referredDimensionIndex] = { ...newReferredDimension };
        }
      }

      if (state.updatedReportBuilderInfo.reportBuilderSavePayload.Columns) {
        state.updatedReportBuilderInfo.reportBuilderSavePayload.Columns = state.updatedReportBuilderInfo.reportBuilderSavePayload.Columns.map((column) => {
          if (column.Id === newColumn.Id) {
            return {
              ...column,
              BuilderConfig: {
                ...column.BuilderConfig,
                DisplayName: newColumn.Name,
              },
              Props: newColumn.Props,
            };
          }

          if (newReferredDimension && column.Id === newReferredDimension.Id) {
            return {
              ...column,
              Name: newReferredDimension.Name,
            };
          }

          return column;
        });
      }

      state.updatedReportBuilderInfo.sortState = state.updatedReportBuilderInfo.sortState?.map((sortItem) => {
        if (sortItem.Id === newColumn.Id) {
          return { ...sortItem, Field: newColumn.Name };
        }
        return sortItem;
      });
    },
    [ReportBuilderActions.UPDATE_LIST_REPORT_COLUMN_CONFIG_FOR_SUBBUILDER]: (state: IReportBuilderState, action: PayloadAction<{
      index: number;
      newColumn: IColumn;
    }>) => {
      const { index, newColumn } = action.payload;
      const appliedDimensions = state.reportQueryBuilder.SelectedQueryData.updatedInfo.AppliedDimensions;
      const selectedQueryId = state.reportQueryBuilder.SelectedQuery;
      const queryConfig = state.reportQueryBuilder.DynamicQueryList?.find((query) => query.Id === selectedQueryId)?.QueryConfig;
      const existingDimension = appliedDimensions[index];

      const newDimension = {
        ...existingDimension,
        Name: newColumn.Name,
        BuilderConfig: newColumn.BuilderConfig,
        // keep top-level Mode in sync with Props.Mode — the save payload (getSavePayloadDimensionColumns) reads dim.Mode
        Mode: newColumn.Props?.Mode ?? existingDimension.Mode,
        Props: newColumn.Props,
      };

      appliedDimensions[index] = { ...newDimension };

      let newReferredDimension: IDimension;

      if (existingDimension.ReferTo) {
        const referredDimensionIndex = appliedDimensions.findIndex(
          (dim) => dim.Id === existingDimension.ReferTo,
        );

        if (referredDimensionIndex !== -1) {
          const existingReferredDimension = appliedDimensions[referredDimensionIndex];
          const renamedReferredName = newColumn.Props?.ReferTo ? newColumn.Name : newColumn.BuilderConfig?.DisplayName || newColumn.Name;
          // only re propagate the name when the field was actually renamed
          const referredName = newColumn.Name !== existingDimension.Name ? renamedReferredName : existingReferredDimension.Name;

          newReferredDimension = {
            ...existingReferredDimension,
            Name: referredName,
            // meta field hide: the referred column is the one actually rendered.
            Mode: newColumn.Props?.Mode ?? existingReferredDimension.Mode,
            Props: { ...existingReferredDimension.Props, Mode: newColumn.Props?.Mode ?? existingReferredDimension.Props?.Mode },
          };

          appliedDimensions[referredDimensionIndex] = { ...newReferredDimension };
        }
      }

      if (queryConfig?.ReportConfig?.Columns) {
        queryConfig.ReportConfig.Columns = queryConfig?.ReportConfig?.Columns.map((column) => {
          if (column.Id === newColumn.Id) {
            return {
              ...column,
              BuilderConfig: {
                ...column.BuilderConfig,
                DisplayName: newColumn.Name,
              },
            };
          }

          if (newReferredDimension && column.Id === newReferredDimension.Id) {
            return {
              ...column,
              Name: newReferredDimension.Name,
            };
          }

          return column;
        });
      }

      state.reportQueryBuilder.SelectedQueryData.updatedInfo.sortState = state.reportQueryBuilder.SelectedQueryData.updatedInfo.sortState?.map((sortItem) => {
        if (sortItem.Id === newColumn.Id) {
          return { ...sortItem, Field: newColumn.Name };
        }
        return sortItem;
      });
    },
    [ReportBuilderActions.REPORT_BUILDER_TYPE_CHANGE_REQUEST]: (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.REPORT_BUILDER_TYPE_CHANGE_REQUEST] = APIRequestStatus.Processing;
    },
    [ReportBuilderActions.REPORT_BUILDER_TYPE_CHANGE_SUCCESS]: (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.REPORT_BUILDER_TYPE_CHANGE_REQUEST] = APIRequestStatus.Success;
    },
    [ReportBuilderActions.REPORT_BUILDER_TYPE_CHANGE_FAILURE]: (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.REPORT_BUILDER_TYPE_CHANGE_REQUEST] = APIRequestStatus.Failure;
    },
    [ReportBuilderActions.UPDATE_CUSTOM_HIERARCHIES]: (state:IReportBuilderState, action: PayloadAction<ICustomHierarchy[]>) => getStateOnUpdateCustomHierarchies(state, action.payload),
    [ReportBuilderActions.UPDATE_DIMENSION]: (state: IReportBuilderState, action: PayloadAction<ISetDimensionPayload>) => getStateOnUpdateDimension(state, action.payload),
    [ReportBuilderActions.ADD_OR_UPDATE_FORMATTING_RULE]: (state: IReportBuilderState, action: PayloadAction<IRule>) => {
      // add default conditional formatting object if it is not present in the save payload
      if (isEmpty(state.updatedReportBuilderInfo.reportBuilderSavePayload?.Visualization?.ConditionalFormatting)) {
        state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.ConditionalFormatting = { Enabled: true, Rules: [] };
      }
      const rule = action.payload;
      const existingRule = state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization?.ConditionalFormatting?.Rules?.find((r) => r.Id === rule.Id);
      // If the rule already exists, then update the rule else add the rule to the conditional formatting rules array.
      if (existingRule) {
        state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.ConditionalFormatting = {
          Enabled: state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization?.ConditionalFormatting.Enabled,
          Rules: state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization?.ConditionalFormatting.Rules.map((r) => (r.Id === rule.Id ? rule : r)),
        };
      } else {
        state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.ConditionalFormatting = {
          Enabled: state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization?.ConditionalFormatting.Enabled,
          Rules: [...(state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization?.ConditionalFormatting?.Rules ?? []), rule],
        };
      }
    },
    [ReportBuilderActions.DELETE_FORMATTING_RULE]: (state: IReportBuilderState, action: PayloadAction<string>) => {
      const ruleId = action.payload;
      if (isEmpty(state.updatedReportBuilderInfo.reportBuilderSavePayload?.Visualization?.ConditionalFormatting)) {
        return;
      }
      const filteredRules = (state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.ConditionalFormatting?.Rules ?? []).filter((r) => r.Id !== ruleId);
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.ConditionalFormatting = {
        Enabled: state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization?.ConditionalFormatting.Enabled,
        Rules: filteredRules,
      };
    },
    [ReportBuilderActions.REORDER_FORMATTING_RULES]: (state: IReportBuilderState, action: PayloadAction<IRule[]>) => {
      if (isEmpty(state.updatedReportBuilderInfo.reportBuilderSavePayload?.Visualization?.ConditionalFormatting)) {
        return;
      }
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.ConditionalFormatting = {
        Enabled: state.updatedReportBuilderInfo.conditionalFormatting.Enabled,
        Rules: [...action.payload],
      };
    },
    [ReportBuilderActions.CLEAR_FORMATTING_RULES]: (state: IReportBuilderState) => {
      if (isEmpty(state.updatedReportBuilderInfo.reportBuilderSavePayload?.Visualization?.ConditionalFormatting)) {
        return;
      }
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.ConditionalFormatting = {
        Enabled: true,
        Rules: [],
      };
    },
    [ReportBuilderActions.SET_FORMATTING_RULE_EDIT_MODE]: (state: IReportBuilderState, action: PayloadAction<boolean>) => {
      state.updatedReportBuilderInfo.isCurrentlyEditingOrAddingFormattingRule = action.payload;
    },
    [ReportBuilderActions.CLEAR_CUSTOM_FILTER_DEFINITIONS]: (state: IReportBuilderState) => {
      // Remove all constituent filter entries and custom filter UI entries from filterConfig
      state.filterBuilder.filterConfig = state.filterBuilder.filterConfig.filter(
        (f) => !f.IsCustomFilter && !f.AssociatedCustomFilterId,
      );

      // Remove applied filter entries for all custom filters
      state.filterBuilder.customFilterDefinitions.forEach((def) => {
        delete state.filterBuilder.appliedFilters[def.ID];
      });

      // Clear AssociatedCustomFilterId from SubBuilder QueryPayload FilterGroups
      (state.reportQueryBuilder.DynamicQueryList || []).forEach((query) => {
        const filterGroup = query?.QueryPayload?.Filter?.FilterGroup;
        if (!filterGroup) return;
        filterGroup.forEach((fg) => {
          if (fg.AssociatedCustomFilterId) {
            delete fg.AssociatedCustomFilterId;
          }
        });
      });

      // Clear AssociatedCustomFilterId from save payload and selected template
      const clearAssociation = (filter: IBuilderFilter) => {
        filter?.FilterGroup?.forEach((fg) => {
          if (fg.AssociatedCustomFilterId) {
            delete fg.AssociatedCustomFilterId;
          }
        });
        filter?.SubFilters?.forEach((sf) => clearAssociation(sf));
      };
      state.updatedReportBuilderInfo?.reportBuilderSavePayload
        ?.Builder?.forEach((b) => clearAssociation(b.Filter));
      state.updatedReportBuilderInfo?.selectedTemplate?.ReportConfig
        ?.Builder?.forEach((b) => clearAssociation(b.Filter));

      // Clear definitions
      state.filterBuilder.customFilterDefinitions = [];

      // Clear from save payload
      if (state.updatedReportBuilderInfo.reportBuilderSavePayload?.CustomFilterDefinitions) {
        state.updatedReportBuilderInfo.reportBuilderSavePayload.CustomFilterDefinitions = [];
      }
    },
    [ReportBuilderActions.SAVE_LINKED_INSIGHT]: (state: IReportBuilderState, action: PayloadAction<ISaveLinkedInsightPayload>) => {
      const { config, editIndex } = action.payload;
      if (editIndex >= 0) {
        state.updatedReportBuilderInfo.linkedReportsConfig[editIndex] = config;
      } else {
        state.updatedReportBuilderInfo.linkedReportsConfig.push(config);
      }
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.LinkedReportsConfig = [
        ...state.updatedReportBuilderInfo.linkedReportsConfig,
      ];
    },
    [ReportBuilderActions.DELETE_LINKED_INSIGHT]: (state: IReportBuilderState, action: PayloadAction<number>) => {
      state.updatedReportBuilderInfo.linkedReportsConfig.splice(action.payload, 1);
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.LinkedReportsConfig = [
        ...state.updatedReportBuilderInfo.linkedReportsConfig,
      ];
    },
  },

  extraReducers: (builder) => {
    builder.addCase(saveReportConfig.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.SAVE_REPORT_CONFIG] = APIRequestStatus.Processing;
    });

    builder.addCase(saveReportConfig.fulfilled, (state: IReportBuilderState) => {
      state.updatedReportBuilderInfo.reportBuilderSavePayload.Status = ReportBuilderStatus.PUBLISHED;
      state.assortedInfo.reportBuilderSaveStatus = ReportBuilderSaveStatus.CREATED;
      state.requestProcessing[ReportBuilderActions.SAVE_REPORT_CONFIG] = APIRequestStatus.Success;
    });

    builder.addCase(saveReportConfig.rejected, (state: IReportBuilderState, action: PayloadAction<any>) => {
      state.updatedReportBuilderInfo.reportBuilderSavePayload = resetFilterOnFailure(state.updatedReportBuilderInfo.reportBuilderSavePayload, state);
      if (action.payload?.status !== statusCodes.Forbidden) {
        state.requestProcessing[ReportBuilderActions.SAVE_REPORT_CONFIG] = APIRequestStatus.Failure;
      } else {
        state.requestProcessing[ReportBuilderActions.SAVE_REPORT_CONFIG] = APIRequestStatus.AboutToLoad;
      }
    });

    builder.addCase(getReportBuilderDynamicFilters.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_FILTERS] = APIRequestStatus.Processing;
    });

    builder.addCase(getReportBuilderDynamicFilters.fulfilled, (state: IReportBuilderState, action: PayloadAction<IFilterConfig[]>) => {
      state.reportBuilderInfo.additionalFilters = action.payload;
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_FILTERS] = APIRequestStatus.Success;
    });

    builder.addCase(getReportBuilderDynamicFilters.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_FILTERS] = APIRequestStatus.Failure;
    });

    builder.addCase(getDynamicDimensions.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_DIMENSIONS] = APIRequestStatus.Processing;
    });

    builder.addCase(getDynamicDimensions.fulfilled, (state: IReportBuilderState, action: PayloadAction<IColumn[]>) => {
      state.reportBuilderInfo.additionalDimensions = action.payload;
      state.updatedReportBuilderInfo.appliedDimensions = getAppliedDimensionsOnSuccess(
        state,
        action.payload,
      );
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_DIMENSIONS] = APIRequestStatus.Success;
    });

    builder.addCase(getDynamicDimensions.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_DIMENSIONS] = APIRequestStatus.Failure;
    });

    builder.addCase(getDynamicMeasures.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_MEASURES] = APIRequestStatus.Processing;
    });

    builder.addCase(getDynamicMeasures.fulfilled, (state: IReportBuilderState, action: PayloadAction<DynamicMeasureResponse[]>) => {
      state.reportBuilderInfo.additionalMeasures = [
        ...getMeasureColumns(state.updatedReportBuilderInfo.selectedTemplate.ReportConfig, false, true),
        ...action.payload?.map((res) => {
          const updatedMeasure = buildMeasureColumn(
            res.Id,
            res.DisplayName,
            res.Alias,
            res.DataType,
            'Sum',
            dynamicMeasureDefaultConfig,
            res?.Entity,
            res?.EntityName,
            res.SchemaName,
            res.JoinID,
            undefined,
            res.Namespace,
            undefined,
            res?.IsSourceCustomColumn,
            res?.NamespaceEntity,
            res?.NsDisplayName,
            res?.Description,
          );
          return updatedMeasure;
        }) || [],
      ];
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_MEASURES] = APIRequestStatus.Success;
    });

    builder.addCase(getDynamicMeasures.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_MEASURES] = APIRequestStatus.Failure;
    });

    builder.addCase(getFieldsRequest.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_FIELDS] = APIRequestStatus.Processing;
    });

    builder.addCase(getFieldsRequest.fulfilled, (state: IReportBuilderState, action: PayloadAction<IField[]>) => {
      state.reportBuilderInfo.fields = action.payload;
      state.requestProcessing[ReportBuilderActions.GET_FIELDS] = APIRequestStatus.Success;
    });

    builder.addCase(getFieldsRequest.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_FIELDS] = APIRequestStatus.Failure;
    });

    builder.addCase(getReportRawConfig.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_REPORT_RAW_CONFIG_REQUEST] = APIRequestStatus.Processing;
    });

    builder.addCase(getReportRawConfig.fulfilled, (state: IReportBuilderState, action: PayloadAction<SieraResponse<IReportConfig>>) => {
      state.updatedReportBuilderInfo.reportBuilderSavePayload = action.payload.data;
      state.reportEditInfo.rawReportConfig = { ...action.payload.data, Columns: action.payload?.data?.Columns?.filter((col:IColumn) => !(col?.Props?.Measure?.IsCustomExpression && col?.Props?.Mode === ColumnModes.NotApplied)) || [] };
      const customColumns = action.payload.data?.Builder?.[0]?.CustomColumns;
      if (isValidArrayAndNotEmpty(customColumns)) {
        // Process custom columns and update expressionStore
        const updatedExpressionStore = getExpressionStoreFromConfig(action.payload.data, state.updatedReportBuilderInfo.expressionStore);
        state.updatedReportBuilderInfo.expressionStore = updatedExpressionStore;
      }
      state.requestProcessing[ReportBuilderActions.GET_REPORT_RAW_CONFIG_REQUEST] = APIRequestStatus.Success;
    });

    builder.addCase(getReportRawConfig.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_REPORT_RAW_CONFIG_REQUEST] = APIRequestStatus.Failure;
    });

    builder.addCase(getReportRenderConfig.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_REPORT_RENDER_CONFIG_REQUEST] = APIRequestStatus.Processing;
    });

    builder.addCase(getReportRenderConfig.fulfilled, (state: IReportBuilderState, action: PayloadAction<SieraResponse<ReportResponseModel.IReportConfig>, string, ObjModel.Obj>) => {
      const reportConfig = { ...action.payload.data, Columns: action.payload?.data?.Columns?.filter((col:IColumn) => !(col?.Props?.Measure?.IsCustomExpression && col?.Props?.Mode === ColumnModes.NotApplied)) || [] };
      const variables = action.meta.arg.variables;
      const data = action.payload.data;
      const definitions = reportConfig.CustomFilterDefinitions;
      const processedFilters = definitions?.length
        ? buildCustomFiltersFromDefinitions(definitions, reportConfig.Filters)
        : reconstructCustomFilters(reportConfig.Filters);
      state.filterBuilder.customFilterDefinitions = definitions ?? [];
      state.filterBuilder.appliedFilters = getAppliedFilterFromTemplate(state, variables, processedFilters, reportConfig?.FiltersMetadata?.UserDropdownSelectType);
      state.filterBuilder.filterConfig = getUpdatedReportFilterConfig(processedFilters);
      state.reportEditInfo.renderReportConfig = reportConfig;
      state.requestProcessing[ReportBuilderActions.GET_REPORT_RENDER_CONFIG_REQUEST] = APIRequestStatus.Success;
      state.updatedReportBuilderInfo.drilldownConfigInfo.enableDrilldown = !!data?.Columns?.some((col) => (Object.prototype.hasOwnProperty.call(col?.Props, 'DrilldownEnabled') ? col?.Props?.DrilldownEnabled : false));
      if (isValidObjectAndNotEmpty(data?.Visualization?.DrilldownConfigIdMapping)) {
        state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping = data?.Visualization?.DrilldownConfigIdMapping || null;
      } else if (data?.Visualization?.DrillDownConfigMapping) {
        state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping = data?.Visualization?.DrillDownConfigMapping || null;
      }

      if (data?.Visualization?.DrillDownPagination) {
        state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownPagination = data?.Visualization?.DrillDownPagination;
      } else {
        state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownPagination = defaultPageValue;
      }
    });

    builder.addCase(getReportRenderConfig.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_REPORT_RENDER_CONFIG_REQUEST] = APIRequestStatus.Failure;
    });

    builder.addCase(getReportBuilderFiltersLoad.pending, (state: IReportBuilderState, action: PayloadAction<any, string, ObjModel.Obj>) => {
      const { filterId, isLazyLoad } = action.meta.arg;
      const filtersLoading = state.requestProcessing[ReportBuilderActions.FILTER_DATA_LOAD_REQUEST];
      if (isLazyLoad) {
        filtersLoading[filterId] = APIRequestStatus.LazyLoading;
        state.requestProcessing[
          ReportBuilderActions.FILTER_DATA_LOAD_REQUEST
        ] = filtersLoading;
      } else {
        filtersLoading[filterId] = APIRequestStatus.Processing;
        state.requestProcessing[
          ReportBuilderActions.FILTER_DATA_LOAD_REQUEST
        ] = filtersLoading;
      }
    });

    builder.addCase(getReportBuilderFiltersLoad.fulfilled, (state: IReportBuilderState, action: PayloadAction<IFilterResponse, string, ObjModel.Obj>) => {
      const filterResponse = action.payload;
      const filterId = action?.meta?.arg?.filterId;
      const isLazyLoad = action?.meta?.arg?.isLazyLoad;
      const newState = state;
      newState.filterBuilder = cloneDeep(state?.filterBuilder);
      if (isLazyLoad && state?.filterBuilder?.appliedFilters[filterId]) {
        filterResponse.FilterResponse = newState.filterBuilder.appliedFilters[filterId]?.FilterResponse;
      }
      const filtersLoading = state.requestProcessing[
        ReportBuilderActions.FILTER_DATA_LOAD_REQUEST
      ];
      const newAppliedFilters = state.filterBuilder.appliedFilters;
      filtersLoading[filterId] = APIRequestStatus.Success;
      let isUsersModifiedFlag = false;
      Object.values(filtersLoading).forEach((status) => {
        if (status === APIRequestStatus.Processing) isUsersModifiedFlag = true;
      });
      state.filterBuilder.isUsersModified = isUsersModifiedFlag;
      newAppliedFilters[filterId] = {
        ...filterResponse,
        label: newAppliedFilters[filterId]?.label,
        userStatus: newAppliedFilters[filterId]?.userStatus,
      };
      state.filterBuilder.appliedFilters = newAppliedFilters;
      state.requestProcessing[
        ReportBuilderActions.FILTER_DATA_LOAD_REQUEST
      ] = filtersLoading;
      const { Title, Description } = state.updatedReportBuilderInfo?.reportBuilderSavePayload?.Details;
      state.assortedInfo.isFormDisabled = getIsReportBuilderSaveFormDisable(Title, Description, state)
        || getIsFilterFormDisable(state.filterBuilder);
    });

    builder.addCase(getReportBuilderFiltersLoad.rejected, (state: IReportBuilderState, action: PayloadAction<any, string, ObjModel.Obj>) => {
      const filterId = action.meta.arg;
      const filtersLoading = state.requestProcessing[ReportBuilderActions.FILTER_DATA_LOAD_REQUEST];
      filtersLoading[filterId] = APIRequestStatus.Failure;
      state.requestProcessing[
        ReportBuilderActions.FILTER_DATA_LOAD_REQUEST
      ] = filtersLoading;
    });

    builder.addCase(getAdditionalDrilldownColumnsRequest.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_DRILLDOWN_COLUMN] = APIRequestStatus.Processing;
    });
    builder.addCase(getAdditionalDrilldownColumnsRequest.fulfilled, (state: IReportBuilderState, action: PayloadAction<IColumn[], string, any>) => {
      const groupId = action?.meta?.arg?.groupId;
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_DRILLDOWN_COLUMN] = APIRequestStatus.Success;
      const defaultCols = state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig[groupId]?.defaultColumns || [];
      const updatedAdditionalCols = isValidArrayAndNotEmpty(action.payload) ? action.payload.filter((col: IColumn) => col.Props.Mode !== ColumnModes.Hidden) : [];
      const updatedAddtFields = updatedAdditionalCols?.map((field: IColumn) => {
        const col = defaultCols?.find((item: IColumn) => getUniqIdentiferForDrilldownCols(item) === getUniqIdentiferForDrilldownCols(field));
        const isAppliedField = col ? DimensionStatus.Applied : DimensionStatus.NotApplied;
        return {
          ...field,
          Props: {
            ...field.Props,
            Dimension: {
              Applied: isAppliedField,
            },
          },
        };
      });

      const updatedDrilldownColumnConfig = {
        ...state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig,
        [groupId]: {
          ...state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig[groupId],
          additionalDrilldownColumns: updatedAddtFields,
          isAdditionalColumnFetched: true,
        },
      };
      state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig = updatedDrilldownColumnConfig;
    });
    builder.addCase(getAdditionalDrilldownColumnsRequest.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_DRILLDOWN_COLUMN] = APIRequestStatus.Failure;
    });

    builder.addCase(getAdditionalListReportColumnsRequest.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_LIST_REPORTS_ADDITIONAL_COLUMNS_FOR_BUILDER] = APIRequestStatus.Processing;
    });
    builder.addCase(getAdditionalListReportColumnsRequest.fulfilled, (state: IReportBuilderState, action: PayloadAction<any, string, ObjModel.Obj>) => {
      state.requestProcessing[ReportBuilderActions.GET_LIST_REPORTS_ADDITIONAL_COLUMNS_FOR_BUILDER] = APIRequestStatus.Success;
      state.reportBuilderInfo.additionalDimensions = action.payload;
      state.updatedReportBuilderInfo.appliedDimensions = getAppliedDimensionsOnSuccess(
        state,
        action.payload,
      );
    });
    builder.addCase(getAdditionalListReportColumnsRequest.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_LIST_REPORTS_ADDITIONAL_COLUMNS_FOR_BUILDER] = APIRequestStatus.Failure;
    });
    builder.addCase(getDefaultDrilldownColumnsRequest.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_DEFAULT_DRILLDOWN_COLUMN] = APIRequestStatus.Processing;
    });
    builder.addCase(getDefaultDrilldownColumnsRequest.fulfilled, (state: IReportBuilderState, action: PayloadAction<any, string, ObjModel.Obj>) => {
      state.requestProcessing[ReportBuilderActions.GET_DEFAULT_DRILLDOWN_COLUMN] = APIRequestStatus.Success;
      state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig = {
        ...state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig,
        ...getInitialDrilldownConfigInfo(action.payload, state?.updatedReportBuilderInfo?.drilldownConfigInfo),
      };
    });
    builder.addCase(getDefaultDrilldownColumnsRequest.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_DEFAULT_DRILLDOWN_COLUMN] = APIRequestStatus.Failure;
    });
    builder.addCase(getDrilldownConfig.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_DRILLDOWN_CONFIG] = APIRequestStatus.Processing;
    });
    builder.addCase(getDrilldownConfig.fulfilled, (state: IReportBuilderState, action: PayloadAction<any>) => {
      state.requestProcessing[ReportBuilderActions.GET_DRILLDOWN_CONFIG] = APIRequestStatus.Success;
      if (action.payload?.data?.message || isEmpty(action.payload)) {
        state.updatedReportBuilderInfo.appliedMeasures = state?.updatedReportBuilderInfo?.appliedMeasures?.map((measure) => {
          measure.Props.DrilldownEnabled = isDrilldownPossible(measure?.Props?.Measure?.Expression) && state?.updatedReportBuilderInfo?.drilldownConfigInfo?.enableDrilldown;
          return measure;
        });
      } else {
        const { configMapping, drilldownColumns } = getUpdatedFetchdrilldownColumnsRes(action.payload.data,
          state.updatedReportBuilderInfo.appliedMeasures, state.updatedReportBuilderInfo.drilldownConfigInfo, state.updatedReportBuilderInfo.selectedTemplate.ReportConfig.CalculatedColumns, state);

        state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping = configMapping;
        state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig = drilldownColumns;
      }
    });
    builder.addCase(getDrilldownConfig.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_DRILLDOWN_CONFIG] = APIRequestStatus.Failure;
    });
    builder.addCase(saveDrilldownColumnConfig.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.SAVE_DRILLDOWN_CONFIG] = APIRequestStatus.Processing;
    });
    builder.addCase(saveDrilldownColumnConfig.fulfilled, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.SAVE_DRILLDOWN_CONFIG] = APIRequestStatus.Success;
    });
    builder.addCase(saveDrilldownColumnConfig.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.SAVE_DRILLDOWN_CONFIG] = APIRequestStatus.Failure;
    });

    builder.addCase(getDataSourcesList.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_DATA_SOURCES_REQUEST] = APIRequestStatus.Processing;
    });
    builder.addCase(getDataSourcesList.fulfilled, (state: IReportBuilderState, action: PayloadAction<IDataSourceApiResponse[]>) => {
      state.requestProcessing[ReportBuilderActions.GET_DATA_SOURCES_REQUEST] = APIRequestStatus.Success;
      state.dataSourceInfo.dataSources = getUpdatedDataSourceResponse(state, action.payload);
    });
    builder.addCase(getDataSourcesList.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_DATA_SOURCES_REQUEST] = APIRequestStatus.Failure;
    });

    builder.addCase(getDataSourcesFieldList.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_DATA_SOURCES_FIELDS_REQUEST] = APIRequestStatus.Processing;
    });
    builder.addCase(getDataSourcesFieldList.fulfilled, (state: IReportBuilderState, action: PayloadAction<any, string, ObjModel.Obj>) => {
      state.requestProcessing[ReportBuilderActions.GET_DATA_SOURCES_FIELDS_REQUEST] = APIRequestStatus.Success;
      const { dataSourceId } = action.meta.arg;
      state.dataSourceInfo.dataSources = getUpdatedDataSourceFieldsResponse(state, action.payload, dataSourceId);
    });
    builder.addCase(getDataSourcesFieldList.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_DATA_SOURCES_FIELDS_REQUEST] = APIRequestStatus.Failure;
    });

    builder.addCase(getSubQueryFiltersLoad.pending, (state: IReportBuilderState, action: PayloadAction<any, string, ObjModel.Obj>) => {
      const { filterId, isLazyLoad } = action.meta.arg;
      const filtersLoading = state.requestProcessing[ReportBuilderActions.SUB_QUERY_FILTER_LOAD_DATA_REQUEST];
      if (isLazyLoad) {
        filtersLoading[filterId] = APIRequestStatus.LazyLoading;
        state.requestProcessing[
          ReportBuilderActions.SUB_QUERY_FILTER_LOAD_DATA_REQUEST
        ] = filtersLoading;
      } else {
        filtersLoading[filterId] = APIRequestStatus.Processing;
        state.requestProcessing[
          ReportBuilderActions.SUB_QUERY_FILTER_LOAD_DATA_REQUEST
        ] = filtersLoading;
      }
    });

    builder.addCase(getSubQueryFiltersLoad.fulfilled, (state: IReportBuilderState, action: PayloadAction<IFilterResponse, string, ObjModel.Obj>) => {
      const filterResponse = action.payload;
      const filterId = action?.meta?.arg?.filterId;
      const isLazyLoad = action?.meta?.arg?.isLazyLoad;
      const newState = state;
      if (isLazyLoad && state?.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder?.appliedFilters[filterId]) {
        filterResponse.FilterResponse = newState.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.appliedFilters[filterId]?.FilterResponse;
      }
      const filtersLoading = state.requestProcessing[
        ReportBuilderActions.SUB_QUERY_FILTER_LOAD_DATA_REQUEST
      ];
      const newAppliedFilters = state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.appliedFilters;
      filtersLoading[filterId] = APIRequestStatus.Success;
      let isUsersModifiedFlag = false;
      Object.values(filtersLoading).forEach((status) => {
        if (status === APIRequestStatus.Processing) isUsersModifiedFlag = true;
      });
      state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.isUsersModified = isUsersModifiedFlag;
      newAppliedFilters[filterId] = {
        ...filterResponse,
        label: newAppliedFilters[filterId]?.label,
        userStatus: newAppliedFilters[filterId]?.userStatus,
      };
      state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.appliedFilters = newAppliedFilters;
      state.requestProcessing[
        ReportBuilderActions.SUB_QUERY_FILTER_LOAD_DATA_REQUEST
      ] = filtersLoading;
    });

    builder.addCase(getSubQueryFiltersLoad.rejected, (state: IReportBuilderState, action: PayloadAction<any, string, ObjModel.Obj>) => {
      const filterId = action.meta.arg;
      const filtersLoading = state.requestProcessing[ReportBuilderActions.SUB_QUERY_FILTER_LOAD_DATA_REQUEST];
      filtersLoading[filterId] = APIRequestStatus.Failure;
      state.requestProcessing[
        ReportBuilderActions.SUB_QUERY_FILTER_LOAD_DATA_REQUEST
      ] = filtersLoading;
    });

    builder.addCase(getDynamicDimensionsForNamespaces.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_DIMENSIONS_FOR_NAMESPACES] = APIRequestStatus.Processing;
    });
    builder.addCase(getDynamicDimensionsForNamespaces.fulfilled, (state: IReportBuilderState, action: PayloadAction<Array<ReportResponseModel.IColumn>>) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_DIMENSIONS_FOR_NAMESPACES] = APIRequestStatus.Success;
      state.reportQueryBuilder.SelectedQueryData.additionalData.AdditionalDimensions = action.payload;
      state.reportQueryBuilder.SelectedQueryData.updatedInfo.AppliedDimensions = getAppliedDimensionsOnSuccess(
        state,
        action.payload,
        true,
      );
    });
    builder.addCase(getDynamicDimensionsForNamespaces.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_DIMENSIONS_FOR_NAMESPACES] = APIRequestStatus.Failure;
    });

    builder.addCase(getDynamicMeasuresForNamespaces.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_MEASURES_FOR_NAMESPACES] = APIRequestStatus.Processing;
    });
    builder.addCase(getDynamicMeasuresForNamespaces.fulfilled, (state: IReportBuilderState, action: PayloadAction<DynamicMeasureResponse[]>) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_MEASURES_FOR_NAMESPACES] = APIRequestStatus.Success;
      state.reportQueryBuilder.SelectedQueryData.additionalData.AdditionalMeasures = [
        ...getMeasureColumnsFromSubqueryBuilder(state.reportQueryBuilder.SelectedQueryData.updatedInfo),
        ...action.payload?.map((res) => {
          const measure = buildMeasureColumn(
            res.Id,
            res.DisplayName,
            res.Alias,
            res.DataType,
            'Sum',
            dynamicMeasureDefaultConfig,
            res?.Entity,
            res?.EntityName,
            res.SchemaName,
            res.JoinID,
            undefined,
            res.Namespace,
            res.QueryId,
            res.IsSourceCustomColumn,
            res?.NamespaceEntity,
            res?.NsDisplayName,
            res?.Description,
          );
          return measure;
        }) || [],
      ];
    });
    builder.addCase(getDynamicMeasuresForNamespaces.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_MEASURES_FOR_NAMESPACES] = APIRequestStatus.Failure;
    });

    builder.addCase(getFieldsRequestForNamespaces.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_FIELDS_FOR_NAMESPACES] = APIRequestStatus.Processing;
    });

    builder.addCase(getFieldsRequestForNamespaces.fulfilled, (state: IReportBuilderState, action: PayloadAction<IField[]>) => {
      state.reportQueryBuilder.SelectedQueryData.additionalData.Fields = action.payload;
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_FIELDS_FOR_NAMESPACES] = APIRequestStatus.Success;
    });

    builder.addCase(getFieldsRequestForNamespaces.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_FIELDS_FOR_NAMESPACES] = APIRequestStatus.Failure;
    });

    builder.addCase(getReportBuilderDynamicFiltersForNamespaces.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_FILTERS_FOR_NAMESPACES] = APIRequestStatus.Processing;
    });

    builder.addCase(getReportBuilderDynamicFiltersForNamespaces.fulfilled, (state: IReportBuilderState, action: PayloadAction<IFilterConfig[]>) => {
      state.reportQueryBuilder.SelectedQueryData.additionalData.AdditionalFilters = action.payload;
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_FILTERS_FOR_NAMESPACES] = APIRequestStatus.Success;
    });

    builder.addCase(getReportBuilderDynamicFiltersForNamespaces.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ADDITIONAL_FILTERS_FOR_NAMESPACES] = APIRequestStatus.Failure;
    });

    builder.addCase(getAdditionalListReportColumnsRequestForNamespaces.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_LIST_REPORTS_ADDITIONAL_COLUMNS_FOR_SUBBUILDER] = APIRequestStatus.Processing;
    });
    builder.addCase(getAdditionalListReportColumnsRequestForNamespaces.fulfilled, (state: IReportBuilderState, action: PayloadAction<any, string, ObjModel.Obj>) => {
      state.requestProcessing[ReportBuilderActions.GET_LIST_REPORTS_ADDITIONAL_COLUMNS_FOR_SUBBUILDER] = APIRequestStatus.Success;
      state.reportQueryBuilder.SelectedQueryData.additionalData.AdditionalDimensions = action.payload;
      state.reportQueryBuilder.SelectedQueryData.updatedInfo.AppliedDimensions = getAppliedDimensionsOnSuccess(
        state,
        action.payload,
        true,
      );
    });
    builder.addCase(getAdditionalListReportColumnsRequestForNamespaces.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_LIST_REPORTS_ADDITIONAL_COLUMNS_FOR_SUBBUILDER] = APIRequestStatus.Failure;
    });

    builder.addCase(getAllReportsForLinkedInsights.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ALL_REPORTS_FOR_LINKED_INSIGHTS] = APIRequestStatus.Processing;
    });
    builder.addCase(getAllReportsForLinkedInsights.fulfilled, (state: IReportBuilderState, action: PayloadAction<IReportData[]>) => {
      state.requestProcessing[ReportBuilderActions.GET_ALL_REPORTS_FOR_LINKED_INSIGHTS] = APIRequestStatus.Success;
      state.reportBuilderInfo.allReports = (action.payload || [])
        .filter((report) => report.SourceType === SourceTypes.SIERA)
        .map(({ Id, Name }) => ({ label: Name, value: Id }));
    });
    builder.addCase(getAllReportsForLinkedInsights.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.GET_ALL_REPORTS_FOR_LINKED_INSIGHTS] = APIRequestStatus.Failure;
      state.reportBuilderInfo.allReports = [];
    });

    builder.addCase(getReportConfigForLinkedInsights.pending, (state: IReportBuilderState, action: PayloadAction<any, string, ObjModel.Obj>) => {
      const reportId = action.meta.arg;
      state.requestProcessing[ReportBuilderActions.GET_REPORT_CONFIG_FOR_LINKED_INSIGHTS] = {
        ...state.requestProcessing[ReportBuilderActions.GET_REPORT_CONFIG_FOR_LINKED_INSIGHTS],
        [reportId]: APIRequestStatus.Processing,
      };
    });
    builder.addCase(getReportConfigForLinkedInsights.fulfilled, (state: IReportBuilderState, action: PayloadAction<SieraResponse<ReportResponseModel.IReportConfig>, string, ObjModel.Obj>) => {
      const reportId = action.meta.arg;
      state.requestProcessing[ReportBuilderActions.GET_REPORT_CONFIG_FOR_LINKED_INSIGHTS] = {
        ...state.requestProcessing[ReportBuilderActions.GET_REPORT_CONFIG_FOR_LINKED_INSIGHTS],
        [reportId]: APIRequestStatus.Success,
      };
      const reportData = action.payload?.data;
      state.reportBuilderInfo.reportConfigMapping = {
        ...state.reportBuilderInfo.reportConfigMapping,
        [reportId]: {
          Dimensions: (reportData?.Columns || []).filter(
            (col) => isDimension(col)
              && !isMeasure(col)
              && col.Props?.Dimension?.Applied !== DimensionStatus.NotApplied,
          ),
          Filters: reportData?.Filters || [],
          Details: reportData?.Details,
          CustomFilterDefinitions: reportData?.CustomFilterDefinitions || [],
        },
      };
    });
    builder.addCase(getReportConfigForLinkedInsights.rejected, (state: IReportBuilderState, action: PayloadAction<any, string, ObjModel.Obj>) => {
      const reportId = action.meta.arg;
      state.requestProcessing[ReportBuilderActions.GET_REPORT_CONFIG_FOR_LINKED_INSIGHTS] = {
        ...state.requestProcessing[ReportBuilderActions.GET_REPORT_CONFIG_FOR_LINKED_INSIGHTS],
        [reportId]: APIRequestStatus.Failure,
      };
    });

    builder.addCase(saveNestedJoinsConfig.pending, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.SAVE_NESTED_JOINS_CONFIG] = APIRequestStatus.Processing;
    });

    builder.addCase(saveNestedJoinsConfig.rejected, (state: IReportBuilderState) => {
      state.requestProcessing[ReportBuilderActions.SAVE_NESTED_JOINS_CONFIG] = APIRequestStatus.Failure;
    });

    builder.addCase(saveNestedJoinsConfig.fulfilled, (state: IReportBuilderState, action: PayloadAction<IRawTemplate, string, ObjModel.Obj>) => {
      const response = action.payload;
      const {
        SelectedQueryData, BreadcrumbData, DataSourceMapping, DataSourceMappingPayload, DynamicQueryList,
      } = state.reportQueryBuilder;
      const selectedQueryId = state.reportQueryBuilder.SelectedQuery;
      const variables = action.meta.arg?.variables;
      const breadcrumbs = [...BreadcrumbData];
      const updatedBreadcrumbs = breadcrumbs.filter((item) => !(item.queryId === selectedQueryId && item.type === SubQueryPanelType.dataSource));
      if (updatedBreadcrumbs.length > 0) {
        updatedBreadcrumbs[updatedBreadcrumbs.length - 1].isActive = false;
      }
      state.reportQueryBuilder.BreadcrumbData = updatedBreadcrumbs;
      state.reportQueryBuilder.DynamicQueryList.forEach((query: IQueryInfo) => {
        if (query.Id === selectedQueryId) query.QueryConfig = response;
      });
      DataSourceMapping[selectedQueryId].isDataSourceSaved = true;

      // Save the initial data source config to both DataSourceMapping and DataSourceMappingPayload,
      // so that data source can be reset to the original configuration when needed.
      if (!isValidObjectAndNotEmpty(DataSourceMappingPayload)) {
        state.reportQueryBuilder.DataSourceMappingPayload = {
          [selectedQueryId]: DataSourceMapping[selectedQueryId],
        };
      } else if (!DataSourceMappingPayload[selectedQueryId]) {
        state.reportQueryBuilder.DataSourceMappingPayload = {
          ...state.reportQueryBuilder.DataSourceMappingPayload,
          [selectedQueryId]: DataSourceMapping[selectedQueryId],
        };
      }
      prepareUICompatibleConfig(state, response, SelectedQueryData, variables, DataSourceMapping[selectedQueryId]?.PrimaryNamespace, DynamicQueryList);
      state.reportQueryBuilder.SelectedQueryData = SelectedQueryData;

      state.requestProcessing[ReportBuilderActions.SAVE_NESTED_JOINS_CONFIG] = APIRequestStatus.Success;
    });
  },
});

export const {
  [ReportBuilderActions.SEARCH_FILTER_DATA_LOAD_REQUEST]: reportBuilderSearchFilter,
  [ReportBuilderActions.LOAD_MORE_FILTER_DATA_LOAD_REQUEST]: reportBuilderLoadMoreFilters,
  [ReportBuilderActions.ADD_DYNAMIC_FILTER]: reportBuilderAddDynamicFilter,
  [ReportBuilderActions.ADD_CUSTOM_FILTER]: reportBuilderAddCustomFilter,
  [ReportBuilderActions.UPDATE_CUSTOM_FILTER]: reportBuilderUpdateCustomFilter,
  [ReportBuilderActions.DELETE_CUSTOM_FILTER]: reportBuilderDeleteCustomFilter,
  [ReportBuilderActions.SWITCH_USER_FIELD_AND_FILTER]: reportBuilderSwitchUserFieldFilter,
  [ReportBuilderActions.DELETE_DYNAMIC_FILTER]: reportBuilderDeleteDynamicFilter,
  [ReportBuilderActions.HANDLE_MAIN_REPORT_FILTER_VALUE_CHANGE]: reportBuilderFilterValueChange,
  [ReportBuilderActions.HANDLE_MAIN_REPORT_QUERY_FILTER_VALUE_CHANGE]: reportBuilderQueryFilterValueChange,
  [ReportBuilderActions.UPDATE_FILTER_FORM]: reportBuilderUpdateFilterForm,
  [ReportBuilderActions.UPDATED_SELECTED_TEMPLATE]: reportBuilderUpdateSelectedTemplate,
  [ReportBuilderActions.UPDATE_SELECTED_TAB]: reportBuilderUpdateSelectedTab,
  [ReportBuilderActions.UPDATE_REPORT_TEMPLATE_DETAIL]: reportBuilderUpdateReportTemplateDetail,
  [ReportBuilderActions.UPDATE_VISUALIZATION]: reportBuilderUpdateVisualization,
  [ReportBuilderActions.UPDATE_PAGINATION]: reportBuilderUpdatePagination,
  [ReportBuilderActions.RESET_REPORT_TEMPLATE]: reportBuilderResetTemplate,
  [ReportBuilderActions.SET_DIMENSIONS_GROUPING]: reportBuilderDimensionGrouping,
  [ReportBuilderActions.SET_DIMENSIONS_BINNING]: reportBuilderDimensionBinning,
  [ReportBuilderActions.ADD_MEASURE]: reportBuilderAddMeasure,
  [ReportBuilderActions.REM_MEASURE]: reportBuilderRemoveMeasure,
  [ReportBuilderActions.SET_MEASURE]: reportBuilderSetMeasure,
  [ReportBuilderActions.MOV_MEASURE]: reportBuilderMoveMeasure,
  [ReportBuilderActions.UPDATE_SAVE_REPORT_BUILDER_STATUS]: reportBuilderSetSaveStatus,
  [ReportBuilderActions.SORT_COLUMN]: reportBuilderSortColumn,
  [ReportBuilderActions.DELETE_CUSTOM_EXPRESSION]: reportBuilderDeleteExpression,
  [ReportBuilderActions.SUBQUERY_DELETE_CUSTOM_EXPRESSION]: subQueryDeleteCustomExpression,
  [ReportBuilderActions.ADD_OR_UPDATE_CUSTOM_EXPRESSION]: reportBuilderAddUpdateCustomMeasure,
  [ReportBuilderActions.COMBINE_RAW_AND_RENDER_CONFIG]: reportBuilderCombineConfigs,
  [ReportBuilderActions.SET_REPORT_EDIT_ID]: reportBuilderSetReportId,
  [ReportBuilderActions.SET_TEMPORARY_REPORT_ID]: reportBuilderSetTempId,
  [ReportBuilderActions.GET_PREVIEW_DATA]: reportBuilderPreviewLoadState,
  [ReportBuilderActions.SET_PREVIEW_DATA_SUCCESS_STATE]: reportBuilderPreviewSuccessState,
  [ReportBuilderActions.SET_PREVIEW_DATA_FAILURE_STATE]: reportBuilderPreviewFailureState,
  [ReportBuilderActions.SET_INITIAL_SUCCESS_STATE]: reportBuilderInitialSuccessState,
  [ReportBuilderActions.SET_INITIAL_FAILURE_STATE]: reportBuilderInitialFailureState,
  [ReportBuilderActions.INITIAL_SAVE_TEMPLATE]: reportBuilderInitialLoadState,
  [ReportBuilderActions.ADD_DRILLDOWN_CONFIGURATION]: addDrilldownConfiguration,
  [ReportBuilderActions.ADD_DRILLDOWN_MEASURE]: addDrilldownMeasure,
  [ReportBuilderActions.REMOVE_DRILLDOWN_ACCORD]: removeAccord,
  [ReportBuilderActions.REMOVE_DRILLDOWN_MEASURE]: removeDrilldownMeasure,
  [ReportBuilderActions.INIT_DRILLDOWN_MAPPING]: initDrilldownMapping,
  [ReportBuilderActions.SORT_DRILLDOWN_COLUMN]: drilldownSortColumn,
  [ReportBuilderActions.ADD_REMOVE_DRILLDOWN_FIELD]: addRemoveDrilldownField,
  [ReportBuilderActions.UPDATE_DRILLDOWN_COLUMN]: updateDrilldownColumn,
  [ReportBuilderActions.MOVE_DRILLDOWN_COLUMN]: moveDrilldownColumn,
  [ReportBuilderActions.TOGGLE_DRILLDOWN]: toggleDrilldown,
  [ReportBuilderActions.UPDATE_DRILLDOWN_PAGINATION]: updateDrildownPagination,
  [ReportBuilderActions.GET_RAW_TEMPLATE_DETAILS]: getRawTemplateDetailsRequest,
  [ReportBuilderActions.GET_RAW_TEMPLATE_DETAILS_SUCCESS]: getRawTemplateDetailsSuccess,
  [ReportBuilderActions.GET_RAW_TEMPLATE_DETAILS_FAILURE]: getRawTemplateDetailsFailure,
  [ReportBuilderActions.RESET_GET_RAW_TEMPLATE_DETAILS]: resetGetRawTemplateDetails,
  [ReportBuilderActions.UPDATE_DATA_SOURCE_CHANGES]: updateDataSourceChanges,
  [ReportBuilderActions.TOGGLE_DATA_SOURCE_EDIT_MODE]: toggleDataSourceEditMode,
  [ReportBuilderActions.SAVE_DATA_SOURCE_CHANGES_REQUEST_RESET]: saveDataSourceChangesRequestReset,
  [ReportBuilderActions.SAVE_DATA_SOURCE_CHANGES_REQUEST]: saveDataSourceChangesRequest,
  [ReportBuilderActions.SAVE_DATA_SOURCE_CHANGES_SUCCESS]: saveDataSourceChangesSuccess,
  [ReportBuilderActions.SAVE_DATA_SOURCE_CHANGES_FAILURE]: saveDataSourceChangesFailure,
  [ReportBuilderActions.UPDATE_REPORT_METADATA_POST_JOINS_SAVE]: updateReportMetadataPostJoinsSave,
  [ReportBuilderActions.UPDATE_DATA_SOURCE_SIDETRAY_STATE]: updateDataSourceSidetrayState,
  [ReportBuilderActions.CREATE_NEW_QUERY]: createNewQueryRequest,
  [ReportBuilderActions.TOGGLE_NESTED_QUERY_BUILDER_MODE]: toggleNestedQueryBuilder,
  [ReportBuilderActions.ADD_GROUPING_FOR_SUB_QUERY]: addGroupingForSubQuery,
  [ReportBuilderActions.ADD_MEASURE_FOR_SUB_QUERY]: addMeasureForSubQuery,
  [ReportBuilderActions.REMOVE_MEASURE_FOR_SUB_QUERY]: removeMeasureForSubQuery,
  [ReportBuilderActions.MOVE_MEASURE_FOR_SUB_QUERY]: moveMeasureForSubQuery,
  [ReportBuilderActions.SET_MEASURE_FOR_SUB_QUERY]: updateMeasureForSubQuery,
  [ReportBuilderActions.UPDATE_DIMENSION_FOR_SUB_QUERY]: subQueryUpdateDimension,
  [ReportBuilderActions.ADD_DYNAMIC_FILTER_IN_SUB_QUERY]: reportBuilderAddDynamicFilterInSubQuery,
  [ReportBuilderActions.DELETE_DYNAMIC_FILTER_IN_SUB_QUERY]: reportBuilderDeleteDynamicFilterInSubQuery,
  [ReportBuilderActions.SUB_QUERY_FILTER_VALUE_CHANGE]: reportBuilderSubQueryFilterValueChange,
  [ReportBuilderActions.SUB_QUERY_SEARCH_FILTER_DATA_LOAD_REQUEST]: subQuerySearchFilterData,
  [ReportBuilderActions.SUB_QUERY_LOAD_MORE_FILTER_DATA_LOAD_REQUEST]: subQueryLoadMoreFilterData,
  [ReportBuilderActions.UPDATE_SUB_QUERY_FILTER_FORM]: subQueryFilterFormUpdate,
  [ReportBuilderActions.SUB_QUERY_SORT_COLUMN]: subQuerySort,
  [ReportBuilderActions.DELETE_SUB_QUERY]: deleteSubQuery,
  [ReportBuilderActions.UPDATE_SUB_QUERY_DATA_SOURCE_JOINS_ARRAY]: subQueryUpdateJoins,
  [ReportBuilderActions.UPDATE_SUB_QUERY_DATA_SOURCE_NAMESPACE]: subQueryUpdateNamespace,
  [ReportBuilderActions.SUBQUERY_ADD_OR_UPDATE_CUSTOM_EXPRESSION]: subQueryAddUpdateCustomMeasure,
  [ReportBuilderActions.SAVE_SUBQUERY]: saveSubQuery,
  [ReportBuilderActions.UPDATE_SELECTED_QUERY]: updateSelectedQuery,
  [ReportBuilderActions.DELETE_SELECTED_QUERY]: cancelSelectedQuery,
  [ReportBuilderActions.DELETE_UNSAVED_DATA_SOURCE]: deleteUnsavedDataSource,
  [ReportBuilderActions.RESET_SELECTED_QUERY]: resetSelectedQuery,
  [ReportBuilderActions.GET_SUB_QUERY_PREVIEW_DATA]: queryBuilderPreviewDataloadStatus,
  [ReportBuilderActions.SET_SUB_QUERY_PREVIEW_DATA_SUCCESS]: queryBuilderPreviewSuccessState,
  [ReportBuilderActions.SET_SUB_QUERY_PREVIEW_DATA_FAILURE]: queryBuilderPreviewFailureState,
  [ReportBuilderActions.SET_QUERY_EDIT_MODE]: setQueryEditMode,
  [ReportBuilderActions.SET_ACTIVE_SUBQUERY_PANEL]: setActiveSubqueryPanel,
  [ReportBuilderActions.UPDATE_DATA_SOURCE_BREADCRUMB]: updateDataSourceBreadcrumb,
  [ReportBuilderActions.UPDATE_DRILLDOWN_MEASURES_SIDETRAY_STATE]: updateDrilldownMeasuresSidetrayState,
  [ReportBuilderActions.UPDATE_DRILLDOWN_FIELDS_SIDETRAY_STATE]: updateDrilldownFieldsSidetrayState,
  [ReportBuilderActions.SAVE_NESTED_JOINS_CONFIG]: updateSaveNestedJoinsConfigRequestStatus,
  [ReportBuilderActions.UPDATE_SUB_QUERY_PAGINATION_STATE]: updateSubQueryPaginationState,
  [ReportBuilderActions.RESET_QUERY_BUILDER_STATE]: resetQueryBuilder,
  [ReportBuilderActions.UPDATE_PARENT_REPORT_DATA_SOURCE_SAVE_STATUS]: updateParentReportDsSaveStatus,
  [ReportBuilderActions.SET_DIMENSIONS_BINNING_FOR_QUERY]: subQueryDimensionBinning,
  [ReportBuilderActions.UPDATE_INDEX_OF_JOIN_BLOCK_BEING_EDITED_INDEX]: updateIndexOfJoinBlockBeingEdited,
  [ReportBuilderActions.UPDATE_HIERARCHY_CONFIG]: updateHierarchyConfig,
  [ReportBuilderActions.UPDATE_USER_CONTEXT]: updateUserContext,
  [ReportBuilderActions.SET_META_SELECTOR_OPTIONS]: reportBuilderSetMetaSelectorOptions,
  [ReportBuilderActions.APPLY_ENTITY_GROUPING]: reportBuilderApplyEntityGrouping,
  [ReportBuilderActions.SET_ENTITY_GROUPING]: reportBuilderDimensionEntityGrouping, [ReportBuilderActions.UPDATE_REPORT_TYPE_FOR_BUILDER]: updateReportTypeForBuilder,
  [ReportBuilderActions.UPDATE_REPORT_TYPE_FOR_SUB_BUILDER]: updateReportTypeForSubBuilder,
  [ReportBuilderActions.UPDATE_LIST_REPORT_COLUMN_CONFIG_FOR_BUILDER]: updateListReportColumnConfigForBuilder,
  [ReportBuilderActions.UPDATE_LIST_REPORT_COLUMN_CONFIG_FOR_SUBBUILDER]: updateListReportColumnConfigForSubBuilder,
  [ReportBuilderActions.REPORT_BUILDER_TYPE_CHANGE_REQUEST]: reportBuilderTypeChangeRequest,
  [ReportBuilderActions.REPORT_BUILDER_TYPE_CHANGE_SUCCESS]: reportBuilderTypeChangeSuccess,
  [ReportBuilderActions.REPORT_BUILDER_TYPE_CHANGE_FAILURE]: reportBuilderTypeChangeFailure,
  [ReportBuilderActions.SUB_QUERY_SWITCH_USER_FIELD_AND_FILTER]: reportBuilderSwitchUserFieldFilterInSubQueryBuilder,
  [ReportBuilderActions.UPDATE_DIMENSION]: reportBuilderUpdateDimension,
  [ReportBuilderActions.UPDATE_CUSTOM_HIERARCHIES]: updateCustomHierarchies,
  [ReportBuilderActions.ADD_OR_UPDATE_FORMATTING_RULE]: addOrUpdateFormattingRule,
  [ReportBuilderActions.DELETE_FORMATTING_RULE]: deleteFormattingRule,
  [ReportBuilderActions.REORDER_FORMATTING_RULES]: reorderFormattingRules,
  [ReportBuilderActions.CLEAR_FORMATTING_RULES]: clearFormattingRules,
  [ReportBuilderActions.SET_FORMATTING_RULE_EDIT_MODE]: setFormattingRuleEditMode,
  [ReportBuilderActions.CLEAR_CUSTOM_FILTER_DEFINITIONS]: clearCustomFilterDefinitions,
  [ReportBuilderActions.SAVE_LINKED_INSIGHT]: saveLinkedInsight,
  [ReportBuilderActions.DELETE_LINKED_INSIGHT]: deleteLinkedInsight,
  [ReportBuilderActions.INITIALIZE_COMBO_CONFIG]: initializeComboConfig,
  [ReportBuilderActions.UPDATE_COMBO_MEASURE_CONFIG]: updateComboMeasureConfig,
  [ReportBuilderActions.ADD_COMBO_YAXIS_COLUMN]: addComboYAxisColumn,
  [ReportBuilderActions.REMOVE_COMBO_YAXIS_COLUMN]: removeComboYAxisColumn,
  [ReportBuilderActions.ADD_COMBO_XAXIS_COLUMN]: addComboXAxisColumn,
  [ReportBuilderActions.REMOVE_COMBO_XAXIS_COLUMN]: removeComboXAxisColumn,
  [ReportBuilderActions.CLEAR_COMBO_CONFIG]: clearComboConfig,
} = reportBuilderSlice.actions;

export default reportBuilderSlice;
